import { ROOM_INFO_TRANSLATIONS } from './roomsInfo';

const NOR = {
  'messenger_v2.call.share_screen': "Del skjerm",
  'messenger_v2.call.ongoing': "Gruppesamtale pågår",
  'messenger_v2.call.ongoing_video': "Videosamtale pågår",
  'messenger_v2.call.ongoing_voice': "Talesamtale pågår",
  'messenger_v2.call.more_members': "{count} flere deltakere",
  'messenger_v2.call.mute_sound': "Slå av lyd",
  'messenger_v2.call.unmute_sound': "Slå på lyd",
  'messenger_v2.call.sound_off': "Lyd av",
  'messenger_v2.call.live_members': "{count} i samtalen nå",
  'messenger_v2.call.waiting_members': "Venter på deltakere",
  'messenger_v2.call.joining': "Kobler til…",
  'messenger_v2.call.return_to_call': "Tilbake til samtalen",
  'messenger_v2.call.rejoin_failed': "Kan ikke bli med i samtalen. Prøv igjen.",
  'messenger_v2.call.stop_sharing': "Stopp deling",
  'messenger_v2.call.share_pending': "Oppdaterer skjermdeling",
  'messenger_v2.call.share_unsupported': "Denne nettleseren kan ikke dele skjermen. Du kan fortsatt se delte skjermer.",
  'messenger_v2.call.share_denied': "Skjermdeling ble avbrutt eller tillatelsen ble avslått. Samtalen er fortsatt tilkoblet.",
  'messenger_v2.call.share_failed': "Skjermdeling kunne ikke startes eller stoppes riktig. Prøv igjen.",
  'messenger_v2.call.view_screen': "Vis skjermen til {name}",
  'messenger_v2.call.expand_screen': "Utvid delt skjerm",
  'messenger_v2.call.exit_expand_screen': "Avslutt utvidet skjerm",
  'messenger_v2.pin.pin': 'Fest chat',
  'messenger_v2.pin.unpin': 'Løsne chat',
  'messenger_v2.pin.pinned': 'Festet chat',
  'messenger_v2.pin.failed': 'Kunne ikke oppdatere festet chat. Prøv igjen.',
  'messenger_v2.self.name': '{name} (Deg)',
  'messenger_v2.self.subtitle': 'Send melding til deg selv',
  ...ROOM_INFO_TRANSLATIONS.NOR,
  'tabs.more': 'Flere',
  'header.footer.short.find_grave': 'Finn grav',
  'header.footer.short.how': 'Hvordan',
  'header.footer.short.about': 'Om',
  'notifications.general.title': 'Varsel',
  'notifications.auth.title': 'Autentisering',
  'notifications.requests.title': 'Forespørsler',
  'notifications.gravesHub.title': 'Gravoversikt',
  'notifications.graves.title': 'Graver',
  'notifications.memoryWall.title': 'Minnevegg',
  'notifications.payments.title': 'Betalinger',
  'notifications.settings.title': 'Innstillinger',
  'notifications.groups.title': 'Rom',
  'notifications.sparks.title': 'Sparks',
  'notifications.store.title': 'Butikk',
  'notifications.purchase.title': 'Kjøp',
  'notifications.userProfile.title': 'Mitt lys',
  'notifications.messaging.title': 'Meldinger',
  'messenger.header.unseen_messages': 'Meldinger, {count} nye',
  'notifications.messages.title': 'Meldinger',
  'notifications.connectRequests.title': 'Tilkoblingsforespørsler',
  'notifications.designSystem.title': 'Designsystem',
  'notifications.subscription.title': 'Abonnement',
  'notifications.comments.title': 'Kommentarer',
  'notifications.familyTree.title': 'Familietre',
  notifications_page_title: 'Varsler',
  notifications_see_all: 'Se alle',
  worthy_calendar_precision_year: 'År',
  worthy_calendar_precision_month: 'Måned',
  worthy_calendar_precision_date: 'Dag',
  worthy_calendar_precision_heading: 'Velg dato',
  worthy_calendar_unset: 'Ingen dato valgt',
  worthy_calendar_unset_time: 'Ingen tid valgt',
  worthy_calendar_selection_value: '{iso} ({precision})',
  worthy_calendar_select_month: 'Velg måned',
  worthy_calendar_select_year: 'Velg år',
  worthy_calendar_select_day: 'Velg dag',
  worthy_calendar_previous: 'Forrige',
  worthy_calendar_next: 'Neste',
  worthy_calendar_selected_label: 'Valgt:',
  worthy_calendar_valid_years: 'Gyldige år: {min}–{max}',
  worthy_calendar_choose_date: 'Velg dag',
  worthy_calendar_choose_time: 'Velg tid',
  worthy_calendar_choose_datetime: 'Velg dato og tid',
  worthy_calendar_close: 'Lukk',
  worthy_calendar_cancel: 'Avbryt',
  worthy_calendar_apply: 'Bruk',
  worthy_calendar_default_label: 'Dato for hendelsen',
  worthy_calendar_default_time_label: 'Tidspunkt',
  worthy_calendar_default_datetime_label: 'Dato og tid for hendelsen',
  worthy_calendar_required: 'Vennligst velg en dato',
  worthy_calendar_required_time: 'Vennligst velg et tidspunkt',
  worthy_calendar_required_datetime: 'Vennligst velg dato og tid',
  worthy_calendar_time_heading: 'Velg tid',
  error_boundary_title: 'Vi oppdaterte Nettgrav',
  error_boundary_subtitle:
    'Last inn siden på nytt for å fortsette. Om det vedvarer, prøv igjen om litt.',
  error_boundary_reload: 'Last inn på nytt',
  error_boundary_show_details: 'Vis detaljer',
  error_boundary_hide_details: 'Skjul detaljer',
  auth_mobileNumber: 'Mobilnummer',
  auth_password: 'Passord',
  auth_passwordPlaceholder: 'Skriv inn passordet',
  auth_show_password: 'Vis passord',
  auth_hide_password: 'Skjul passord',
  auth_rememberMe: 'Husk meg på denne enheten',
  sign_in: 'Logg inn',
  auth_login: 'Logg inn',
  auth_get_newsletr: 'Motta nyheter og oppdateringer fra Nettgrav',
  auth_notRegistered: 'Har du ikke en konto? ',
  auth_alreadyRegistered: 'Har du allerede en konto? ',
  auth_login_here: 'Logg inn',
  register: 'Opprett konto',
  auth_register: 'Opprett konto',
  'family_tree_guest.eyebrow': 'Familietre',
  'family_tree_guest.title': 'Se slekt, talenter og mønstre i sammenheng',
  'family_tree_guest.intro':
    'Familietreet gir et felles sted for å samle mennesker, graver og relasjoner. Slik blir det lettere å forstå sammenhenger, bevare historier og føre dem videre.',
  'family_tree_guest.primary_cta': 'Logg inn for å fortsette',
  'family_tree_guest.secondary_cta': 'Opprett konto',
  'family_tree_guest.note': 'Logg inn for å begynne å bygge familiens tre.',
  'family_tree_guest.panel_label': 'Slik kan det se ut',
  'family_tree_guest.feature_1':
    'Knytt personer sammen, og se hvordan relasjoner også kommer til underveis.',
  'family_tree_guest.feature_2': 'Oppdag talenter og sanser som går igjen gjennom generasjonene.',
  'family_tree_guest.feature_3':
    'Familien kan bekrefte det de kjenner igjen, slik at innsikten blir tydeligere og mer forankret over tid.',
  'family_tree_guest.feature_1_title': 'Bygg og la treet vokse',
  'family_tree_guest.feature_2_title': 'Talenter og sanser i familien',
  'family_tree_guest.feature_3_title': 'Bekreftet av familien',
  'family_tree_guest.preview_person_name': 'Elias Johansen',
  'family_tree_guest.preview_person_meta': 'Født 1984 • del av samme familielinje',
  'family_tree_guest.preview_relation_1': 'Bror',
  'family_tree_guest.preview_relation_2': 'Forelder',
  'family_tree_guest.preview_grave_name': 'Lorense Johansen',
  'family_tree_guest.preview_grave_meta': 'Koblet til samme familie',
  'family_tree_guest.preview_grave_body':
    'Se hvordan mennesker og graver henger sammen i familien over tid.',
  'family_tree_guest.preview_tree_root': 'Elias Johansen',
  'family_tree_guest.preview_tree_root_meta': 'Start med én person og bygg treet videre',
  'family_tree_guest.preview_tree_left': 'Liv Johansen',
  'family_tree_guest.preview_tree_left_meta': 'Mor',
  'family_tree_guest.preview_tree_right': 'Oskar Johansen',
  'family_tree_guest.preview_tree_right_meta': 'Far',
  'family_tree_guest.detail_title': 'Dette kan du gjøre i familietreet',
  'family_tree_guest.detail_intro': 'Familietreet binder mennesker, graver og slektslinjer sammen.',
  'family_tree_guest.preview_status': 'Kjenner igjen',
  'family_tree_guest.preview_hint': 'Maren kjenner igjen talentet Delegasjon hos Elias Johansen.',
  auth_forgotPassword: 'Trenger du hjelp med passordet?',
  login_phone_verification_message:
    'Telefoninnlogging krever at e-postadressen på kontoen er bekreftet.',
  login_phone_email_verification_message:
    'E-postadressen på kontoen må bekreftes før du kan logge inn med telefonnummer. Logg inn med e-postadressen din for å fortsette.',
  login_send_verification_code: 'Send bekreftelses-e-post',
  login_phone_code_sent: 'Bekreftelses-e-posten er sendt.',
  login_phone_code_verified: 'E-postadressen er bekreftet. Logger deg inn...',
  auth_too_many_attempts: 'For mange innloggingsforsøk. Vent litt før du prøver igjen.',
  phone_verification_uses_email: 'Telefonverifisering skjer via e-post.',
  auth_welcome: 'Velkommen tilbake',
  auth_toNettgrav: 'til nettgrav.no',
  auth_enterPhoneNumber: 'Skriv inn telefonnummeret ditt',
  auth_emailOrPhone_label: 'E-post eller telefonnummer',
  auth_emailOrPhone_placeholder: 'Skriv inn e-post eller telefonnummer',
  auth_emailOrPhone_required: 'E-post eller telefonnummer er påkrevd',
  auth_phone_hint: 'Skriv et lokalt nummer eller bruk et internasjonalt format som +47 45007009.',
  auth_man: 'Mann',
  auth_woman: 'Kvinne',
  auth_other: 'Annen',
  auth_acceptConditions: 'Jeg godtar å motta SMS fra Nettgrav og jeg godtar',
  auth_termsAndCondition: 'vilkår og betingelser',
  auth_next: 'Neste',
  auth_receivedSMS: 'Du vil nå motta en melding',
  auth_otpCode: 'Skriv inn engangskoden',
  auth_received: 'Har du ikke mottatt en engangskode?',
  auth_newOtp: 'Du kan sende en ny engangskode om 00:',
  auth_sendNew: 'Send ny',
  auth_confirm: 'Bekreft',
  confirm: 'Bekreft',
  auth_passwordSentTo: 'Passordet ble sendt til:',
  auth_yourName: 'Ditt navn',
  auth_enterFullName: 'Skriv inn navnet ditt',
  auth_enterPasswordAgain: 'Skriv inn passordet på nytt',
  auth_passwordMessage: 'Bruk minst 7 tegn og 3 av de 4 kategoriene:',
  auth_capitalLetter: '⚙︎ Stor bokstav',
  auth_smallLetters: '⚙︎ Små bokstaver',
  auth_digits: '⚙︎ Tall',
  auth_characters: '⚙︎ Spesialtegn',
  auth_signupInvitation: 'Du ble invitert til bevisst abonnement fra',
  auth_resetPassword: 'Tilbakestill passord',
  auth_resetPasswordSMS: 'En engangskode er sendt til mobiltelefonen din',
  auth_back: 'Tilbake',
  auth_send: 'Send',
  auth_restOtp: 'Skriv inn engangskoden sendt til {code}{phoneNumber}',
  auth_code: 'Skriv inn koden',
  auth_confirmPassword: 'Bekreft nytt passord',
  auth_newPassword: 'Nytt passord',
  auth_notSame: 'Passordene er ikke like',
  auth_save: 'Lagre',
  'gravesHub.inviteFamily.title': 'Inviter familie til å ta vare på graven',
  'gravesHub.inviteFamily.submit': 'Send invitasjon',
  'gravesHub.inviteFamily.success':
    'Invitasjon sendt til {email}. De kan nå hjelpe til med å ta vare på graven.',
  'gravesHub.inviteFamily.error': 'Kunne ikke sende invitasjonen. Prøv igjen.',
  'gravesHub.inviteFamily.loading': 'Vent mens vi laster siden.',
  settings_profile: 'Profil',
  settings_personalInformation: 'Navn og informasjon',
  settings_payments: 'Betalinger',
  settings_paymentDate: 'Dato',
  settings_paymentStatus: 'Status',
  settings_paymentMethod: 'Betalingsmetode',
  settings_paymentAmount: 'Beløp',
  settings_emptyPayments: 'Det er for øyeblikket ingen betalinger tilgjengelig',
  settings_subscription: 'Abonnement',
  settings_members: 'Familie og venner',
  settings_giftInvitations: 'Inviter med en gave',
  settings_notifications: 'Varsler',
  settings_security: 'Sikkerhet',
  settings_title: 'Innstillinger',
  settings_back_to_menu: 'Tilbake til innstillinger',
  settings_load_error_title: 'Kunne ikke laste innstillingene',
  settings_load_error_body: 'Kontroller forbindelsen og prøv igjen.',
  settings_notifications_load_error_title: 'Kunne ikke laste varslene',
  settings_notifications_load_error_body: 'Varslingsvalgene ble ikke endret. Prøv igjen.',
  settings_password_updated_success: 'Nytt passord ble lagret.',
  settings_password_invalid_error: 'Passordet kunne ikke endres. Kontroller opplysningene.',
  account_deletion_requested_success: 'Forespørselen om å slette kontoen er registrert.',
  account_deletion_cancelled_success: 'Slettingen av kontoen er avbrutt.',
  account_deletion_update_error: 'Kunne ikke oppdatere slettingen av kontoen. Prøv igjen.',
  settings_enter_verification_code: 'Skriv inn verifiseringskode',
  settings_verification_code_invalid: 'Koden er ikke riktig',
  settings_account_information: 'Kontoinnstillinger',
  settings_inventory: 'Mine valg',
  inventory_section_subtitle: 'Her finner du lys og sirkler du kan legge på gravene du hører til.',
  inventory_empty_title: 'Legg til produkter fra butikken.',
  inventory_empty_description: 'Inventaret ditt kan brukes på alle graver.',
  inventory_purchase_item: 'Kjøp vare',
  inventory_purchase_button: 'Gå til butikken',
  settings_contact: 'Kontakt Nettgrav',
  settings_password: 'Passord',
  settings_edit: 'Rediger',
  my_light_remove_relation: 'Fjern relasjon',
  settings_fullName: 'Navn',
  settings_gender: 'Kjønn',
  settings_occupation: 'Yrke',
  settings_birthday: 'Fødselsdato',
  settings_email: 'E-postadresse',
  settings_telephoneNumber: 'Telefonnummer',
  settings_address: 'Adresse',
  settings_language: 'Språk',
  settings_currency: 'Valuta',
  settings_timeZone: 'Tidssone',
  settings_invalidEmail: 'Ugyldig e-postadresse',
  settings_cancel: 'Avbryt',
  save: 'Lagre',
  // Livshendelse tema-navn
  theme_name_familie: 'Familie',
  theme_name_skole: 'Skole',
  theme_name_arbeid: 'Arbeid',
  theme_name_kjaerlighet: 'Kjærlighet',
  theme_name_minne: 'Minne',
  theme_name_natur: 'Natur',
  theme_name_tro: 'Tro/Håp',
  theme_name_fellesskap: 'Fellesskap',
  theme_name_annet: 'Annet',
  settings_currentPassword: 'Gjeldende passord',
  settings_newPassword: 'Skriv inn nytt passord',
  settings_retype: 'Skriv inn passordet på nytt',
  confirm_password: 'Bekreft passord',
  settings_billingMethod: 'Betalingsmetode',
  settings_cancelSubscription: 'Avbryt abonnement',
  settings_cancel_mySubscription: 'Ja, avbryt abonnementet mitt',
  settings_month: 'måned',
  cancelSubscription_message:
    'Du er i ferd med å avslutte Nettgrav {name}-planen. Du kan fortsatt være her med gratisplanen, og starte igjen når du ønsker.',
  reactivateSubscription_message:
    'Du er i ferd med å reaktivere abonnementet på Nettgrav {name}-planen. Dette vil gjenopprette full tilgang til alle funksjonene knyttet til denne planen.',
  not_now: 'ikke nå',
  reactivate: 'Ja, reaktiver abonnementet mitt',
  settings_nextDue: 'Neste betaling forfaller',
  settings_paymentMethods: 'Betalingsmetoder',
  settings_nextBilling: 'Neste automatiske fakturering er',
  settings_mangeMethods: 'Se og administrer betalingsmetoden din',
  settings_emptyMethods: 'Det er ingen betalingsmetoder lagt til ennå',
  settings_vippsHeading: 'Vipps-betalinger og avtaler kommer snart hit',
  settings_manageVipps: 'For å se og administrere avtalene dine',
  settings_cardEnd: 'slutter på',
  settings_remove: 'Fjern',
  settings_stop: 'Stopp',
  relation_title_for_connection: 'Hva er relasjonen fra {firstGrave} til {secondGrave}?',
  relation_direction_title_for_connection: 'Hva er relasjonen fra {secondGrave} til {firstGrave}?',
  settings_vippsAgreement: 'Vipps-avtale',
  view_manage_agreements: 'Se og administrer avtalen din',
  empty_agreements: 'Ingen Vipps-avtaler ble funnet',
  settings_amount: '{amount}',
  settings_subscriptionHeading: 'Abonnements­administrasjon',
  settings_subscriptionStatus: 'Status',
  settings_length: 'Lengde',
  settings_nextBillingDate: 'Neste faktureringsdato',
  settings_endDate: 'Sluttdato',
  settings_reactivateSubscription: 'Reaktiver abonnement',
  settings_freeSubscriptionHeading: 'Kom i gang gratis.',
  months: 'måneder',
  year: 'år',
  month: 'måned',
  years: 'år',
  saved: 'Lagret',
  saved_message: '{name} har blitt lagret.',
  settings_upgrade: 'Oppgrader planen',
  settings_subDescription: 'For et meningsfullt liv',
  settings_for: 'for',
  settings_paymentInfo: 'Betalingsinformasjon',
  settings_cardNumber: 'Kortnummer',
  settings_billingInfo: 'Faktureringsinformasjon',
  settings_name: 'Navn',
  settings_billingEmail: 'E-post',
  settings_billingCountry: 'Land',
  settings_postCode: 'Postnummer',
  settings_changePlan: 'Bytt plan',
  change_plan: 'bytt plan',
  change: 'endre',
  change_members: 'endre medlemmer',
  settings_noSubscription: 'Du har ingen aktivt abonnement ennå.',
  settings_clickHere: 'klikk her',
  settings_getSubscription: 'Få abonnement',
  settings_subscriptionPrice: 'Pris per år',
  settings_subscriptionLengths: 'Tillatte lengder',
  settings_subscriptionYears: 'Kjøpte år',
  settings_subscriptionFrameId: 'Ramme-ID',
  open_menu: 'Åpne meny',
  settings_memberHeading: 'Invitasjoner',
  settings_receivedMembership: '(Invitasjoner du har mottatt)',
  settings_emptyMembership: 'Ingen invitasjoner akkurat nå.',
  settings_subscribedPlan: 'Abonnementet ditt er aktivert. Du kan se eller administrere ',
  settings_updatePlan: 'Abonnementet ditt er oppdatert. Du kan se eller administrere ',
  settings_downgradePlan: 'Abonnementet ditt er nedgradert. Du kan se eller administrere ',
  settings_addedMember: 'Nye medlemmer er lagt til. Du kan se eller administrere ',
  payment_progress: 'Betaling pågår – vennligst vent',
  something_wrong: 'Noe gikk galt. Vennligst prøv igjen senere',
  add_validNumber: 'Vennligst skriv inn et gyldig telefonnummer',
  select_planMessage:
    'For å fortsette, velg en plan som passer dine behov. Våre planer tilbyr fleksibilitet og gode funksjoner.',
  settings_memberPage: 'medlemsside',
  settings_your: 'din.',
  settings_enable: 'plan aktivert',
  free: 'Gratis',
  conscious: 'Conscious',
  consciousPlus: 'Conscious plus',
  settings_membershipOn: '– abonnement aktivert',
  settings_modalSubheading: 'Størst av alt er kjærlighet',
  settings_modalLink: 'Takk for at du er her',
  settings_memberSubheading: 'Din familieplan.',
  settings_emptyMembers: 'Du har ingen abonnements­medlemmer',
  settings_memberName: '{name}s familie',
  settings_memberLength: '{length} medlemmer',
  settings_administrator: 'Administrator',
  settings_showMembers: 'Vis medlemmer',
  settings_familyMembers: 'Familie',
  settings_you: 'Deg',
  settings_connect: 'koble til',
  settings_setRelation: 'Knytt relasjon',
  settings_selectedRelation: 'Velg relasjon',
  settings_giftHeading: 'Gi en medlemskap til noen du bryr deg om.',
  settings_giftFreeSubscription:
    'Du har en gratis konto. Oppgrader for å få alt og invitere flere.',
  settings_seeSubscriptions: 'Oppgrader',
  settings_youHave: 'Du har {count} ',
  settings_inviteAgain: 'invitasjoner igjen.',
  settings_addMore: 'for å legge til flere i planen din',
  error_trigger_title: 'Feilgrense-test',
  error_trigger_subtitle:
    'Klikk på knappen for å utløse en render-feil og verifisere den globale feilgrensen.',
  error_trigger_button: 'Utløs feil',
  settings_addMember: 'Legg til medlem',
  settings_invitedMember: 'Inviterte medlemmer',
  settings_emptyGiftMembers: 'Ingen ubesvarte invitasjoner',
  settings_inviteTo: 'Klikk her for å invitere til familieabonnementet',
  settings_pendingSubscription: 'Ditt abonnement er {status}.',
  settings_notificationsSubheading: 'Velg hva du vil få fra oss.',
  settings_notificationsTitle: 'Varslingsinnstillinger',
  settings_preferenceText: 'Varsler om samtaler og direkte henvendelser.',
  settings_reminders: 'Påminnelser',
  settings_remindersText: 'Merkedager og stille påminnelser.',
  settings_anniversary_marking: 'Jeg ønsker en markering på merkedager',
  settings_anniversary_in_app: 'Vis markeringen i Nettgrav',
  settings_anniversary_email: 'Send meg også e-post',
  settings_genealText: 'Nyheter og informasjon fra Nettgrav.',
  settings_textMessage: 'SMS',
  settings_general: 'Generelle oppdateringer',
  delete: 'Slett',
  settings_goToAgreements: 'Klikk her',
  settings_shareLink: 'Kopier og del din Nettgrav-invitasjon',
  grave_invitation_shareLink: 'Kopier og del din grav-invitasjonslink',
  settings_copyToClipboard: 'lenke kopiert',
  discard_subheading: 'Du kan fortsette å redigere, eller avslutte nå.',
  no: 'Nei',
  yes: 'Ja',
  invitation: 'Invitasjon',
  information: 'Informasjon',
  interests: 'Interesser',
  note: 'Notat',
  relative: 'Familie',
  uploadingImages: 'laster opp bilder',
  uploading: 'Laster opp',
  lifeEvent: 'Livshendelse',
  Workplace: 'Arbeidssted',
  delete_modalHeading: 'Bekreft at du vil fjerne',
  picture: 'bilde',
  paymentMethod: 'Betalingsmetode',
  vippsAgreement: 'Vipps-avtale',
  settings_complete_subscription: 'Fullfør abonnementet',
  pending_message:
    'Abonnementet ditt er ufullstendig. Fullfør abonnementet for fortsatt tilgang til Conscious-funksjoner.',
  pending_title: 'Din betalingsavtale venter',
  stopped_title: 'Din betalingsavtale ble stoppet',
  stopped_message:
    'Abonnementet ditt er ufullstendig fordi betalingsavtalen ble kansellert. Fullfør abonnementet for fortsatt tilgang til Conscious-funksjoner.',
  expired_title: 'Din betalingsavtale er utløpt',
  expired_message:
    'Abonnementet ditt er ufullstendig fordi betalingsavtalen er utløpt. Fullfør abonnementet for fortsatt tilgang til Conscious-funksjoner.',
  complete_setup: 'fullfør oppsett',
  cancelled_title: 'Abonnementet ditt er kansellert',
  cancelled_message:
    'Abonnementet ditt er kansellert. Du kan reaktivere før {period_end_date} for fortsatt tilgang til Conscious-funksjoner. Etter dette vil abonnementet bli nedgradert til gratisplan.',
  activeStopped_title: 'Din betalingsavtale har utløpt',
  activeStopped_message:
    'Abonnementets betalingsmetode er utløpt. Forny betalingsmetode for fortsatt tilgang til Conscious-funksjoner. Hvis problemet vedvarer, nedgraderes abonnementet til gratisplan ved slutten av syklusen.',
  renew_Agreement: 'Forny betalingsavtale',
  add_card: 'Legg til betalingsmetode',
  Reactivate: 'Reaktiver abonnement',
  active_title: 'Abonnementet ditt aktiveres snart',
  active_message:
    'Abonnementet ditt behandles og aktiveres om noen minutter. Takk for tålmodigheten – du får snart tilgang til Conscious-tjenester.',
  activeExpired_title: 'Din betalingsavtale er utløpt',
  activeExpired_message:
    'Abonnementets betalingsmetode er utløpt. Vennligst forny eller opprett ny betalingsavtale for fortsatt tilgang til Conscious-funksjoner.',
  notValid_title: 'Betalingsmetode mangler',
  notValid_message:
    'Det ser ut til at betalingsmetoden din mangler eller ikke er gyldig. Oppdater betalingsdetaljene for uavbrutt tjeneste.',
  consciousness: 'Om oss',
  about_us: 'Om Nettgrav',
  team: 'Vår historie',
  careers: 'Bli med i teamet',
  features: 'Om graven',
  available_sustainable: 'Alltid tilgjengelig',
  maintenance_free_grave: 'Enkelt i bruk',
  memory_album: 'Personer',
  'settings.security.title': 'Sikkerhet',
  'settings.security.sessions.title': 'Hvor du er logget inn',
  'settings.security.sessions.device': 'Enhet',
  'settings.security.sessions.this_device': 'Denne enheten',
  'settings.security.sessions.last_active': 'Sist aktiv',
  'settings.security.sessions.created': 'Opprettet',
  'settings.security.sessions.expires': 'Utløper',
  'settings.security.sessions.ip': 'IP',
  'settings.security.sessions.logout': 'Logg ut',
  'settings.security.sessions.logout_all': 'Logg ut av alle enheter',
  'settings.security.sessions.logout_others': 'Logg ut av andre enheter',
  'security.alerts.reuse_detected.title': 'Vi avsluttet økten din for å holde deg trygg',
  'security.alerts.reuse_detected.body':
    'Vi oppdaget et uvanlig innloggingsforsøk. Vi logget deg ut på alle enheter. Hvis dette ikke var deg, vennligst endre passordet ditt.',
  'gettingStarted.title': 'Velkommen',
  'gettingStarted.subtitle': 'Start med å søke på navnet for å finne graven.',
  'gettingStarted.search': 'Søk',
  'gettingStarted.search.placeholder': 'Søk etter navn',
  'gettingStarted.addRelation': 'Legg til en person',
  'gettingStarted.explainer':
    'Sett relasjonen din for å få oppdateringer, merkedager og vennlige påminnelser.',
  value_archive: 'Egenskaper og historier',
  memorial_wall: 'Varige gravbesøk',
  life_archive: 'Livshistorie',
  anniversary_calendar: 'Kalender for viktige datoer',
  Family_values: 'Familietre (kommer snart)',
  resources: 'Hjelp og ressurser',
  find_grave: 'Finn grav',
  blog: 'Blogg',
  help_center: 'Spørsmål og svar',
  contact: 'Kontakt',
  contact_us: 'Kontakt oss',
  business_inquiries: 'Forretningshenvendelser',
  feedback: 'Del dine tanker',
  basic_information: 'Grunnleggende informasjon',
  interest: 'Interesse',
  notes: 'Notater',
  passion: 'Lidenskap',
  relation: 'Relasjon',
  life_event: 'Livshendelse',
  subscription_invitation: 'Invitasjon til abonnement',
  cookies_banner_text:
    'Vi bruker nødvendig lagring og vår egen trafikkmåling for at Nettgrav skal fungere og bli bedre.',
  cookies_more: 'Les mer',
  cookies_accept: 'Godta',
  cookies_reject: 'Avvis',
  cookies_manage: 'Endre cookievalg',
  rooms_landing_eyebrow: 'Rom',
  rooms_landing_title: 'Et sted å samles rundt det som betyr noe.',
  rooms_landing_lead:
    'Et rom samler mennesker rundt det som betyr noe. Ikke en gruppe. Ikke en tråd. Et rom der du setter tonen, inviterer dem du vil og skaper et fellesskap rundt noe som faktisk betyr noe for deg.',
  rooms_landing_coming_soon: 'Kommer snart til Nettgrav.',
  rooms_landing_preview_label: 'Preview',
  rooms_landing_panel_quote: 'Ingen algoritme bestemmer hvem som ser hva. Det er deg.',
  rooms_landing_open_rooms: 'Åpne rom',
  rooms_landing_closed_rooms: 'Lukkede rom',
  rooms_landing_private_rooms: 'Private rom',
  rooms_landing_what_title: 'Hva er et rom?',
  rooms_landing_what_body_1:
    'Et rom er et fellesskap du oppretter rundt en tanke, en opplevelse, en sorg eller en glede. Du bestemmer hvem som er velkommen, hva rommet handler om og hvordan det holdes trygt.',
  rooms_landing_what_body_2:
    'Noen rom er åpne. Alle kan lese, men man melder seg inn for å delta. Andre er lukkede, der du godkjenner hvem som kommer inn. Og noen er private, bare for dem du inviterer selv.',
  rooms_landing_who_title: 'Hvem kan opprette et rom?',
  rooms_landing_who_body: 'Alle med en Nettgrav-konto kan opprette et rom.',
  rooms_landing_use_case_1: 'Deg som har mistet noen og vil samle dem som kjente vedkommende.',
  rooms_landing_use_case_2: 'En sykepleier som vil gi pårørende et trygt sted.',
  rooms_landing_use_case_3: 'En psykolog eller fasilitator som holder en sorggruppe.',
  rooms_landing_use_case_4: 'En venn som vil holde et minnerom levende over tid.',
  rooms_landing_who_question: 'Det eneste vi spør om er: hvordan vil du holde rommet trygt?',
  rooms_landing_support_title: 'Støtt rommet du bryr deg om',
  rooms_landing_support_body_1:
    'Noen rom fortjener å leve lenge. Hvis du holder et rom som betyr noe for andre, kan du åpne for støtte. De som finner verdi der kan bidra med for eksempel 99 kr i måneden.',
  rooms_landing_support_body_2:
    'Støtten er et månedlig abonnement. Nettgrav beholder 15 %, og betalingsgebyrer trekkes før resten utbetales til deg.',
  rooms_landing_directions_title: 'Retninger',
  rooms_landing_directions_body:
    'Alle rom tilhører en retning, en kategori som hjelper folk å finne det som er relevant for dem. Du velger retning når du oppretter rommet, og rommet ditt kan bli synlig for dem som leter etter nettopp det du tilbyr.',
  rooms_landing_direction_grief: 'Sorg og tap',
  rooms_landing_direction_relationships: 'Relasjoner',
  rooms_landing_direction_life_choices: 'Livsvalg',
  rooms_landing_direction_health: 'Helse',
  rooms_landing_direction_eot: 'End of Time Consciousness',
  rooms_landing_cta_eyebrow: 'Tidlig tilgang',
  rooms_landing_cta_title: 'Rom er på vei inn i Nettgrav.',
  rooms_landing_cta_body:
    'Funksjonen er ikke fullt lansert ennå. Eksisterende rom er fortsatt tilgjengelige for dem som allerede bruker dem.',
  rooms_landing_cta_primary: 'Opprett et rom',
  rooms_landing_cta_secondary: 'Les vilkår',
  find_grave_norway: 'Finn en grav',
  find_grave_value_statement: 'Finn hvor noen er gravlagt, og besøk graven på nett.',
  search_grave: 'Søk etter navn',
  search_recent_title: 'Nylige',
  search_recent_clear: 'Tøm',
  search_recent_remove: 'Fjern',
  search_suggestions_title: 'Forslag',
  search_searching: 'Søker…',
  search_no_results: 'Ingen treff',
  or: 'eller',
  find_grave_create_cta: 'legg til en grav',
  create_netgrave: 'opprett en grav',
  netgrave: 'Nettgrav',
  visit: 'Besøk',
  relation_summary_self: 'Jeg er {relationLower} til {name}',
  relation_summary_target: '{name} er min {relationLower}',
  relation_summary_fallback_person: 'denne personen',
  visit_grave: 'Finn den du tenker på',
  wish: '',
  find_grave_practical_reason:
    'Her kan du finne grav i {municipalityName} og se hvilke gravlunder personen er gravlagt på.',
  find_grave_cemetery_practical_reason:
    '{cemeteryName} ligger i {municipalityName}. Her kan du finne grav og se hvem som er gravlagt på gravlunden. Søk etter navn for å finne riktig gravsted og besøke graven på nett.',
  find_grave_support_statement: 'Små handlinger gir rom for nærhet over tid.',
  find_grave_guest_cta_title: 'Når du finner riktig grav',
  find_grave_guest_cta_body:
    'kan du knytte deg til den, legge igjen et tegn og følge opp over tid.',
  find_grave_guest_cta_button: 'Ta vare på en grav',
  find_grave_search_heading: 'Søk etter navn',
  find_grave_search_description: 'Start med et navn for å finne riktig grav.',
  find_grave_name_placeholder: 'Skriv et navn, f.eks. Ola Nordmann',
  second_section_description: 'Start med et navn, eller utforsk kommune og kirkegård.',
  find_grave_start_hint: 'Skriv inn et navn',
  find_grave_faq_title: 'Vanlige spørsmål',
  find_grave_faq_question_1: 'Hvordan finner jeg en grav?',
  find_grave_faq_answer_1:
    'Søk på navn. Du kan også bruke kommune eller kirkegård for å snevre inn treffene.',
  find_grave_faq_question_2: 'Kan jeg søke på kommune eller kirkegård?',
  find_grave_faq_answer_2:
    'Ja. Skriv kommunen eller kirkegården i søket, eller velg videre fra oversikten.',
  find_grave_faq_question_3: 'Hva gjør jeg hvis jeg ikke finner personen?',
  find_grave_faq_answer_3:
    'Prøv en annen skrivemåte eller søk med færre ord. Du kan også opprette en Nettgrav hvis den mangler.',
  memorial_plaque: 'Kommuner',
  memorial_plaque_description: 'Utforsk kommuner og gravplasser.',
  archive: 'Kirkegårder',
  archive_description: 'Se kirkegårder i kommunen.',
  memory_album_description: 'Finn personer som er gravlagt der.',
  find_municipality: 'Finn grav i disse kommunene',
  search_municipality: 'Søk etter kommune',
  find_grave_municipality_cta: 'Se gravlunder',
  it_is: 'Det er',
  find_grave_count: '{count}',
  municipality_description: 'Søk blant {count} kommuner og finn graven du leter etter.',
  no_results: 'Ingen resultater funnet for',
  find_cemetery: 'Gravlunder i {municipalityName}',
  find_cemetery_generic: 'Finn en grav på disse kirkegårdene',
  search_cemetery: 'Søk etter kirkegård',
  cemetery_description:
    'kirkegårder i {municipalityName}. Velg kirkegård nedenfor for å søke etter grav eller finne gravsted.',
  grave_description:
    'personer gravlagt her. Søk etter navn for å finne riktig gravsted og besøke graven på nett.',
  goto_grave: 'se grav',
  payment_due_message:
    'Abonnementet ditt er aktivt. Betalingen behandles. Vipps håndterer belastningen.',
  payment_due_title: 'Abonnementet ditt er aktivt',
  life_page: 'Livet-side',
  the_life_page: 'Mitt lys',
  first_description: 'Her kan du dele din egen gnist og se andres.',
  your_graves: 'De du bærer med videre',
  second_description: 'Personene du har relasjon til blir synlige her.',
  update: 'Dine relasjoner',
  third_description: 'Dine nærmeste blir en del av ditt Lys.',
  find_grave_last_text:
    'På Nettgrav kan du ha et sted å gå til når du vil tenke på noen. Du kan finne og lage gravsteder som alltid er tilgjengelige, og du trenger aldri å tenke på vedlikehold eller kostnader. Her kan du også dele det som er viktig for deg gjennom noe vi kaller Gnist. Kanskje du har spørsmål, erfaringer, eller tanker om hva som betyr mest i livet – alt dette kan du dele her. Slik bidrar vi sammen til mer kunnskap og undring om livet, døden og alt som er viktig for oss mennesker.',
  plans_page_heading: 'Et bevisst valg for et meningsfullt liv',
  plans_page_subheading:
    'Slipp fortiden, omfavn reisen videre med den mest verdifulle graven for dine kjære.',
  per_user: 'per medlem',
  current_members: 'Gjeldende medlemmer',
  added_members: 'Antall medlemmer som skal legges til',
  removed_members: 'Antall medlemmer som skal fjernes',
  view_current_members: 'Vis gjeldende medlemmer',
  total_members: 'Medlemmer etter endring',
  plan_price: 'Planpris',
  increment_text: 'Velg antall medlemskap du ønsker for deg og familien',
  free_description: 'For de som ønsker å søke etter og besøke graver uten kostnad.',
  conscious_description:
    'Med Conscious-abonnement blir du en verifisert støttespiller av End Of Time-perspektivene.',
  consciousPlus_description:
    'Tilgang som Conscious, med ekstra fokus på gravens etikk. Pris: 500 NOK per år',
  total_user_count: 'For {subscriptionTotalCount} familiemedlemmer er totalbeløpet:',
  per_month: 'per måned',
  current_plan: 'Gjeldende plan',
  got_started: 'Kom i gang',
  free_feature_heading: 'Alle funksjoner inkludert i gratisplanen',
  conscious_feature_heading: 'Alle funksjoner inkludert i gratisplanen, pluss flere',
  conscious_plus_feature_heading: 'Alle funksjoner inkludert i Conscious-planen, pluss flere',
  feature_memory_album: 'Minnealbum',
  feature_purposes: 'Formål',
  feature_end_of_time: 'End Of Time-mynt',
  feature_family_tree: 'Familietre',
  feature_testament: 'Testamente',
  feature_groups: 'Grupper (fellesskap)',
  feature_Shop: 'Nærvær',
  feature_Sparks: 'Sparks',
  feature_life_page: 'Mitt lys',
  feature_search_grave: 'Søk etter graver',
  feature_create_grave: 'Opprett Spark',
  question_answer: 'Spørsmål og svar',
  feature_life_archive: 'Livsarkiv',
  feature_anniversary_calendar: 'Merkedagskalender',
  feature_memory_wall: 'Minnevegg',
  feature_value_archive: 'Egenskaper',
  benefits_1_title: 'Kjærligheten fortsetter',
  benefits_1_description:
    'Hver conscious grav er et sted der kjærligheten lever videre – med verdighet, varme og mening.',
  benefits_2_title: 'Støtter det som redder liv',
  benefits_2_description:
    'Din donasjon går direkte til forskning og utvikling for å forstå og overvinne det som tar liv.',
  benefits_3_title: 'En meningsfull grav',
  benefits_3_description:
    'Fra blomster og lys – til ekte handling. Conscious-graver bidrar til å forme en bedre fremtid.',
  benefits_4_title: 'Mot en verden uten uønsket død',
  benefits_4_description:
    'Sammen skaper vi håp. Hver grav bringer oss ett skritt nærmere en tryggere og mer hel verden.',
  benefits_title: 'Gode grunner til å velge Conscious på Nettgrav',
  faqs_1_question: 'Hvilke betalingsmetoder aksepterer dere?',
  faqs_1_answer: 'Vi aksepterer kreditt-/debetkort (Visa, Mastercard) og Vipps',
  faqs_2_question: 'Er det noen tilleggskostnader jeg bør være oppmerksom på?',
  faqs_2_answer:
    'Det er ingen skjulte avgifter. Her kan du samle alle graver og begravelser uten ekstra kostnader',
  faqs_3_question: 'Hvordan oppdaterer jeg betalingsinformasjonen min?',
  faqs_3_answer:
    'For å oppdatere betalingsinformasjonen, gå til kontoinnstillingene dine og velg abonnement-fanen',
  faqs_4_question: 'Hva skjer etter at betalingen er fullført?',
  faqs_4_answer:
    'Når betalingen er fullført, mottar du et varsel fra Nettgrav som indikerer at abonnementet ditt er aktivert.',
  faqs_5_question: 'Hva er forskjellen mellom Free og Conscious?',
  faqs_5_answer:
    'Gratisabonnement gir fem søk og fem minner. Det er også begrensning på størrelsen på media som kan legges til graver. Med Conscious har du ubegrenset tilgang til alle funksjoner og nye funksjoner som legges til.',
  faqs_6_question: 'Hvem er Conscious-planen for?',
  faqs_6_answer:
    'Conscious er for de som ønsker det beste ut av livet. Den gir deg frihet til å gi slipp på gamle antagelser og ritualer. Med Conscious har du alltid tilgang til funksjoner som støtter reisen din i livet – med utgangspunkt i den mest meningsfulle graven for dine kjære og vårt løfte om alltid å veilede deg til der kjærligheten er.',
  update_modal_change_plan: 'Endre {name}-plan',
  waite_for_validation: 'Vent mens vi bekrefter abonnementet',
  add_members: 'Legg til medlemmer',
  remove_members: 'Fjern medlemmer',
  allowed_members: 'Antall tillatte medlemmer',
  how_many_add: 'Hvor mange medlemmer vil du legge til?',
  how_many_remove: 'Hvor mange medlemmer vil du fjerne?',
  not_remove_all: 'Behold minst ett medlem.',
  updated_price: 'Oppdatert pris etter endringene',
  remaining_members: 'Totalt gjenværende medlemmer',
  total_price: 'Totalpris',
  extra_user: 'For ytterligere {subscriptionTotalCount} familiemedlemmer er det en ekstra kostnad',
  process_payment: 'Gå til betaling',
  continue: 'Fortsett',
  subscription_members: 'Abonnementsmedlemmer',
  remove_subscription_members: 'Fjern abonnementsmedlemmer ved å klikke fjern',
  subscription_invitation_members: 'Invitasjoner til abonnement',
  remove_invitation_members: 'Fjern abonnementsinvitasjonen ved å klikke fjern',
  downgrade_plan: 'Nedgrader plan',
  upgrade_plan: 'Oppgrader plan',
  downgrade_message:
    'Deaktiver alle abonnementsmedlemmer og invitasjoner for å fortsette med nedgradering',
  upgrade_message: 'Fjern alle abonnementsmedlemmer og invitasjoner for å oppgradere',
  close_message: 'Du kan nå lukke og fortsette',
  close: 'Lukk',
  active_members: 'Aktive medlemmer i abonnementet ditt',
  active_members_message:
    'For å fortsette, deaktiver ett eller flere medlemmer fra abonnementet ditt.',
  active_members_empty_message: 'Ingen aktive medlemmer funnet i abonnementet ditt',
  active_invitations: 'Avventende invitasjoner for abonnementet ditt',
  active_invitations_message: 'Vennligst tilbakekall invitasjonene for medlemmer for å fortsette.',
  active_invitations_empty_message: 'Ingen utestående invitasjoner knyttet til abonnementet ditt',
  check_out: 'Kassen',
  select_payment_method: 'Velg betalingsmetode',
  order_details: 'Ordredetaljer',
  subscription_number: 'Antall abonnement',
  taxes: 'Skatter',
  total: 'Total å betale:',
  sub_total: 'Vanlig medlemspris:',
  discount_title: 'Faktureringsfrekvens:',
  subscription_length: 'Planvarighet',
  discount: 'Rabatt for flere medlemmer:',
  renewal: 'Abonnementet fornyes automatisk.',
  renewal_details:
    'Fornyelse skjer i henhold til valgt faktureringsfrekvens. Du kan avslutte når som helst.',
  payment_page_terms: 'Ved å velge “Neste” eller “Abonner” godtar du våre',
  terms_conditions: 'Vilkår for bruk.',
  terms_conditions_page_title: 'Vilkår for Nettgrav',
  terms_conditions_page_subtitle:
    'Dette er avtalen mellom deg og Nettgrav når du bruker tjenesten.',
  terms_conditions_section1_title: '1. Generelt',
  terms_conditions_section1_body:
    'Nettgrav.no er en sosial portal for ivaretakelse av det indre livet vårt. Portalen starter arbeidet med fornyelse av den fysiske graven gjennom et skybasert gravsted som tilrettelegger for at pårørende og andre skal få mulighet til å møte behovene døden etterlater seg på Nettgrav med mere. I tillegg til muligheten for å opprette og besøke en Nettgrav, tilrettelegges det for at medlemmer kan lagre bilder i Gravalbum, minner på Gravtavlen, verdier i Verdiarkivet og livshendeler i Livsarkivet, og andre tjenester kommer til knyttet til ivaretakelse av seg selv, gravlagte og andre relasjoner. For enkelte deler av Produktet gjelder i tillegg særskilte vilkår som fremgår av Nettstedet med hensyn til blant annet priser, betalingsvilkår og betalingsmetoder, avtaleperiode og annet som Nettgrav AS tilbyr. Ved avvik mellom slike særskilte vilkår og disse generelle brukervilkårene vil de særskilte vilkårene gjelde foran de generelle brukervilkårene.',
  terms_conditions_section2_title: '2. REGISTRERING, BRUKERNAVN OG PASSORD',
  terms_conditions_section2_body:
    'Fremgangsmåten for å få tilgang til Produktet varierer ettersom du er fester for den fysiske graven eller besøkende. Registrering av brukerkonto kan enten skje på Nettstedet eller via andre tjenester og sosiale medier i den grad Nettgrav tilbyr det. Dersom du registrerer deg via andre tjenester eller sosiale medier gir du samtykke til at Nettgrav kan innhente brukerinformasjon for å sette opp brukerkontoen. Du er selv ansvarlig for at alle opplysninger som oppgis ved registrering er korrekte. Ditt passord er personlig og kan ikke brukes av andre. Dersom du oppdager uautorisert bruk av din konto må du umiddelbart ta kontakt med Nettgrav AS og endre ditt passord. For å ivareta sikkerheten ved Produktet har Nettgrav AS rett til å kreve at du når som helst endrer ditt passord.',
  terms_conditions_section3_title: '3. BRUK AV TJENESTENE M.M',
  terms_conditions_section3_body:
    'Du er selv ansvarlig for din bruk av Produktet, og det skal kun benyttes til det formål det er ment for. Du forplikter deg til å holde Nettgrav AS skadesløs for følger av lovovertredelser og for ethvert krav som tredjemann måtte rette mot Nettgrav AS som følge av din bruk av Produktet og Tjenestene som tilbys.',
  terms_conditions_section4_title: '4. PRISER OG BETALING',
  terms_conditions_section4_body: 'Priser for Produktet fremgår av Nettstedet.',
  terms_conditions_section5_title: '5. ANSVARSFRASKRIVELSE',
  terms_conditions_section5_body:
    'Med mindre annet klart fremgår er Nettgrav AS ikke ansvarlig for informasjon eller innhold plassert på eller sendt via våre Tjenester. Nettgrav AS har ikke kontroll over andre nettsider som det lenkes til, og har heller ikke ansvar for innholdet som finnes på slike nettsider. Innenfor det som er tillatt etter gjeldende rett fraskriver Nettgrav AS seg ethvert ansvar for skade eller tap som følge av dine handlinger eller unnlatelser i forbindelse med Tjenestene.',
  terms_conditions_section6_title: '6. ENDRINGER',
  terms_conditions_section6_body:
    'Nettgrav AS har rett til å endre innholdet i og omfanget av Produktets Tjenester. Nettgrav AS har rett til å endre priser og andre vilkår, herunder vilkårene for Tjenestene. Når endringene er av en viss betydning og hvis til ugunst for deg, skal Nettgrav AS varsle deg via brev, SMS eller e-post på den adressen du har registrert, og senest 30 dager før endringen trer i kraft. Om du ikke ønsker å godta slike nye vilkår kan du som alltid si opp ditt medlemskap når du selv ønsker det.',
  terms_conditions_section7_title: '7. VARIGHET OG OPPSIGELSE',
  terms_conditions_section7_body:
    'Du kan når som helst slette din brukerkonto og eventuelle abonnement. Send e-post til kontakt@nettgrav.no hvis du har spørsmål eller trenger hjelp.',
  terms_conditions_section8_title: '8. REKLAMASJON',
  terms_conditions_section8_body:
    'For å benytte deg av reklamasjon må du meddele Nettgrav AS via e-post, telefon, brev eller gjennom Nettstedet innen 5 dager fra leveringstidspunktet. Blomster og planter regnes som ferskvare og er unnlatt angrefristloven.',
  terms_conditions_section9_title: '9. PERSONVERN',
  terms_conditions_section9_1_title: '9.1 Generelt',
  terms_conditions_section9_1_paragraph1:
    'Ditt personvern er viktig, og i tråd med lover og regler vil vi derfor informere deg om følgende:',
  terms_conditions_section9_1_paragraph2:
    'Nettgrav AS, Damstredet 3, 0177 Oslo (org.nr. 912 857 336) er behandlingsansvarlig for personopplysninger som behandles i forbindelse med levering av Produkt og Tjenester. Nettgrav AS behandler personopplysninger i henhold til den norske personopplysningsloven.',
  terms_conditions_section9_1_paragraph3:
    'Ved å registrere en brukerkonto samtykker du til at Nettgrav AS behandler personopplysninger i henhold til disse brukervilkårene og personopplysningspolicyen.',
  terms_conditions_section9_2_title: '9.2 Formål',
  terms_conditions_section9_2_body:
    'Nettgrav AS behandler personopplysninger for å kunne tilby Tjenestene, for å analysere hvordan mennesker benytter Produktet og Tjenestene, for administrasjon av kundeforhold, for å kommunisere med kontoinnehavere og for å kunne oppfylle våre forpliktelser i henhold til lov.',
  terms_conditions_section9_3_title: '9.3 Hvilke personopplysninger behandles?',
  terms_conditions_section9_3_body:
    'Personopplysningene som vi behandler er den informasjonen som oppgis av mennesker i forbindelse med registrering av konto, samt informasjon som ellers oppgis av mennesker ved bruk av Tjenestene. Dette omfatter opplysninger som navn, adresse, telefonnummer, e-postadresse og betalingsopplysninger. I tillegg behandles relevante opplysninger om avdøde og minner knyttet til graven.',
  terms_conditions_section9_4_title: '9.4 Utlevering av opplysninger',
  terms_conditions_section9_4_body:
    'Nettgrav AS kan utlevere personopplysninger til foretak som utfører tjenester for Nettgrav AS, slik at disse foretakene skal kunne utføre de tjenestene som Nettgrav AS etterspør. Dette gjelder blant annet levering av infrastruktur- og IT-tjenester samt kundetjenester. Vi vil ikke utlevere personopplysninger til andre tredjeparter eller benytte dine data for trening av KI.',
  terms_conditions_section9_5_title: '9.5 Retting, sletting og innsyn',
  terms_conditions_section9_5_body:
    'Du har rett til å få innsyn i hva slags personopplysninger Nettgrav AS behandler om deg i tråd med personopplysningslovens bestemmelser. Videre har du rett til å kreve retting av personopplysninger som er uriktige, ufullstendige eller som det ikke er anledning til å behandle. Hvor det foreligger grunnlag for det, kan du også kreve at opplysninger slettes.',
  terms_conditions_section9_6_title: '9.6 Bruk av informasjonskapsler',
  terms_conditions_section9_6_body:
    'Vi bruker informasjonskapsler (såkalte cookies) på Nettsiden, som er små tekstfiler som lagres på din datamaskin. Informasjonskapslene gjør at dine valg og ditt brukermønster kan bli lagret mens du er inne på Nettsiden. Vi bruker disse opplysningene til å tilpasse Nettsiden og for å gjøre Tjenestene så brukervennlige som mulig. I tillegg måler vi trafikken på Nettsiden.',
  terms_conditions_section9_6_paragraph2:
    'De fleste moderne nettlesere aksepterer informasjonskapsler automatisk, men du kan selv stenge av for informasjonskapsler dersom du ønsker det. Vi bruker ikke cookies til å personalisere opplevelsen. Alle opplever Produktet likt.',
  terms_conditions_section9_6_paragraph3:
    'Trafikk måles i Nettgrav sitt eget system med pseudonyme besøks- og øktnøkler. Vi bruker ikke Google Analytics eller andre eksterne analyseverktøy til denne målingen, og måledata deles ikke med kommersielle partnere som brukerprofiler.',
  terms_conditions_section9_6_paragraph4: '',
  terms_conditions_section10_title: '10. Tvister',
  terms_conditions_section10_body:
    'Disse brukervilkårene skal reguleres og tolkes i samsvar med gjeldende norsk rett. Tvister skal være underlagt norske domstolers jurisdiksjon. Oslo tingrett avtales som verneting.',
  terms_conditions_section11_title: '11. Kontaktinformasjon',
  terms_conditions_section11_body:
    'Ved spørsmål knyttet til Tjenestene og Produktet kan du ta kontakt med Nettgrav AS på kontakt@nettgrav.no, +47 450 07 009, eller per post: Damstredet 3, 0151, Oslo.',
  legal_navigation: 'Juridisk informasjon',
  legal_last_updated: 'Sist oppdatert 2. august 2026',
  legal_terms_1_title: '1. Generelt',
  legal_terms_1_body:
    'Nettgrav er en digital tjeneste for gravsteder, minner, relasjoner, samtaler og fellesskap. Tjenesten omfatter blant annet Nettgrav, Mitt lys, Skap Gnist, Rom og End of Time Chat. Enkelte kjøp eller funksjoner kan ha tilleggsvilkår som vises før du bestiller eller tar dem i bruk.',
  legal_terms_2_title: '2. Konto og sikkerhet',
  legal_terms_2_body:
    'Du skal oppgi riktige opplysninger og holde innloggingsinformasjonen din for deg selv. Kontakt oss og endre passordet dersom du tror andre har fått tilgang. Du er ansvarlig for aktiviteten fra kontoen din frem til du varsler oss. Nettgrav kan kreve ny bekreftelse eller passordendring når det er nødvendig for sikkerheten.',
  legal_terms_3_title: '3. Respektfull og lovlig bruk',
  legal_terms_3_body:
    'Du skal møte andre mennesker og minnet om avdøde med respekt. Du kan ikke utgi deg for å være andre, opprette en grav du vet er falsk, trakassere, true, krenke rettigheter, spre ulovlig innhold eller forsøke å få uautorisert tilgang. Meld fra til kontakt@nettgrav.no dersom du oppdager misbruk eller feil opplysninger.',
  legal_terms_4_title: '4. Innhold og synlighet',
  legal_terms_4_body:
    'Du beholder rettighetene til innhold du lager. Du bekrefter at du har rett til å dele innholdet og velger selv tilgjengelige synlighetsnivåer. Når du publiserer, gir du Nettgrav den begrensede retten som er nødvendig for å lagre, vise, sikre og levere innholdet i tråd med valgene dine. Innhold om andre levende mennesker skal deles med omtanke og nødvendig tillatelse.',
  legal_terms_5_title: '5. Moderering og feil',
  legal_terms_5_body:
    'Nettgrav kan skjule, begrense eller fjerne innhold og kontoer som bryter vilkårene, loven eller andres rettigheter. Vi kan be om dokumentasjon ved opprettelse eller endring av graver og relasjoner. Vi forsøker å rette feil og håndtere uenighet på en respektfull måte. Tiltak vurderes ut fra alvorlighet, risiko og tilgjengelig informasjon.',
  legal_terms_6_title: '6. Priser og betaling',
  legal_terms_6_body:
    'Grunnleggende bruk av Nettgrav er kostnadsfri. Pris, betaling, levering og eventuelle tilleggsvilkår vises før et kjøp. Lovfestede forbrukerrettigheter gjelder uavhengig av disse vilkårene.',
  legal_terms_7_title: '7. Endringer og tilgjengelighet',
  legal_terms_7_body:
    'Nettgrav utvikles løpende. Funksjoner kan endres, erstattes eller tas bort. Ved vesentlige endringer som påvirker rettighetene dine negativt, varsler vi på en egnet måte og gir rimelig frist før endringen gjelder. Vi kan ikke garantere uavbrutt tilgjengelighet, og arbeider for å gjenopprette tjenesten ved feil.',
  legal_terms_8_title: '8. Avslutning og reklamasjon',
  legal_terms_8_body:
    'Du kan når som helst be om å slette kontoen din og avslutte eventuelle løpende avtaler. For kjøp gjelder reklamasjons- og angrerett etter ufravikelig norsk lov. Kontakt kontakt@nettgrav.no så snart som mulig dersom noe er feil, slik at vi kan hjelpe.',
  legal_terms_9_title: '9. Ansvar og tvister',
  legal_terms_9_body:
    'Nettgrav er ansvarlig i den utstrekning det følger av ufravikelig lov. Vi er ikke ansvarlige for innhold brukere publiserer eller eksterne tjenester vi ikke kontrollerer. Vilkårene følger norsk rett. Uenighet forsøkes først løst gjennom dialog. Forbrukere kan også kontakte Forbrukertilsynet eller annet relevant klageorgan.',
  legal_terms_10_title: '10. Kontaktinformasjon',
  legal_terms_10_body:
    'Nettgrav AS, organisasjonsnummer 912 857 336. Registrert forretningsadresse: Damstredet 2, 0177 Oslo. Kontakt oss på kontakt@nettgrav.no.',
  privacy_page_title: 'Personvern i Nettgrav',
  privacy_page_subtitle:
    'Her forklarer vi hvilke opplysninger vi behandler, hvorfor vi trenger dem og hvilke valg du har.',
  privacy_promise_eyebrow: 'Kort fortalt',
  privacy_promise_title: 'Opplysningene dine er ikke til salgs',
  privacy_promise_no_sale: 'Vi selger ikke personopplysninger.',
  privacy_promise_no_targeting:
    'Vi deler ikke navn, kontaktopplysninger, relasjoner, minner, meldinger eller aktivitet med kommersielle partnere for målretting mot enkeltpersoner.',
  privacy_promise_context:
    'Partnere får synlighet i utvalgte sammenhenger på Nettgrav. De får ikke tilgang til menneskene som bruker tjenesten, og mottar bare samlet statistikk som ikke er ment å identifisere enkeltpersoner.',
  privacy_promise_no_profiles:
    'Vi bruker ikke det du skriver, hvem du minnes eller hva du opplever til å bygge kommersielle profiler om deg.',
  privacy_controller_title: '1. Hvem er ansvarlig?',
  privacy_controller_body:
    'Nettgrav AS, organisasjonsnummer 912 857 336, er behandlingsansvarlig. Registrert forretningsadresse er Damstredet 2, 0177 Oslo. Du kan kontakte oss på kontakt@nettgrav.no.',
  privacy_data_title: '2. Hvilke opplysninger behandler vi?',
  privacy_data_body:
    'Vi behandler konto- og kontaktopplysninger, profilopplysninger, relasjoner, innhold du velger å dele, henvendelser til kundeservice og nødvendige betalingsopplysninger. Vi behandler også tekniske opplysninger som økt, nettlesertype, omtrentlig land, sikkerhetshendelser og hvilke deler av tjenesten som besøkes. Graver inneholder opplysninger om avdøde. Minner og relasjoner kan samtidig inneholde opplysninger om levende mennesker.',
  privacy_purposes_title: '3. Hva bruker vi opplysningene til?',
  privacy_purposes_body:
    'Vi bruker opplysninger til å opprette og sikre kontoen din, levere funksjonene du ber om, vise innhold i tråd med synlighetsvalgene, håndtere betaling og støtte, forebygge misbruk, rette feil, måle samlet bruk og oppfylle rettslige plikter. Vi bruker ikke innholdet ditt til trening av generelle KI-modeller.',
  privacy_legal_basis_title: '4. Rettslig grunnlag',
  privacy_legal_basis_body:
    'Behandling som er nødvendig for å levere Nettgrav bygger normalt på avtalen med deg. Sikkerhet, misbruksforebygging og begrenset førstepartsmåling bygger på vår berettigede interesse i en trygg og fungerende tjeneste. Regnskapsopplysninger behandles fordi loven krever det. Valgfrie analyseverktøy og annen behandling som krever samtykke aktiveres først når du har valgt dette, og samtykket kan trekkes tilbake.',
  privacy_visibility_title: '5. Synlighet og innhold om andre',
  privacy_visibility_body:
    'Du styrer synlighet gjennom valgene som finnes i den enkelte funksjonen. Offentlig innhold kan sees og deles av andre. Privat innhold begrenses etter valget ditt. Når noen legger inn opplysninger om deg eller en relasjon til deg, kan du be om innsyn, retting, begrensning eller sletting der vilkårene for dette er oppfylt.',
  privacy_processors_title: '6. Leverandører, partnere og land utenfor EØS',
  privacy_processors_body:
    'Drifts-, lagrings-, e-post-, betalings-, kundestøtte-, sikkerhets- og analyseleverandører kan behandle nødvendige opplysninger på våre vegne under avtale og instrukser. Kommersielle partnere får ikke brukerprofiler eller tilgang til personopplysninger for presis markedsføring. Enkelte tekniske leverandører kan behandle opplysninger utenfor EØS. Da bruker vi et gyldig overføringsgrunnlag og nødvendige beskyttelsestiltak.',
  privacy_retention_title: '7. Hvor lenge lagrer vi opplysningene?',
  privacy_retention_body:
    'Vi lagrer opplysninger så lenge kontoen eller innholdet er aktivt og videre bare når det er nødvendig for formålet, sikkerhet, dokumentasjon eller lovkrav. Betalings- og regnskapsopplysninger beholdes så lenge bokføringsreglene krever det. Tekniske logger og måledata skal slettes eller anonymiseres etter fastsatte frister. Sikkerhetskopier fases ut etter ordinære rotasjonsrutiner.',
  privacy_rights_title: '8. Rettighetene dine',
  privacy_rights_body:
    'Du kan be om innsyn, retting, sletting, begrensning og dataportabilitet, og protestere mot behandling som bygger på berettiget interesse. Du kan trekke tilbake samtykke uten at det påvirker lovlig behandling som allerede er utført. Du kan klage til Datatilsynet. Enkelte opplysninger kan måtte beholdes på grunn av lovkrav eller hensynet til andres rettigheter.',
  privacy_security_title: '9. Sikkerhet',
  privacy_security_body:
    'Vi bruker tilgangsstyring, kryptert transport, logging, sikkerhetskopier og andre tekniske og organisatoriske tiltak tilpasset risikoen. Ingen digitale systemer er uten risiko. Ved et brudd som kan påvirke deg, varsler vi i tråd med gjeldende regler.',
  privacy_contact_title: '10. Kontakt oss',
  privacy_contact_body:
    'Send spørsmål eller krav om personvern til kontakt@nettgrav.no. Vi kan be om nødvendig informasjon for å bekrefte identiteten din før vi gir innsyn eller utfører endringer.',
  cookies_page_title: 'Informasjonskapsler og måling',
  cookies_page_subtitle: 'Her forklarer vi nødvendig lagring og Nettgrav sin egen trafikkmåling.',
  cookies_necessary_title: '1. Nødvendig lagring',
  cookies_necessary_body:
    'Nettgrav bruker nødvendig lokal lagring og øktsteknologi for innlogging, sikkerhet, språk, grunnleggende funksjoner og for å huske personvernvalget ditt. Dette kan ikke slås av inne i tjenesten når det er nødvendig for funksjonen du bruker.',
  cookies_first_party_title: '2. Nettgrav sin egen måling',
  cookies_first_party_body:
    'Vi teller sidevisninger og økter i vårt eget system for å forstå samlet bruk, oppdage tekniske problemer og filtrere roboter. Målingen bruker pseudonyme økt- og besøksnøkler, sidekategori, nettlesertype, omtrentlig land og en tidsbegrenset hash av IP-adressen. Rapportene brukes på aggregert nivå og deles ikke med partnere som brukerprofiler.',
  cookies_list_title: '3. Oversikt',
  cookies_list_body:
    'Nødvendige elementer omfatter Nettgrav sin økt og innstillinger som språk og visning. Nettgrav bruker ikke Google Analytics, Google Tag Manager eller analyse-cookies fra tredjeparter.',
  terms_conditions_accept_button: 'Aksepter',
  terms_conditions_reject_button: 'Avvis',
  change_free_plan: 'Gratisplan er kostnadsfri',
  free_plan_message:
    'Med gratisplan kan du utforske, besøke og opprette Nettgrav. Gratis er en grunnleggende verdi.',
  ending_with: 'slutter på',
  add_payment_method: 'Legg til betalingsmetode',
  name_on_card: 'Navn på kort',
  expiry_date: 'Utløpsdato',
  secure_payment_message: 'Sikker betaling med SSL-kryptering',
  billing_address: 'Fakturaadresse',
  enter_address: 'Skriv inn adresse',
  billing_info_message:
    'Denne informasjonen brukes til å utstede første faktura. Du kan oppdatere fremtidige fakturadetaljer i kontoprofilen din.',
  subscribe: 'Abonner',
  select_language: 'Velg språk',
  payment_error: 'Betalingsfeil',
  subscription_waiting_message:
    'Betalingen behandles. Vennligst vent, abonnementet er under behandling',
  success_message: 'Abonnementet ble avbrutt suksessfullt',
  reactivate_success_message: 'Abonnementet er reaktivert',
  choose_plan: 'Velg en plan før du abonnerer',
  canceling_waite_message: 'Avbryting av abonnement pågår, vennligst vent…',
  subscription_overview: 'Abonnementets oversikt',
  users: 'Medlemmer',
  for_members: 'For {user} medlemmer',
  for_member: 'For {user} medlem',
  for_6_members: 'For {user} eller flere',
  billing_cycle: 'Faktureringssyklus',
  amount: 'Beløp',
  cancelSubscriptionInfo:
    'Abonnementet avsluttes ved sluttdatoen og går over til gratisplan. Du kan starte igjen når som helst.',
  confirm_billing_cycle: 'Lagre endringer',
  different_cycle: 'Velg en annen faktureringssyklus',
  update_billing: 'Faktureringssyklus er oppdatert',
  waiting_update_billing_cycle: 'Ett øyeblikk, oppdaterer faktureringssyklus…',
  add_members_message: 'Medlemmer er lagt til',
  remove_members_message: 'Medlemmer er fjernet',
  your_current_plan: 'Din nåværende plan',
  upgrade_to: 'Oppgrader til {planName}',
  downgrade_to: 'Nedgrader til {planName}',
  members_removed: 'Abonnementsmedlem er fjernet',
  invitation_removed: 'Invitasjonsmedlem er fjernet',
  mann: 'Mann',
  kvinne: 'Kvinne',
  annen: 'Annet',
  life_page_description: 'Her finner du gravene dine og Mitt Lys.',
  settings: 'Innstillinger',
  settings_description: 'Kontoopplysninger som passord, medlemskap og person.',
  logout: 'Logg ut',
  logout_description: 'Gjør noe fint. Et blikk. Et smil. Et ord. Ditt lys betyr noe.',
  logout_success: 'Du er nå logget ut.',
  create_new_grave: 'Opprett ny grav',
  create_grave_description: 'Opprett en ny gravpost for en avdød i registeret.',
  new: 'Ny',
  read: 'Lest',
  empty_notification_message: 'Nye varsler vises her',
  public_anniversaries: 'Offentlige merkedager',
  grave_anniversaries: 'Merkedager',
  public_anniversary: 'Offentlig merkedag',
  grave_anniversary: 'Personlig merkedag',
  anniversary: 'Merkedag',
  birthday_event: 'Fødselsdag',
  death_anniversary_event: 'Dødsdag',
  memorial_days: 'Merkedager',
  anniversary_delete: 'Merkedagen er slettet.',
  anniversary_created: 'Merkedagen er opprettet.',
  anniversary_updated: 'Merkedagen er oppdatert.',
  empty_anniversaries: 'Ingen merkedager er opprettet.',
  anniversaries_today: 'I dag',
  anniversaries_upcoming: 'Kommende',
  anniversaries_past: 'Tidligere',
  anniversaries_past_empty: 'Ingen tidligere merkedager ennå.',
  anniversaries_personal: 'Dine merkedager',
  anniversaries_personal_empty: 'Du har ikke lagt til egne merkedager ennå.',
  anniversaries_personal_login: 'Logg inn for å legge til egne dager.',
  anniversaries_care_title: 'Omsorg over tid',
  anniversaries_care_body:
    'Lys og gravstell kan ivaretas på merkedager, også når ingen er i nærheten.',
  anniversaries_care_soon: 'Kommer snart',
  anniversaries_focus_title: 'Denne dagen',
  anniversaries_focus_today: 'Tenn et lys i dag for å være nær.',
  anniversaries_focus_future: 'Lys kan bestilles for denne dagen.',
  anniversaries_focus_future_scheduled:
    '{count, plural, one {# lys er bestilt for denne dagen.} other {# lys er bestilt for denne dagen.}}',
  anniversaries_focus_future_scheduled_self: 'Du har bestilt lys for denne dagen.',
  anniversaries_focus_future_cta: 'Bestill lys',
  anniversaries_focus_future_tooltip: 'Kommer snart',
  anniversaries_focus_past: 'Denne dagen ligger bak oss. Minnet består.',
  anniversaries_focus_empty: 'Velg en merkedag for å se detaljer.',
  anniversaries_recurring_note: 'Årlig · {year}',
  anniversaries_show_all: 'Vis alle',
  anniversaries_show_less: 'Vis færre',
  candles_now: 'Lys nå',
  candles_on_selected_day: 'Lys denne dagen',
  candles_on_selected_day_empty: 'Ingen lys denne dagen.',
  schedule_candle: 'Bestill lys',
  schedule_candle_cta: 'Bestill',
  scheduled_gift_context_label: 'Bestiller for',
  scheduled_gift_created: 'Lyset er bestilt.',
  scheduled_gift_error: 'Kunne ikke bestille lys.',
  scheduled_gift_load_error: 'Kunne ikke hente bestilte lys akkurat nå.',
  quiet_presence_count: 'Stille merker · {count}',
  quiet_presence_zero: 'Ingen stille merker ennå',
  quiet_presence_return: 'Du har vært her før',
  calendar_today_with_date: 'I dag, {date}',
  calendar_today: 'I dag',
  calendar_tomorrow: 'I morgen',
  calendar_upcoming: 'Kommende',
  calendar_month: 'Måned',
  calendar_week: 'Uke',
  calendar_day: 'Dag',
  weekday_short_0: 'Søn',
  weekday_short_1: 'Man',
  weekday_short_2: 'Tir',
  weekday_short_3: 'Ons',
  weekday_short_4: 'Tor',
  weekday_short_5: 'Fre',
  weekday_short_6: 'Lør',
  create: 'Opprett',
  add_dates: 'Legg til datoer',
  date: 'Dato',
  time: 'Tid',
  title: 'Tittel',
  reset_time: 'Tilbakestill tid',
  home: 'Hjem',
  about: 'Om',
  howTo: 'Hvordan',
  plans: 'Planer',
  find_a_grave: 'Finn en grav',
  create_a_grave: 'Opprett en grav',
  take_control: 'Ta kontroll over graven',
  pricing: 'Priser',
  get_started: 'Kom i gang',
  create_new_account: 'Opprett din egen konto.',
  did_you_know: 'Visste du at',
  registration_description_one:
    'Her er det ingen gravleie eller gravstell. Du trenger ikke tenke på vedlikehold. Nettgrav tar vare på det ytre – du tar vare på det indre.',
  registration_description_two:
    'En grav å ta med seg i livet. Det å huske noen, er også en måte å elske på.',
  registration_description_three: 'Du trenger ikke å prestere her. Det er nok å være til stede.',
  enter_your_password: 'Skriv inn passordet ditt',
  confirm_your_password: 'Bekreft passordet ditt',
  type_your_email: 'Skriv inn e-postadressen din',
  type_email: 'Skriv inn e-post',
  hi: 'Hei {name}',
  dream_world_question: 'Hvordan ser din drømmeverden ut?',
  decline: 'Avslå',
  read_only: '(kun lesing)',
  accept: 'Godta',
  accepted_message: 'Invitasjonen er akseptert',
  invited_title: 'Du er invitert til et abonnement',
  open: 'Åpne',
  subscription_invitation_message: 'Du er invitert til {subscription}-abonnement fra {name}',
  email_error: 'Vennligst skriv inn en gyldig e-post',
  password_length: 'Bruk minst 8 tegn, med store og små bokstaver og tall.',
  filled_out: 'Fyll inn alle feltene for å fortsette.',
  must_agree: 'Godta vilkårene for å fortsette.',
  inactive: 'Inaktiv',
  delete_payment_method: 'Sletter betalingsmetode, vennligst vent…',
  payment_method_deleted: 'Betalingsmetoden er slettet',
  payment_method_inactive:
    'Din nåværende betalingsmetode er enten slettet eller ikke lenger aktiv.',
  subscription_changes_title: 'Du har bedt om disse endringene i abonnementet.',
  period: 'Du ba om å nedgradere faktureringssyklusen fra {month} {previous} til {newMonth} {new}',
  user_count: 'Du ba om å redusere antall medlemmer fra {previous} til {new}',
  product_id: 'Du ba om å nedgradere planen fra {previous} til {new}',
  remove_subscription_change: 'Den forespurte endringen er reversert',
  remove_subscription_loading: 'Vennligst vent, forespørselen behandles…',
  revert: 'Reverser',
  subscription_changes_subTitle:
    'Endringene trer i kraft etter at din nåværende faktureringssyklus avsluttes den {date}',
  add_new_paymentMethod: 'Legg til betalingsmetode',
  filled_out_info: 'Pass på at du har fylt ut alle feltene i skjemaet før du fortsetter',
  continue_new_card: 'Velg en betalingsmetode eller legg til nytt kort for å fortsette',
  create_payment_method_waiting: 'Oppretter betalingsmetode. Vennligst vent…',
  login_description: 'Nærhet til de døde og til livet på nettgrav.no. Følg Gnisten din.',
  login_with_email: 'Logg inn med e-post',
  login_with_phone: 'Logg inn med telefonnummer',
  account_created: 'Velkommen. Kontoen din er opprettet',
  verify_account: 'E-posten er ikke bekreftet',
  verification_message:
    'For å logge inn, bekreft e-posten din. Sjekk innboksen eller søppelpost, eller be om ny e-post:',
  resend_email: 'Send bekreftelses-e-post på nytt',
  sending_verification_email: 'Sjekk innboksen for verifiserings-e-post',
  sending_verification_code: 'Verifiseringskode er sendt til telefonnummeret ditt.',
  sending_verification_waiting: 'Verifiseringskode sendes, vennligst vent…',
  email_verification:
    'Vi har sendt en verifiserings-e-post. Sjekk innboksen og klikk linken for å verifisere e-posten.',
  signup_step_title: 'Bekreft e-posten din',
  signup_relation_ready:
    'Relasjonen er klar — vi kobler deg til {name} så snart e-posten er bekreftet.',
  signup_message_heading: 'Bekreft e-posten din',
  signup_message_subheading: 'For å fullføre må du bekrefte e-posten din.',
  signup_primary_cta: 'Vi har sendt en bekreftelseslenke til {email}',
  signup_secondary_cta: 'Når du åpner lenken, blir du automatisk logget inn.',
  signup_secondary_cta_relation:
    'Når du åpner lenken, blir du automatisk logget inn – og relasjonen blir knyttet.',
  signup_help_text: 'Finner du ikke e-posten? Sjekk søppelpost eller send lenken på nytt.',
  signup_verification_reason: 'Dette gjør vi for å sikre riktig tilgang.',
  signup_primary_action: '🕊 Venter på e-postbekreftelse …',
  signup_resend_action: 'Send lenken på nytt',
  signup_save_email: 'Lagre e-post',
  signup_cancel_email: 'Avbryt',
  signup_email_updated: 'E-posten er oppdatert. Ny lenke er sendt.',
  signup_verification_refresh_hint: 'Verifisert – oppdaterer…',
  signup_change_email: 'Endre e-post',
  signup_login_action: 'Gå til innlogging',
  signup_resend_toast: 'Bekreftelses-e-posten er sendt på nytt.',
  signup_waiting_cta: 'Avventer bekreftelse',
  signup_delivery_status_label: 'E-poststatus:',
  grave_guest_visit_title: 'Besøk graven',
  grave_guest_visit_body: 'Her kan du lese, se hvem som hører til og være til stede rundt {name}.',
  grave_guest_visit_support: 'Logg inn for å knytte deg til graven og følge med videre.',
  grave_guest_visit_primary: 'Knytt deg til graven',
  signup_delivery_status_sending: 'Sender e-post …',
  signup_delivery_status_sent: 'E-posten er sendt fra oss. Venter på leveringsbekreftelse.',
  signup_delivery_status_delivered: 'E-posten er levert.',
  signup_delivery_status_temporary_failure:
    'Vi klarte ikke å levere e-posten akkurat nå. Prøv igjen om litt.',
  signup_delivery_status_temp_over_quota:
    'E-posten kom ikke frem nå fordi innboksen er full. Prøv igjen om litt.',
  signup_delivery_status_permanent_failure:
    'E-posten kunne ikke leveres. Sjekk adressen eller bruk en annen e-post.',
  signup_login_inline: 'Har du allerede konto? Logg inn',
  relation_gender_mismatch: 'Relasjonen passer ikke valgt kjønn. Velg på nytt.',
  waiting_for_account: 'Vi oppretter kontoen din. Vennligst vent…',
  account_verification_waiting: 'Vennligst vent, kontoverifisering pågår…',
  account_verification_heading: 'Konto verifisert!',
  account_verification_heading_error: 'Verifisering mislyktes',
  account_verification_description: 'Kontoen din er verifisert.',
  account_verification_description_error:
    'Klarte ikke verifisere konto. Prøv igjen eller kontakt support.',
  update_payment_method_waiting: 'Oppdaterer betalingsmetode. Vennligst vent…',
  update_payment_method_success: 'Betalingsmetode oppdatert!',
  warning_payment_method: 'Velg en ny betalingsmetode',
  complete_pending_payment: 'Vennligst fullfør betalingen.',
  plans_card_payment_method: 'Se betalingsvalg her:',
  forgot_password_heading: 'Trenger du hjelp med passordet?',
  forgot_password_description: 'Skriv inn e-postadressen din, så sender vi en lenke.',
  forgot_password_button: 'Send lenke',
  forgot_password_message: 'Vi har sendt en lenke til e-posten din. Sjekk innboks eller spam.',
  forgot_password_title: 'Lenke sendt',
  forgot_password_waiting: 'Sender lenke…',
  set_new_password: 'Sett nytt passord',
  set_new_password_description: 'Skriv inn et nytt passord. Etter bekreftelse kan du logge inn.',
  set_new_password_error: 'Vennligst skriv inn passord',
  set_new_password_success: 'Passord oppdatert!',
  set_new_password_waiting: 'Oppdaterer passord…',
  action_required: 'Handling kreves:',
  email_verification_alert:
    'Legg til og verifiser e-post for å fortsette innlogging. Uverifiserte kontoer kan ikke logge inn.',
  goTo_settings_page: 'Gå til innstillinger',
  go_to_home_page: 'Gå til startsiden',
  verify_now: 'Verifiser nå',
  authCode_verified: 'Telefonnummer verifisert!',
  personal_information_updated: 'Personlig informasjon oppdatert',
  change_phone_number: 'Endre telefonnummer',
  verify_phone_button: 'Verify phone number',
  change_email: 'Endre e-post',
  current_email: 'Nåværende e-post',
  new_email: 'Ny e-post',
  verify_email_button: 'Verify email',
  change_email_btn: 'Endre e-post',
  change_password: 'Endre passord',
  change_password_btn: 'Endre passord',
  reset_date: 'Tilbakestill dato',
  date_picker_day_label: 'Dag',
  date_picker_month_label: 'Måned',
  date_picker_year_label: 'År',
  date_picker_day_placeholder: 'Velg dag',
  date_picker_month_placeholder: 'Velg måned',
  date_picker_year_placeholder: 'Velg år',
  date_picker_search_placeholder: 'Søk…',
  date_picker_no_results: 'Ingen treff',
  date_picker_clear: 'Tøm valg',
  sending_verification_email_waiting: 'Link sendt til e-post—vent…',
  local_name: 'Lokalt navn',
  create_anniversary_waiting: 'Oppretter merkedag… vennligst vent',
  anniversary_time_end: 'Arrangementet er avsluttet',
  hello: 'Hei',
  coins: 'Mynter',
  store: 'Nærvær',
  purchase: 'Kjøp',
  checkout_title: 'Fullfør valget',
  checkout_billing_address: 'Fakturaadresse',
  checkout_billing_name_label: 'Fullt navn',
  checkout_billing_name_placeholder: 'Fullt navn',
  checkout_billing_email_label: 'E-post',
  checkout_billing_email_placeholder: 'E-post',
  checkout_billing_phone_label: 'Telefonnummer',
  checkout_billing_phone_placeholder: 'Telefonnummer',
  checkout_billing_street_label: 'Gateadresse',
  checkout_billing_street_placeholder: 'Gateadresse',
  checkout_billing_city_label: 'By',
  checkout_billing_city_placeholder: 'By',
  checkout_billing_state_label: 'Kommune',
  checkout_billing_state_placeholder: 'Kommune',
  checkout_billing_postal_label: 'Postnummer',
  checkout_billing_postal_placeholder: 'Postnummer',
  checkout_billing_country_label: 'Land',
  checkout_billing_country_placeholder: 'Velg land',
  checkout_card_details: 'Kortdetaljer',
  checkout_card_number_label: 'Kortnummer',
  checkout_card_number_placeholder: '1234 1234 1234 1234',
  checkout_card_expiration_label: 'Utløpsdato',
  checkout_card_expiration_placeholder: 'MM / ÅÅ',
  partner_card_expiration: 'Utløpsdato',
  checkout_card_cvc_label: 'Sikkerhetskode',
  checkout_card_cvc_placeholder: 'CVC',
  checkout_payment_unavailable: 'Betalingstjenesten er ikke klar. Prøv igjen.',
  checkout_missing_card_details: 'Skriv inn kortnummeret for å fortsette.',
  checkout_missing_card_expiry: 'Skriv inn utløpsdatoen.',
  checkout_missing_card_cvc: 'Skriv inn CVC-koden.',
  checkout_saved_payment_methods: 'Betalingsmetode',
  checkout_add_new_payment: 'Legg til betalingsmetode',
  checkout_notice_banner_title: 'Gave til familien',
  checkout_notice_banner_body:
    'Denne bestillingen knyttes til annonsen{hasName, select, true { for {name}} false {}}.',
  checkout_cart_title: 'Ditt valg',
  checkout_subtotal: 'Sum',
  checkout_total: 'Totalt',
  checkout_checkout: 'Bekreft valget',
  checkout_complete_purchase: 'Bekreft valget',
  checkout_pay_amount: 'Betal {amount}',
  bonus_tc: 'Bonus TC',
  set_color: 'Hvilken farge har du i dag?',
  set_color_button: 'Velg fargen din',
  sparks: 'Gnister',
  community: 'Fellesskap',
  purpose: 'Formål',
  talents: 'Talenter',
  profile_image_changed: 'Bilde oppdatert',
  cover_photo_updated: 'Oversiktsbildet er oppdatert.',
  cover_photo_removed: 'Oversiktsbildet er fjernet.',
  edit_cover_photo: 'Rediger oversiktsbilde',
  waiting_profile_upload: 'Oppdaterer profilbilde… vennligst vent',
  graves: 'De jeg bærer med meg',
  'cemeteryLanding.title': '{cemetery}',
  wisdom: 'Visdom',
  sparks_description: 'Del din Gnist som kan tenne lys og spre varme.',
  text_area_placeholder: 'Hvordan kan du lyse opp noens vei?',
  crop_image: 'Beskjær bilde',
  recurring_anniversary: 'Gjenta hvert år',
  nick_name: 'Kallenavn',
  birth_name: 'Fødenavn',
  date_of_birth: 'Fødselsdato',
  date_of_death: 'Dødsdato',
  time_of_birth: 'Fødselstid',
  time_of_death: 'Dødstid',
  place_of_birth: 'Fødested',
  place_of_death: 'Dødssted',
  cause_of_death: 'Dødsårsak',
  municipality: 'Kommune',
  country: 'Land',
  cemetery: 'Kirkegård',
  grave_number: 'Gravnummer',
  grave_info_updating: 'Oppdaterer gravedata… vennligst vent',
  deceased_name: 'Navn',
  deceased_placeholder: 'Skriv inn navnet på den avdøde',
  deceased_gender: 'Kjønn',
  i_am: 'Jeg er',
  buried_is_mine: 'Den avdøde var min',
  select_relationship: 'Velg relasjon',
  upload_document: 'Last opp dokument for graven',
  upload_document_description: 'Velg hvilket dokument du vil laste opp:',
  death_certificate: 'Dødsattest',
  birth_certificate: 'Fødselsattest',
  invoice: 'Kvittering for gravstell eller leie',
  power_of_attorney: 'Fullmakt',
  driving_license: 'Legitimasjon for den avdøde',
  proof_of_person: 'Last opp dokument om den avdøde',
  proof_of_person_description: 'Dokumentet kan være PDF, PNG eller JPG og maks. 5 MB',
  replace_files: 'Erstatt filer',
  browse_files: 'Finn filen din',
  drag_image: 'eller dra filen hit',
  dear: 'Kjære',
  new_grave_first_description: 'Velkommen til å opprette en ny Nettgrav.',
  new_grave_second_description: 'Her kan du opprette en trygg og respektfull grav.',
  new_grave_third_description:
    'Ved å opprette en Nettgrav bekrefter du at du har tillatelse til dette for den avdøde.',
  new_grave_fourth_description: "Klikk 'Godta' for å fortsette.",
  new_grave_agree_terms: 'Jeg godtar vilkårene ovenfor',
  enter_name_error: 'Vennligst skriv inn personens navn',
  select_gender_error: 'Velg kjønn for personen.',
  select_relation_error: 'Velg din relasjon til personen.',
  select_date_error: 'Vennligst velg en dato',
  select_reason_error: 'Vennligst velg en dødsårsak',
  reason_of_death: 'Dødsårsak',
  other_reason: 'Skriv inn annen dødsårsak',
  other_reason_error: 'Vennligst skriv inn annen dødsårsak',
  select_country: 'Velg land',
  select_municipality: 'Velg kommune',
  select_cemetery: 'Velg kirkegård',
  select_country_error: 'Vennligst velg et land',
  select_municipality_error: 'Vennligst velg en kommune',
  select_cemetery_error: 'Vennligst velg en kirkegård',
  create_the_grave: 'Opprett graven',
  create_the_message: 'Oppretter grav… vennligst vent',
  death_date_error: 'Vennligst velg en gyldig dødsdato',
  birth_date_error: 'Vennligst velg en gyldig fødselsdato',
  month_0: 'januar',
  month_1: 'februar',
  month_2: 'mars',
  month_3: 'april',
  month_4: 'mai',
  month_5: 'juni',
  month_6: 'juli',
  month_7: 'august',
  month_8: 'september',
  month_9: 'oktober',
  month_10: 'november',
  month_11: 'desember',
  unknown_year: 'Ukjent år',
  unknown_month: 'Ukjent måned',
  'life.unknown_month': 'Ukjent måned',
  weekday_0: 'søndag',
  weekday_1: 'mandag',
  weekday_2: 'tirsdag',
  weekday_3: 'onsdag',
  weekday_4: 'torsdag',
  weekday_5: 'fredag',
  weekday_6: 'lørdag',
  father: 'Far',
  mother: 'Mor',
  son: 'Sønn',
  husband: 'Ektemann',
  wife: 'Kone',
  brother: 'Bror',
  sister: 'Søster',
  maternal_grandfather: 'Morfar',
  maternal_grandmother: 'Mormor',
  paternal_grandfather: 'Farfar',
  paternal_grandmother: 'Farmor',
  maternal_uncle: 'Morbror',
  maternal_aunt: 'Tante (mors side)',
  paternal_uncle: 'Farbror',
  paternal_aunt: 'Tante (fars side)',
  farfar: 'Farfar',
  morfar: 'Morfar',
  farmor: 'Farmor',
  mormor: 'Mormor',
  grandfather: 'Bestefar',
  grandmother: 'Bestemor',
  grandchild: 'Barnebarn',
  grandson: 'Barnebarn',
  granddaughter: 'Barnebarn',
  uncle: 'Onkel',
  uncle_child: 'Søskenbarn',
  aunt: 'Tante',
  aunt_child: 'Søskenbarn',
  nephew: 'Nevø',
  niece: 'Niese',
  cousin: 'Søskenbarn',
  aunt_husband: 'Tantes ektemann',
  uncle_wife: 'Onkels kone',
  cousin_wife: 'Søskenbarns ektefelle',
  cousin_husband: 'Søskenbarns ektefelle',
  stepbrother: 'Stebror',
  stepsister: 'Stesøster',
  stepfather: 'Stefar',
  stepmother: 'Stemor',
  stepson: 'Stesønn',
  stepdaughter: 'Stedatter',
  father_in_law: 'Svigerfar',
  mother_in_law: 'Svigermor',
  brother_in_law: 'Svoger',
  sister_in_law: 'Svigerinne',
  son_in_law: 'Svigersønn',
  daughter_in_law: 'Svigerdatter',
  self: 'Meg',
  parent: 'Forelder',
  child: 'Barn',
  sibling: 'Søsken',
  spouse: 'Ektefelle',
  grandparent: 'Besteforelder',
  great_grandparent: 'Oldeforelder',
  great_grandchild: 'Oldebarn',
  great_great_grandparent: 'Tipp-oldeforelder',
  great_great_grandchild: 'Tipp-oldebarn',
  great_great_great_grandparent: 'Tipp-tipp-oldeforelder',
  great_great_great_grandchild: 'Tipp-tipp-oldebarn',
  aunt_or_uncle: 'Tante/Onkel',
  great_uncle: 'Grandonkel',
  great_aunt: 'Grandtante',
  great_aunt_or_uncle: 'Grandtante/Grandonkel',
  nibling: 'Niese/Nevø',
  grand_niece: 'Grandniese',
  grand_nephew: 'Grandnevø',
  grand_nibling: 'Grandniese/Grandnevø',
  great_niece: 'Oldeniese',
  great_nephew: 'Oldenevø',
  great_nibling: 'Oldeniese/Oldenevø',
  cousin_in_law: 'Inngiftet søskenbarn',
  aunt_in_law: 'Svigertante',
  uncle_in_law: 'Svigeronkel',
  first_cousin_in_law: 'Inngiftet søskenbarn',
  uncle_in_law_son: 'Svigeronkelens sønn',
  first_cousin: 'Første søskenbarn',
  first_cousin_once_removed: 'Første søskenbarn én gang forskjøvet',
  first_cousin_twice_removed: 'Første søskenbarn to ganger forskjøvet',
  second_cousin: 'Andre søskenbarn',
  second_cousin_once_removed: 'Andre søskenbarn én gang forskjøvet',
  second_cousin_twice_removed: 'Andre søskenbarn to ganger forskjøvet',
  third_cousin: 'Tredje søskenbarn',
  third_cousin_once_removed: 'Tredje søskenbarn én gang forskjøvet',
  third_cousin_twice_removed: 'Tredje søskenbarn to ganger forskjøvet',
  aunt_uncle_in_law: 'Inngiftet tante/onkel',
  nibling_in_law: 'Inngiftet niese/nevø',
  niece_in_law: 'Inngiftet niese',
  nephew_in_law: 'Inngiftet nevø',
  parent_in_law: 'Svigerforelder',
  child_in_law: 'Svigerbarn',
  sibling_in_law: 'Svigersøsken',
  grandparent_in_law: 'Svigerbesteforelder',
  grandchild_in_law: 'Svigerbarnebarn',
  step_parent: 'Steforelder',
  step_mother: 'Stemor',
  step_father: 'Stefar',
  step_child: 'Stebarn',
  step_daughter: 'Stedatter',
  step_son: 'Stesønn',
  step_sibling: 'Stesøsken',
  step_sister: 'Stesøster',
  step_brother: 'Stebror',
  boyfriend: 'Kjæreste',
  girlfriend: 'Kjæreste',
  adopt_son: 'Adoptivsønn',
  adopt_daughter: 'Adoptivdatter',
  adopted_son: 'Adoptivsønn',
  adopted_daughter: 'Adoptivdatter',
  moons: 'Måner',
  my_moons: 'Mine måner',
  has_you_as_moon: 'Har deg som måne',
  moons_empty_title: 'Ingen måner ennå.',
  moons_empty_description: 'En måne er en person som har veiledet deg. En du lar deg lede av.',
  friends: 'Venner',
  friends_and_family: 'Familie og venner',
  colleagues: 'Kollegaer',
  friend: 'Venn',
  other: 'Annet',
  daughter: 'Datter',
  partner: 'Partner',
  relation_category_parent: 'Forelder',
  relation_category_child: 'Barn',
  relation_category_partner: 'Partner',
  relation_category_sibling: 'Søsken',
  relation_category_grandparent: 'Besteforelder',
  relation_category_aunt_uncle: 'Onkel/Tante',
  relation_quick_pick_hint: 'Valget er forhåndsutfylt. Bekreft eller bytt.',
  relation_quick_pick_parent_choose: 'Velg Mor eller Far.',
  relation_quick_pick_sibling_choose: 'Velg Bror eller Søster.',
  relation_quick_pick_child_choose: 'Velg Sønn eller Datter.',
  open_details: 'Åpne detalj',
  colleague: 'Kollega',
  great_granddaughter: 'Oldebarn',
  great_grandson: 'Oldebarn',
  great_grandmother: 'Oldemor',
  great_grandfather: 'Oldefar',
  great_great_granddaughter: 'Tipp-oldebarn',
  great_great_grandson: 'Tipp-oldebarn',
  great_great_grandmother: 'Tipp-oldemor',
  great_great_grandfather: 'Tipp-oldefar',
  great_great_great_granddaughter: 'Tipp-tipp-oldebarn',
  great_great_great_grandson: 'Tipp-tipp-oldebarn',
  great_great_great_grandmother: 'Tipp-tipp-oldemor',
  great_great_great_grandfather: 'Tipp-tipp-oldefar',
  cohabitant: 'Samboer',
  contact_person: 'Din kontaktperson',
  monthly: 'Månedlig',
  semi_annual: 'Halvårlig',
  annually: 'Årlig',
  biennial: 'Hvert annet år',
  auth_modal_description:
    'Logg inn eller opprett en gratis konto for å besøke graver og bruke alle funksjoner.',
  auth_modal_heading: 'Logg inn | Opprett konto',
  active: 'Aktiv',
  requested_to_remove: 'Forespørsel om fjerning',
  manage_members: 'Administrer medlemmer',
  remove_members_warning: 'Fjern medlemmer eller senk antallet for å fortsette.',
  subscription_base_price: 'Grunnpris',
  membership: 'medlemskap',
  remove_all_grave_user: 'Viktig: Oppdatering av gravadministrasjon',
  remove_all_grave_user_message:
    'Behold minst én person eller administrator tilknyttet. For å fjerne alle, overfør eierskap eller slett graven.',
  send_it: 'Send',
  public_view: 'Offentlig visning',
  spark_posting_to_privacy: 'Synlig for {privacy}',
  constellation: 'Stjernebilde',
  moons_only: 'Kun måner',
  form: 'Uttrykk',
  state_of_mind: 'Tilstand (væremåte)',
  spark_state_of_mind_info:
    'Velg din tilstand (væremåte). Den preger hvordan gnisten din blir mottatt.',
  spark_state_of_mind_info_label: 'Info om sinnsstemning',
  spark_form_info_label: 'Info om uttrykk',
  spark_remove_link_preview_to_add_media: 'Fjern lenkeforhåndsvisningen for å legge til media.',
  taggable_composer_type_to_tag: 'Skriv et navn for å tagge',
  taggable_composer_no_matches: 'Ingen treff',
  taggable_composer_clear: 'Tøm',
  question: 'spørsmål',
  insight: 'innsikt',
  experience: 'erfaring',
  discovery: 'oppdagelse',
  feeling: 'følelse',
  value: 'verdi',
  energy: 'energi',
  select_category: 'Velg kategori',
  spark_delete: 'Gnist slettet',
  spark_create: 'Gnist opprettet',
  spark_update: 'Gnist oppdatert',
  ENG: 'Engelsk',
  NOR: 'Norsk',
  loading: 'Laster…',
  in_your_mind: 'Del en tanke, et spørsmål eller en erfaring…',
  spark_reflection_placeholder:
    'Svar med det denne gnisten vekker i deg – refleksjon, håp eller forbindelse.',
  create_spark: 'Skap Gnist',
  reflect_on_spark: 'Reflect on Spark',
  empty_graves:
    'Bruk søkefeltet øverst til venstre for å finne en grav du har tilknytning til. Når relasjonen er satt, vises graven her.',
  all: 'Alle',
  owner: 'Eier',
  affiliated: 'Tilknyttet',
  view_all: 'Vis alle',
  close_relation: 'Når du legger til noen, vises de her.',
  no_relation_set: 'Ingen relasjoner er satt',
  love_ones: 'De som går med {name}',
  set_relation: 'Velg din relasjon',
  relation_request_send: 'Relasjonsforespørsel sendt',
  relation_updated_success: 'Relasjonen er oppdatert.',
  relation_update_failed: 'Kunne ikke oppdatere relasjonen.',
  relation_removed_success: 'Relasjonen er fjernet.',
  relation_remove_failed: 'Kunne ikke fjerne relasjonen.',
  relation_connection: '{name} er min {reciprocalRelation}, og jeg er {name}s {relation}.',
  request_send: 'Forespørsel sendt',
  empty_sparks: 'Ingen gnister tilgjengelig, opprett en ny',
  'sparks.empty_stars':
    'Ingen gnister har blitt stjerner ennå. Når en gnist blir til en stjerne, vises den her.',
  create_post: 'Gravveggen · {graveName}',
  grave_wall_cta_primary: 'Legg igjen ordene',
  grave_wall_cta_secondary: 'Lukk',
  post: 'Publiser',
  update_post: 'Oppdater innlegg',
  account_heading: 'Slett Nettgrav-kontoen din',
  delete_account: 'Slett min konto',
  delete_account_pending: 'Kontosletting pågår',
  deleted_message_pending:
    'Søknad om sletting sendt. Konto og data slettes. Du kan avbryte innen kl. 23:50 i dag. Spørsmål? kontakt@nettgrav.no.',
  deleted_message:
    'Når du sletter kontoen din, blir innhold og tilknytninger fjernet fra Nettgrav. Slettingen skjer etter kl. 23:50 og kan ikke angres. Ta gjerne kontakt med oss på kontakt@nettgrav.no dersom du har spørsmål.',
  confirm_delete_account: 'Dette sletter kontoen og alt innhold.',
  confirm_cancel_account: 'Dette stopper slettingen og beholder kontoen.',
  account_delete_confirm_button: 'Fjern konto',
  account_delete_cancel_button: 'Behold konto',
  account_cancel_delete_confirm_button: 'Stopp sletting',
  account_cancel_delete_cancel_button: 'Behold konto',
  phone_number_error: 'Telefonnummer/passord stemmer ikke',
  email_error_login: 'E-post og passord stemmer ikke.',
  set_relation_heading: 'Knytt til graven',
  set_relation_free_description: 'Fortell oss hvem {graveName} er for deg for tilgang til graven.',
  set_relation_access: 'Som medlem kan du:',
  do_you_know: 'Hvem er {graveName} for deg?',
  set_relation_description: 'Send forespørsel om å bli medlem som slektning, venn eller velgjører',
  set_relation_info_message:
    'Gratiskontoer blir bedt om å betale 2 $/mnd når du klikker “Bekreft og bli medlem”.',
  click_button_below: 'Velg relasjon for å fortsette.',
  feature_title_1: 'Minnealbum',
  feature_description_1: 'Legg til bilder av din kjære og familie.',
  feature_title_2: 'Minnevegg',
  feature_description_2: 'Les og del minner med andre som kjente dem.',
  feature_title_3: 'Merkedagskalender',
  feature_description_3: 'Få påminnelser om viktige dager.',
  feature_title_4: 'Verdikatalog',
  feature_description_4: 'Lagre viktige lærdommer den kjære ga deg.',
  feature_title_5: 'Livsarkiv',
  feature_description_5: 'Skriv ned historier om deres liv.',
  choose_relation: 'Velg relasjon',
  relation_label: 'Jeg er {grave}s',
  reciprocal_label: '{grave} er min',
  set_relation_note: 'Velg hvem den avdøde er for deg og gi graven et hjem her.',
  set_relation_other: 'For alle som kjente den avdøde. Enten kollega, fan eller annet.',
  set_relation_placeholder: 'For eksempel, jeg var venner med {grave} på universitetet i Oslo…',
  confirm_relation_member: 'Bekreft relasjon og bli medlem',
  pay_and_reactivate: 'Betal for å reaktivere medlemskap',
  confirm_membership: 'Bekreft medlemskap',
  enlightened: 'Opplyst',
  inspired: 'Inspirert',
  spark_reaction_add_wood: 'Legg på ved',
  spark_reaction_add_breath: 'Gi gnisten pust',
  spark_reaction_add_light: 'Tenn gnisten med lys',
  spark_reaction_add_wood_tooltip: 'Ved til gnisten',
  spark_reaction_add_breath_tooltip: 'Pust på gnisten',
  spark_reaction_add_light_tooltip: 'Lys for gnisten',
  spark_reaction_legacy: 'Tidligere reaksjoner',
  spark_stage_spark: 'Gnisten',
  spark_stage_campfire: 'Leirbål',
  spark_stage_star: 'Stjerne',
  'spark.openDetail': 'Åpne gnist',
  reflected: 'Reflektert',
  comments: 'svar',
  comment: 'svar',
  empty_comments: 'Ingen svar funnet',
  comment_placeholder: 'Skriv her…',
  reply: 'Svar',
  view_replies: 'Se alle {total} svar',
  create_grave_body: 'For å opprette en ny Nettgrav, trenger du et Conscious-medlemskap.',
  upgrade_modal_heading: 'Opprett ny grav',
  go_to: 'Gå til',
  our_plans: 'aktiver medlemskap',
  choose_the_subscription: 'for å få tilgang til alle funksjoner.',
  link_grave_body:
    'Så fint at du vil knytte de begravede sammen. For å gjøre det, trenger du Conscious-medlemskap.',
  add_more_images_body: 'For å legge til flere bilder i album, må du oppgradere abonnementet ditt.',
  inviting_body: 'Invitasjoner er tilgjengelig med Conscious-medlemskap.',
  life_archive_body: 'Livsarkivet er tilgjengelig med Conscious-medlemskap.',
  upload_images_body: 'For å legge til bilder, må du oppgradere ditt nåværende abonnement.',
  add_value_body:
    'Så fint at du vil legge til egenskap. For å legge til, trenger du Conscious-medlemskap.',
  search_limit_body:
    'Fordyp deg i Nettgrav med vår Conscious-plan. Oppgrader i dag for ubegrensede søk.',
  grave_invitation_first_text: 'Du har blitt invitert til å bidra til graven',
  of: 'av',
  grave_invitation_second_text: 'Her kan dere samle minner, bilder og merkedager sammen.',
  grave_email_info:
    'Denne e-posten er låst for denne invitasjonen. Hvis noe er feil, ta kontakt med den som inviterte deg.',
  subscription_email_info:
    'Denne e-posten er låst for dette abonnementet. Hvis noe er feil, kontakt den som satte det opp.',
  grave_invitation_message:
    '{name} har invitert deg til å bli med og ta vare på graven til {grave}.',
  accept_or_pay: 'Godta og betal',
  paid_grave_user_message:
    'Du er invitert av {userName} til å bli med i denne graven med et betalt abonnement. Godta invitasjonen for å bli med i dette eksklusive fellesskapet, eller avslå hvis det ikke passer nå. Velg ditt neste steg nedenfor!',
  unpaid_grave_user_message:
    'Du er invitert av {userName} til å bli med i denne graven. For å være en del av dette eksklusive fellesskapet, vennligst oppgrader til et betalt abonnement. Godta invitasjonen for å bli med, eller avslå hvis det ikke passer nå. Velg ditt neste steg nedenfor!',
  active_unpaid_grave_user_message:
    'Du har ikke et aktivt abonnement akkurat nå. Reaktiver abonnementet for å fortsette å bidra og forbli et aktivt medlem av fellesskapet. Klikk nedenfor for å fornye abonnementet ditt og gjøre en forskjell!',
  invite: 'Inviter',
  complete_relation_setup: 'Fullfør betalingen din for å bekrefte relasjonen',
  already_set_relation: 'Du har allerede satt relasjonen til graven {graveName} som {relation}.',
  already_accept_relation:
    'Du har allerede akseptert relasjonen til graven {graveName} som {relation}.',
  finalize_membership:
    'For å fullføre denne tilknytningen og låse opp alle medlemsfordelene, vennligst fullfør betalingen. Når dette er gjort, vil graven bli knyttet til livssiden din, og du får tilgang til:',
  click_below_to_complete:
    'Klikk knappen nedenfor for å fullføre betalingen og bekrefte relasjonen.',
  complete_payment: 'Fullfør betaling',
  awaiting_owner_approval: 'Venter på eierens godkjenning',
  awaiting_approval_message:
    'Eieren er varslet om forespørselen din. Vennligst vent på godkjenning eller avslag. Du blir oppdatert så snart de svarer.',
  subscribed_grave_invitation:
    'Du er invitert av {name} til å knytte deg til graven {graveName} som {relation}.',
  click_below_to_accept: 'Klikk knappen nedenfor for å godta invitasjonen og bekrefte relasjonen.',
  accept_invitation: 'Godta invitasjon',
  accept_invitation_payment: 'Godta og fullfør betaling',
  complete_invitation: 'Fullfør invitasjonen',
  unsubscribed_grave_invitation:
    'For å godta denne invitasjonen og fullføre tilknytningen, vennligst fullfør betalingsprosessen. Når bekreftet, får du tilgang til følgende eksklusive funksjoner:',
  you_are_invited: 'Du er invitert!',
  reclaim_user_access: 'Gjenopprett tilgangen din',
  previous_relation: 'Du var tidligere knyttet til {graveName} som {relation}.',
  downgrade_subscription:
    'Siden medlemskapet ditt er nedgradert til gratisplanen, er tilgangen til denne graven og funksjonene begrenset. Du er fortsatt anerkjent medlem av denne graven.',
  regain_access:
    'For å gjenvinne full tilgang og gjenopprette tilknytningen til graven, vennligst oppgrader medlemskapet ditt.',
  click_below_to_upgrade: 'Klikk knappen nedenfor for å oppgradere og gjenopprette tilgangen din.',
  upgrade_membership: 'Oppgrader medlemskap',
  set_self_relation: 'Fortell hvem {graveName} er for deg for å knytte til graven.',
  set_relation_linked: 'Når du gjør dette, kan du:',
  set_self_relation_1: 'Besøke graven når du trenger det.',
  set_self_relation_2: 'Bevare minner og familie.',
  set_self_relation_3: 'La graven gi mer mening i livet fremover.',
  set_self_relation_message: 'Viktig melding:',
  claim_grave_labe:
    'Jeg ønsker å være ansvarlig for denne graven. Merk av boksen for å gi oss beskjed.',
  claim_grave_terms_1: 'Velkommen til Nettgrav.',
  claim_grave_terms_2: 'Her kan du kreve en trygg og respektfull grav.',
  claim_grave_terms_3:
    'Ved å kreve en Nettgrav bekrefter du at du har tillatelse til dette for den avdøde.',
  claim_grave_terms_4:
    'Vanligvis er dette eier av den fysiske graven eller deres representant. Klikk “Godta” for å fortsette.',
  i_agreed_claim: 'Jeg godtar vilkårene ovenfor',
  upload_death_document: 'Last opp dødsattesten til personen siden gjelder.',
  upload_death_document_limit: 'Dokumentet kan være i PDF, PNG eller JPG og mindre enn 5 MB',
  drag_files: 'eller dra og slipp filen her',
  'grave.new.docs.header': 'Jeg er graveier/fester.',
  'grave.new.docs.upload_title': 'Last opp dokumentasjon',
  'grave.new.docs.upload_note': 'Format: PDF, PNG eller JPG (maks 5 MB).',
  'grave.new.docs.button': 'Last opp dokumentasjon',
  'grave.new.docs.drop_hint': 'Klikk eller dra filen hit',
  'grave.new.info.title': 'Ansvar for graven.',
  'grave.new.info.line1':
    'Når du går videre, bekrefter du at du har rett til å ivareta denne graven.',
  'grave.new.info.line2':
    'Dette gjelder vanligvis den som har ansvar for den fysiske graven, eller en som har fått fullmakt.',
  'grave.new.info.line3': 'Dokumentasjonen brukes kun til dette formålet.',
  'grave.new.accept_label': 'Jeg bekrefter at jeg har ansvar for denne graven',
  'grave.new.create_cta': 'Opprett grav',
  claim_grave_message: 'Har du ansvar for å ivareta denne graven?',
  claim_grave_document_helper: 'Dette brukes kun for å bekrefte ansvar for graven.',
  claim_guardian_info_title: 'Hva innebærer omsorgsansvar?',
  claim_guardian_info_lead: 'Å være verge betyr å ivareta graven og fellesskapet rundt den.',
  claim_guardian_info_bullet_relations: 'Godkjenne eller avvise relasjoner',
  claim_guardian_info_bullet_content: 'Administrere innhold på graven',
  claim_guardian_info_bullet_admins: 'Legge til eller fjerne administratorer',
  claim_guardian_info_note: 'Omsorgsansvar bekreftes med dokumentasjon.',
  take_ownership: 'Bli {firstName} sin verge',
  manage_grave: 'Forvalt graven',
  claim_request_queue:
    'Din forespørsel om å kreve graven {graveName} er sendt. Den venter nå på godkjenning. Du blir varslet når forespørselen er vurdert.',
  register_ownership: 'Registrer eierskap',
  public: 'Offentlig',
  moon: 'Måne',
  moon_set: 'Velg som min måne',
  moon_remove: 'Fjern måne',
  moon_remove_as_moon: 'Fjern som måne',
  moon_remove_confirm_moon:
    'Dette fjerner {username} som måne. Du kan legge {username} til igjen senere.',
  moon_remove_confirm_as_moon:
    'Dette fjerner deg som måne for {username}. Du kan velge på nytt senere.',
  moon_cancel_request: 'Avbryt forespørsel',
  moon_ping_cta: 'Gi et tegn',
  moon_request_sent: 'Måneforespørsel sendt.',
  moon_request_accepted: 'Måneinvitasjonen er akseptert.',
  moon_request_declined: 'Måneinvitasjonen er avslått.',
  moon_request_page_title: 'Invitasjon til månerelasjon',
  moon_request_page_subtitle: '{name} ønsker at du skal være deres måne.',
  moon_request_sign_in: 'Logg inn for å svare',
  moon_request_accept: 'Aksepter',
  moon_request_decline: 'Avslå',
  moon_request_already_handled: 'Denne invitasjonen er allerede behandlet.',
  moon_removed: 'Månen er fjernet.',
  moon_ping_sent: 'Signal sendt.',
  moon_ping_cta_sent: 'Tegn sendt',
  moon_ping_sent_hint: 'De får beskjed om at du er her for dem.',
  moon_ping_cooldown: 'Du har allerede gitt et tegn i dag. Du kan sende et nytt senere.',
  moon_helper_text_line_1: 'En måne er en person som har veiledet deg.',
  moon_helper_text_line_2: 'En du lar deg lede av.',
  moon_helper_text: 'En måne er en person som har veiledet deg. En du lar deg lede av.',
  own_words_tab: 'Mine egne ord',
  own_words_public_tab: 'Egne ord',
  own_words_title: 'Mine egne ord',
  own_words_subtitle:
    'Et sted for det du ønsker at andre skal forstå om deg mens dere kan snakke sammen.',
  own_words_prompts_title: 'Start med et spørsmål',
  own_words_prompt_1: 'Hva håper jeg at du forstår om meg?',
  own_words_prompt_2: 'Hva gir livet mitt retning?',
  own_words_prompt_3: 'Hva er vanskelig å si høyt?',
  own_words_prompt_4: 'Hva trenger jeg å sette ord på akkurat nå?',
  own_words_placeholder: 'Skriv med dine egne ord...',
  own_words_visibility_title: 'Hvem kan lese dette?',
  own_words_visibility_everyone: 'Alle på Nettgrav',
  own_words_self_only: 'Bare du kan lese dette før du velger en annen synlighet.',
  own_words_reader_invitation_title: 'Hvordan kan leseren møte ordene dine?',
  own_words_reader_invitation_help:
    'Valg med privat chat viser en meldingsknapp sammen med ordene.',
  own_words_reader_invitation_listen: 'Bare les',
  own_words_reader_invitation_ask: 'Spør meg i privat chat',
  own_words_reader_invitation_understand_together: 'Forstå sammen i privat chat',
  own_words_reader_invitation_keep: 'Ta vare på dette',
  own_words_publish: 'Del ordene',
  own_words_update: 'Oppdater',
  own_words_publish_success: 'Ordene dine er delt.',
  own_words_publish_needs_words: 'Skriv noen ord før du deler.',
  own_words_save_error: 'Kunne ikke lagre akkurat nå.',
  own_words_public_title: 'Med egne ord',
  own_words_public_subtitle: 'Ord {name} har skrevet og valgt å dele.',
  own_words_updated: 'Oppdatert {date}',
  own_words_chat_cta: 'Spør for å forstå',
  own_words_chat_ask_cta: 'Send privat melding',
  own_words_chat_understand_cta: 'Forstå sammen',
  own_words_chat_error: 'Samtalen kunne ikke åpnes akkurat nå.',
  after_me_tab: 'Etter meg',
  after_me_title: 'Etter meg',
  after_me_subtitle: 'Et sted for å gjøre valg og ønsker tydeligere.',
  after_me_intro_title: 'Hvis jeg ikke kan si dette selv en dag',
  after_me_intro_text: 'Du kan skrive lite eller mye. Du kan endre alt senere.',
  after_me_step_counter: 'Steg {current} av {total}',
  after_me_step_intentions_title: 'Hva vil du at dette skal gi?',
  after_me_step_words_title: 'Noe jeg vil at andre skal vite',
  after_me_step_legacy_title: 'Det som lever videre',
  after_me_words_help: 'Det trenger ikke være perfekt. Skriv det med dine egne ord.',
  after_me_writing_prompts_title: 'Start med et spørsmål',
  after_me_writing_prompt_1: 'Hva håper jeg at dere forstår om meg?',
  after_me_writing_prompt_2: 'Hva har gitt livet mitt retning?',
  after_me_writing_prompt_3: 'Hva håper jeg å gi videre?',
  after_me_writing_prompt_4: 'Hva bør de nærmeste mine vite?',
  after_me_public_tab: 'Egne ord',
  after_me_public_title: 'Det jeg ønsker dere skal vite om meg',
  after_me_public_subtitle: 'Ord skrevet av {name}, og delt på egne premisser.',
  after_me_public_intentions_title: 'Det jeg ønsker at dette skal gi',
  after_me_public_legacy_title: 'Det jeg håper å gi videre',
  after_me_public_choices_title: 'Mine valg',
  after_me_public_updated: 'Oppdatert {date}',
  after_me_public_chat_cta: 'Spør for å forstå',
  after_me_public_chat_error: 'Samtalen kunne ikke åpnes akkurat nå.',
  after_me_emotional_context_title: 'Hva kommer ordene fra?',
  after_me_emotional_context_help: 'Velg bare hvis det gjør ordene lettere å forstå.',
  after_me_emotional_context_vulnerable: 'Sårbarhet',
  after_me_emotional_context_grateful: 'Takknemlighet',
  after_me_emotional_context_hopeful: 'Håp',
  after_me_emotional_context_uncertain: 'Usikkerhet',
  after_me_emotional_context_peaceful: 'Ro',
  after_me_reader_invitation_title: 'Hvordan ønsker du å bli møtt?',
  after_me_reader_invitation_help: 'Gjør måten du ønsker å bli møtt på tydelig.',
  after_me_reader_invitation_listen: 'Bare lytt',
  after_me_reader_invitation_ask: 'Spør meg',
  after_me_reader_invitation_understand_together: 'Forstå sammen',
  after_me_reader_invitation_keep: 'Ta vare på dette',
  after_me_public_emotional_context_label: 'Ordene kommer fra',
  after_me_public_reader_invitation_label: 'Jeg ønsker å bli møtt med',
  after_me_legacy_help: 'Dette er valgfritt. Det kan gi retning for dem som står deg nær.',
  after_me_step_boundaries_title: 'Grenser',
  after_me_step_sharing_title: 'Hvem skal vite?',
  after_me_label_visibility: 'Hvem kan se dette?',
  after_me_label_activation_mode: 'Når skal dette bli synlig?',
  after_me_label_intentions: 'Hva vil du at dette skal gi?',
  after_me_label_message_text: 'Noe jeg vil at andre skal vite',
  after_me_label_grave_choice: 'Gravform',
  after_me_label_ceremony_choice: 'Hvordan ønsker du at seremonien skal være?',
  after_me_label_place_choice: 'Foretrukket sted',
  after_me_label_religious_preference: 'Ønsker du en religiøs ramme?',
  after_me_label_body_title: 'Kroppen',
  after_me_label_body_choice: 'Har du en preferanse for kremasjon eller kistegrav?',
  after_me_label_legacy_focus: 'Retning',
  after_me_label_legacy_reason: 'Hvis du vil, skriv én setning om hvorfor.',
  after_me_label_boundaries: 'Hva ønsker du ikke?',
  after_me_visibility_moons: 'Måner',
  after_me_visibility_family_friends: 'Familie og venner',
  after_me_visibility_self_only: 'Kun meg',
  after_me_activation_show_when_deceased: 'Vis hvis andre må ta valg på mine vegne',
  after_me_activation_visible_now: 'Synlig nå',
  after_me_intention_calm: 'Ro',
  after_me_intention_clarity: 'Tydelighet',
  after_me_intention_closeness: 'Nærhet',
  after_me_intention_calm_help: 'For at de nærmeste skal slippe å gjette.',
  after_me_intention_clarity_help: 'For at valgene dine skal være enkle å forstå.',
  after_me_intention_closeness_help: 'For at det som skjer, kan føles ekte.',
  after_me_choice_unsure: 'Usikker',
  after_me_choice_both: 'Begge',
  after_me_grave_choice_physical: 'Fysisk grav',
  after_me_grave_choice_nettgrav: 'Nettgrav',
  after_me_ceremony_choice_small: 'Liten og nær',
  after_me_ceremony_choice_open: 'Åpen for flere',
  after_me_ceremony_choice_none: 'Ingen stor seremoni',
  after_me_body_choice_cremation: 'Kremasjon',
  after_me_body_choice_coffin_burial: 'Kistegrav',
  after_me_place_choice_church: 'Kirke',
  after_me_place_choice_nature: 'Natur',
  after_me_place_choice_home: 'Hjemme',
  after_me_religious_preference_religious: 'Ja',
  after_me_religious_preference_non_religious: 'Nei',
  after_me_legacy_focus_knowledge: 'Kunnskap',
  after_me_legacy_focus_knowledge_help: 'Forståelse som kan gjøre livet klarere – og lengre.',
  after_me_legacy_focus_health: 'Helse',
  after_me_legacy_focus_health_help: 'Arbeid som kan bidra til at færre liv tar slutt for tidlig.',
  after_me_legacy_focus_care: 'Omsorg',
  after_me_legacy_focus_care_help: 'Verdighet og nærhet der mennesker er mest sårbare.',
  after_me_legacy_focus_nature: 'Natur',
  after_me_legacy_focus_nature_help: 'Livets sammenheng – og det som bærer oss videre.',
  after_me_legacy_focus_creation: 'Skapelse',
  after_me_legacy_focus_creation_help: 'Det mennesket bygger, uttrykker og gir videre.',
  after_me_legacy_focus_freedom: 'Frihet',
  after_me_placeholder_message_text:
    'Er det noe du ønsker å gjøre tydelig for dem som står deg nær?',
  after_me_placeholder_legacy_reason: 'Skriv en kort setning …',
  after_me_placeholder_boundaries: 'Skriv det du vil gjøre tydelig …',
  after_me_practical_title: 'Enkle valg',
  after_me_practical_intro: 'Dette handler ikke om detaljer. Bare det viktigste.',
  after_me_boundaries_help: 'Noen ganger er det viktigste å sette en grense.',
  after_me_status_ready: 'Tydelig',
  after_me_status_draft: 'Utkast',
  after_me_status_ready_hint: 'Du kan når som helst gjøre endringer.',
  after_me_save_state_idle: 'Utkast',
  after_me_save_state_saving: 'Lagrer…',
  after_me_save_state_saved: 'Lagret',
  after_me_save_state_error: 'Kunne ikke lagre',
  after_me_back: 'Tilbake',
  after_me_next: 'Videre',
  after_me_mark_ready: 'Gjør tydelig',
  after_me_update: 'Oppdater',
  after_me_mark_ready_success: 'Lagret som tydelig.',
  after_me_mark_ready_needs_more: 'For å gjøre dette tydelig trenger vi litt mer.',
  after_me_saved_inline: 'Tydelig lagret',
  after_me_warning_self_only:
    'Kun du kan se dette. Da kan ingen andre ivareta ønskene dine på dine vegne.',
  after_me_last_updated: 'Oppdatert {date}',
  after_me_save_error: 'Kunne ikke lagre akkurat nå. Prøv igjen.',
  after_me_error_visibility_missing: 'Velg hvem som skal kunne se dette.',
  after_me_error_activation_mode_missing: 'Velg når dette skal bli synlig.',
  after_me_error_intentions_missing: 'Velg minst én intensjon.',
  after_me_error_content_missing: 'Legg til noen ord før du gjør dette tydelig.',
  after_me_error_message_text_too_long: 'Teksten er for lang. Kort den litt ned.',
  after_me_error_boundaries_text_too_long: 'Teksten om grenser er for lang. Kort den litt ned.',
  after_me_error_legacy_reason_too_long: 'Begrunnelsen er for lang. Kort den litt ned.',
  private: 'Privat',
  relatives: 'Slektninger',
  need_subscription: 'Du trenger et abonnement for å legge til minner.',
  upgrade_subscription: 'Oppgrader abonnement',
  no_memories_added: 'Et sted for ordene som blir igjen.',
  no_memories_added_with_relation: 'Et sted for ordene som blir igjen.',
  no_memories_added_ceremony: 'Et sted for ordene også nå.',
  no_memories_added_with_relation_ceremony: 'Et sted for ordene også nå.',
  no_memories_added_no_relation_hint:
    'For dem som hørte til. Velg relasjonen din for å se gravveggen og det som lever videre.',
  grave_wall_pending_review_hint:
    'Relasjonen din er registrert. Gravveggen åpnes når Nettgrav har godkjent graven.',
  input_memory_placeholder: 'Når det passer for deg',
  input_memory_placeholder_ceremony: 'Skriv når du trenger det.',
  memory_discard_message: 'Endringene blir ikke lagret.',
  discard_changes: 'Avbryte endringer?',
  discard: 'Avbryt endringer',
  discard_cancel: 'Fortsett å redigere',
  post_update_success: 'Innlegget ble oppdatert',
  post_share_success: 'Innlegget ble delt',
  post_share_failed: 'Kunne ikke dele innlegget. Prøv igjen.',
  post_failed: 'Klarte ikke å publisere. Prøv igjen.',
  company_request_approved: 'Bedriftsforespørsel godkjent',
  company_request_declined: 'Bedriftsforespørsel avslått',
  ad_request_approved: 'Annonseforespørsel godkjent',
  ad_request_declined: 'Annonseforespørsel avslått',
  spark_comment_create_failed: 'Kunne ikke opprette kommentar',
  spark_comment_update_failed: 'Kunne ikke oppdatere kommentar',
  settings_notification_preferences_saved: 'Varslingsinnstillinger lagret',
  file_upload_failed: 'Klarte ikke å laste opp filen',
  posting: 'Publiserer',
  updating: 'Oppdaterer',
  edit_post: 'Rediger innlegg',
  update_memory: 'Oppdater',
  create_memory_post: 'Publiser til grav',
  memory_description_placeholder: 'Legg igjen noen ord her.',
  add_photos_videos: 'Legg til bilder/videoer',
  click_or_drag_media: 'Klikk eller dra medier hit',
  edit_image: 'Rediger bilde',
  edit_video: 'Rediger video',
  add_caption: 'Legg til bildetekst…',
  memory_deleted_success: 'Minne slettet!',
  memory_delete_failed: 'Kunne ikke slette minnet.',
  memory_load_failed: 'Kunne ikke hente innlegget. Prøv igjen.',
  comments_load_failed: 'Kunne ikke hente kommentarene. Prøv igjen.',
  comment_delete_failed: 'Kunne ikke slette kommentaren. Prøv igjen.',
  grave_wall_load_failed: 'Kunne ikke hente gravveggen',
  grave_wall_load_failed_description: 'Prøv igjen. Innholdet ditt er ikke endret.',
  delete_memory_title: 'Fjern fra dette stedet?',
  delete_media_confirmation:
    'Dette fjerner mediet fra dette stedet. Du kan legge det til igjen senere.',
  delete_img_title: 'Fjern fra dette stedet?',
  delete_memory_content:
    'Dette fjerner innholdet fra dette stedet. Du kan legge det til igjen senere.',
  delete_memory_confirm: 'Fjern',
  write_something_or_add_media:
    'En Gnist trenger noe å brenne. Del et bilde, et minne eller noen ord – og la det skinne.',
  empty_grave_post_warning:
    'Et gravinnlegg trenger noe å dele. Legg til et bilde, et minne eller noen ord – og la det leve videre.',
  empty_memory_post_warning:
    'Du har ikke skrevet noe ennå. Del noen ord, tanker eller minner før du publiserer.',
  add_to_your_post: 'Legg til bilde eller video',
  memory_review: 'Forhåndsvis minne',
  grave_wall: 'Gravveggen',
  grave_ceremony_title: 'Dødsannonse og seremoni',
  grave_ceremony_death_notice_section: 'Dødsannonse',
  grave_ceremony_ceremony_section: 'Seremoni',
  grave_ceremony_edit: 'Rediger',
  grave_ceremony_subtitle_ready: 'Tid og sted, når det er klart.',
  grave_ceremony_subtitle_empty: 'Legg til tid og sted når det er klart.',
  grave_ceremony_published_by: 'Delt av {name}',
  grave_ceremony_published_by_relation: '{relation} til {graveName}',
  grave_ceremony_updated_at: 'Oppdatert {dateTime}',
  grave_ceremony_when: 'Tidspunkt',
  grave_ceremony_where: 'Sted',
  grave_ceremony_place_of_death: 'Dødssted',
  grave_ceremony_message: 'Melding til familie og venner',
  grave_ceremony_save: 'Lagre',
  grave_ceremony_not_set: 'Ikke satt',
  grave_ceremony_saved: 'Seremoniinformasjon lagret.',
  grave_ceremony_save_failed: 'Kunne ikke lagre akkurat nå.',
  grave_ceremony_attendance_coming: 'Kommer',
  grave_ceremony_attendance_unsure: 'Usikker',
  grave_ceremony_attendance_not_coming: 'Kan ikke komme',
  grave_ceremony_attendance_summary: 'Svar',
  grave_ceremony_attendance_prompt: 'Kan du delta i seremonien?',
  grave_ceremony_response_saved: 'Svaret ditt er lagret.',
  grave_ceremony_response_failed: 'Kunne ikke lagre svaret akkurat nå.',
  grave_ceremony_copy_link_failed: 'Kunne ikke kopiere lenken akkurat nå.',
  grave_ceremony_redirecting: 'Åpner dødsannonsen på gravsiden…',
  grave_ceremony_timing_pending: 'Tid og sted er ikke satt ennå',
  grave_ceremony_responses_title: 'Hvem kommer',
  grave_ceremony_share_link: 'Del dødsannonsen',
  grave_ceremony_link_copied: 'Lenke til dødsannonsen kopiert',
  grave_ceremony_responses_empty: 'Ingen svar ennå.',
  grave_ceremony_responses_load_failed: 'Kunne ikke hente svarlisten akkurat nå.',
  grave_ceremony_move_to_anniversaries: 'Flytt til merkedager nå',
  grave_ceremony_move_to_anniversaries_saved: 'Flyttet til merkedager.',
  grave_ceremony_move_to_anniversaries_failed: 'Kunne ikke flytte akkurat nå.',
  create_grave_ceremony_visibility_notice:
    'Dødsannonsen publiseres på gravveggen og kan deles med andre. Du kan redigere opplysningene senere.',
  life_archive_menu: 'Livsarkiv',
  media: 'Media',
  connect_grave: 'Knytt grav',
  upgrade_plan_modal: 'Oppgrader planen din',
  more: 'Mer',
  about_name: 'Navn',
  about_gender: 'Kjønn',
  relations: 'Relasjoner',
  about_birthplace: 'Fødested',
  about_nickname: 'Kallenavn',
  about_birth_name: 'Fødselsnavn',
  about_death_location: 'Dødssted',
  about_cemetery: 'Kirkegård',
  about_birthday: 'Fødselsdag',
  about_death_date: 'Dødsdato',
  about_relations: 'Relasjoner',
  about_cause_of_death: 'Dødsårsak',
  about_country: 'Land',
  about_title: 'Om',
  about_privacy: 'Synlighet',
  buried: 'Om',
  edit_grave_details: 'Rediger gravopplysninger',
  relationships: 'Relasjoner',
  grave_people_tab_label: 'De som hører til',
  grave_people_title: 'De som hører til',
  grave_people_title_with_name: 'De som sto {name} nær',
  grave_people_subtitle_with_name: 'Dette er menneskene som var en del av livet til {name}.',
  work: 'Arbeid',
  announcements: 'Dødsannonser',
  grave_link: 'Sammen med',
  grave_link_header: '{graveName}, din {relation}, er koblet til',
  placeholder_name: 'Skriv inn navn',
  placeholder_nickname: 'Skriv inn kallenavn',
  placeholder_birth_name: 'Skriv inn fødselsnavn',
  placeholder_birthplace: 'Skriv inn fødested',
  placeholder_death_location: 'Skriv inn dødssted',
  placeholder_gender: 'Velg kjønn',
  placeholder_country: 'Velg land',
  placeholder_municipality: 'Velg kommune',
  placeholder_cemetery: 'Velg kirkegård',
  placeholder_cause_of_death: 'Velg dødsårsak',
  placeholder_privacy: 'Velg synlighet',
  placeholder_date_of_birth: 'Velg fødselsdato',
  placeholder_time_of_birth: 'Velg fødselstid',
  placeholder_date_of_death: 'Velg dødsdato',
  placeholder_time_of_death: 'Velg dødstid',
  grave_owner: 'graveier',
  admin: 'admin',
  edit_relation: 'Rediger relasjon',
  remove_member: 'Fjern medlem',
  confirm_delete_user_title: 'Er du sikker?',
  confirm_button: 'Fjern',
  cancel_button: 'Behold',
  confirm_delete_message:
    'Dette fjerner {username} som familiemedlem. Du kan legge {username} til igjen senere.',
  confirm_remove_member_self_title: 'Vil du forlate denne graven?',
  confirm_remove_member_self_message: 'Du mister tilgang nå, men kan knytte deg til igjen senere.',
  confirm_remove_member_other_title: 'Vil du fjerne {username} fra denne graven?',
  confirm_remove_member_other_message:
    '{username} mister tilgang nå, men kan inviteres igjen senere.',
  relation_to_buried: 'Deres relasjon til deg',
  relation_to_user: 'Din relasjon til den begravede',
  role_required: 'Velg en rolle',
  relation_required: 'Velg en relasjon',
  direction_required: 'Velg relasjonens retning.',
  relation_you_are_prefix: 'Du er',
  relation_you_are_suffix: 'til {name}',
  relation_they_are_prefix: '{name} er din',
  invitation_relation_you_are_prefix: 'Den inviterte er',
  invitation_relation_you_are_suffix: 'til {name}',
  invitation_relation_they_are_prefix: '{name} er den inviterte sin',
  invite_family_member: 'Inviter noen',
  grave_people_invite_button: 'Gi familie tilgang',
  email_required: 'Fyll inn e-post',
  email_required_validation: 'Fyll inn en gyldig e-postadresse',
  name_required: 'Fyll inn navn',
  pending_invitations: 'Ventende invitasjoner',
  find_grave_member: 'Søk i relasjoner',
  grave_people_pending_invitations: 'Ventende invitasjoner',
  grave_people_search_placeholder: 'Finn en person',
  grave_people_search_failed: 'Kunne ikke søke etter personer. Prøv igjen.',
  grave_people_search_empty_title: 'Ingen treff',
  grave_people_search_empty_message: 'Prøv et annet navn.',
  grave_invitations_load_failed: 'Kunne ikke hente invitasjonene.',
  relation_requests_load_failed: 'Kunne ikke hente relasjonsforespørslene.',
  relation_request_update_failed: 'Kunne ikke oppdatere relasjonsforespørselen.',
  grave_invitation_sent: 'Invitasjonen er sendt.',
  grave_invitation_updated: 'Invitasjonen er oppdatert.',
  find_invited_user: 'Finn noen du har invitert',
  find_workplace: 'Finn arbeidssted',
  add_workplace: 'Legg til arbeidssted',
  company_name_label: 'Firma',
  company_name_placeholder: 'Skriv inn firmanavn',
  company_name_required: 'Legg til firmanavn.',
  city_label: 'By',
  city_placeholder: 'Skriv inn by',
  city_required: 'Legg til by.',
  position_label: 'Stilling',
  position_placeholder: 'Skriv inn stilling',
  position_required: 'Legg til stilling.',
  start_year_label: 'Startår',
  start_year_placeholder: 'Velg startår',
  start_year_required: 'Velg startår.',
  end_year_label: 'Sluttår',
  end_year_placeholder: 'Velg sluttår',
  end_year_required: 'Velg sluttår.',
  description_label: 'Beskrivelse',
  description_placeholder: 'Skriv jobb­beskrivelse',
  publicPrivacy_label: 'Personvern',
  publicPrivacy_placeholder: 'Velg personverninnstilling',
  publicPrivacy_required: 'Velg valg av personvern.',
  invalid_end_date: 'Ugyldig sluttdato',
  invalid_end_date_message: 'Sluttdato kommer etter startdato.',
  no_workplaces_added: 'Steder som hørte til livet.',
  add_workplaces_message: 'Velg relasjonen din for å legge til arbeidssteder som betydde noe.',
  add_workplaces_message_member: 'Her kan du legge til hvor personen har jobbet gjennom livet.',
  no_invitations_sent: 'Del graven med de nærmeste',
  no_invitations_message:
    'Inviter familie og venner til å være til stede – når det passer for dem.',
  grave_people_empty_title: 'Ingen ventende invitasjoner',
  grave_people_empty_message: 'Invitasjoner du sender vises her til de blir besvart.',
  grave_relation_responsible: 'Har ansvar',
  grave_people_owner_tag: 'Den som holder graven',
  photos: 'Album',
  find_interests: 'Finn interesser',
  add_interest: 'Legg til interesse',
  interest_name: 'Interessenavn',
  interest_name_placeholder: 'Skriv inn interessenavn',
  interest_name_required: 'Legg til interessenavn.',
  interest_category: 'Kategori',
  interest_category_placeholder: 'Velg kategori',
  interest_category_required: 'Velg kategori.',
  interest_description: 'Beskrivelse',
  interest_description_placeholder: 'Skriv inn beskrivelse',
  interest_description_required: 'Legg til beskrivelse.',
  confirm_delete_workplace_message:
    'Dette fjerner arbeidsstedet. Du kan legge arbeidsstedet til igjen senere.',
  confirm_delete_interests_message:
    'Dette fjerner interessen. Du kan legge interessen til igjen senere.',
  confirm_delete_payment_method_message:
    'Dette fjerner betalingsmetoden. Du kan legge til en ny senere.',
  no_interests_added: 'Det som ga glede, ro eller nysgjerrighet.',
  add_interests_message: 'Velg relasjonen din for å dele interesser som hørte til livet.',
  add_interests_message_member:
    'Her kan du dele hva som fanget nysgjerrigheten deres, inspirerte dem eller fikk dem til å smile.',
  add_passion: 'Legg til lidenskap',
  confirm_delete_passion_message:
    'Dette fjerner lidenskapen fra dette stedet. Du kan legge lidenskapen til igjen senere.',
  confirm_delete_gift_message:
    'Dette fjerner gaven fra dette stedet. Du kan legge gaven til igjen senere.',
  passion_description: 'Lidenskapsbeskrivelse',
  passion_description_placeholder: 'Skriv inn lidenskapsbeskrivelse',
  passion_description_required: 'Legg til lidenskapsbeskrivelse.',
  no_passion_added: 'Det som ga energi og mening.',
  add_passion_message: 'Velg relasjonen din for å legge til lidenskaper som betydde mye.',
  add_passion_message_member:
    'Legg til det de virkelig brydde seg om – det som ga dem energi, mening eller glede.',
  no_grave_linked: 'Forbindelser gir sammenheng.',
  add_grave_linked_message:
    'Vis hvordan {firstName} henger sammen med familien sin. Knytt {firstName} til dem som betyr noe – uansett hvor gravene er.',
  grave_link: 'Sammen med',
  grave_link_empty_primary: 'Noen graver hørte sammen i livet.',
  grave_link_empty_secondary: 'Her kan de stå sammen – uansett hvor de er gravlagt.',
  grave_link_empty_tertiary: 'Velg relasjonen din for å knytte dem sammen på Nettgrav.',
  grave_link_empty_image_alt: 'To gravsteder knyttet sammen',
  grave_link_open_grave: 'Åpne graven til {name}',
  grave_link_more_actions: 'Flere handlinger for gravkoblingen',
  grave_link_removed: 'Gravkoblingen er fjernet.',
  grave_link_remove_failed: 'Vi klarte ikke å fjerne koblingen. Prøv igjen om litt.',
  grave_link_updated: 'Gravkoblingen er oppdatert.',
  photo_albums_manage: 'Endre samling',
  upload_photo: 'Legg til bilde',
  photo_uploading_title: 'Laster opp bilder',
  photo_album_system_name: 'Samlede bilder',
  photo_album_images_count: '{count, plural, one {# bilde} other {# bilder}}',
  photo_album_empty_count: 'Ingen bilder her ennå',
  photo_tagging_label: 'Vis også på andre graver',
  photo_tagging_placeholder: 'Velg graver',
  photo_tagged_section_title: 'Bilder som deles med andre graver',
  photo_tagged_source: 'Også på graven til {graveName}',
  photo_tagged_open_original: 'Gå til graven',
  photo_upload_progress: 'Legger til {completed} av {total} bilder',
  photo_upload_partial_failure:
    '{successCount} bilder er lagt til. {failedCount} ble ikke med denne gangen. Du kan prøve igjen.',
  photo_album_delete_confirm_title: 'Slette album?',
  photo_album_delete_confirm_body: 'Bildene slettes ikke. De flyttes til Samlede bilder.',
  photo_album_delete_confirm_body_with_images:
    'Bildene blir fortsatt tilgjengelige i Samlede bilder.',
  photo_album_delete_confirm_body_empty: 'Dette albumet er tomt og blir slettet.',
  photo_album_delete_confirm_action: 'Slett album',
  photo_delete_image_title: 'Fjern bildet?',
  photo_delete_image_content: 'Bildet fjernes fra denne graven. Du kan legge det til igjen senere.',
  photo_delete_failed: 'Kunne ikke fjerne bildet. Prøv igjen.',
  grave_photos_loading: 'Henter bilder',
  grave_photos_load_failed: 'Kunne ikke hente bildene',
  grave_photos_load_failed_description: 'Prøv igjen. Innholdet ditt er ikke endret.',
  grave_photos_retry: 'Prøv igjen',
  grave_photos_load_more: 'Vis flere bilder',
  grave_photos_load_more_failed: 'Kunne ikke hente flere bilder.',
  photo_albums_load_failed: 'Kunne ikke hente albumsamlingene.',
  grave_photo_alt: 'Bilde på gravstedet til {name}',
  photo_comment_action_failed: 'Kunne ikke lagre kommentaren. Prøv igjen.',
  photo_comment_delete_title: 'Slette kommentaren?',
  photo_comment_delete_content: 'Kommentaren fjernes permanent.',
  photo_move_to_album: 'Flytt til album',
  photo_move_to_album_title: 'Flytt bilde til album',
  photo_move_to_album_placeholder: 'Velg album',
  no_photos_added: 'Her kan bilder samles over tid.',
  add_photos_message: 'Når et bilde legges til, blir det en del av historien.',
  album_empty_primary: 'Bilder som samles over tid.',
  album_empty_album_title: 'Ingen bilder her ennå',
  album_empty_album_message: 'Når et bilde legges til, blir det en del av historien.',
  album_empty_secondary: 'Velg relasjonen din for å legge til bilder og se mer av historien.',
  album_empty_cta: 'Knytt deg til {firstName}',
  select_cover_photo: 'Velg forsidebilde',
  add_photos: 'Legg til bilder',
  choose_cover_photo: 'Velg forsidebilde',
  adjust_cover_position: 'Juster plassering',
  upload_image: 'Legg til bilde',
  remove_image: 'Fjern fra forsiden',
  remove_grave_avatar: 'Fjern profilbilde',
  grave_avatar_removed: 'Profilbildet er fjernet.',
  grave_avatar_remove_failed: 'Kunne ikke fjerne profilbildet.',
  edit_profile_photo: 'Rediger profilbilde',
  edit_cover_image: 'Rediger grav­forsidebilde',
  add_cover_photo: 'Legg til forsidebilde',
  edit: 'Rediger',
  upload_photos: 'Last opp bilder',
  label_description: 'Beskrivelse',
  placeholder_description: 'Skriv inn beskrivelse',
  label_address: 'Adresse',
  placeholder_address: 'Skriv inn adresse',
  date_time: 'Dato og tid',
  create_anniversary: 'Opprett merkedag',
  edit_anniversary: 'Rediger merkedag',
  add_life_event: 'Legg til historie',
  no_events_added:
    '{firstName}s bok er et sted for historiene som hører til livet til {firstName}.',
  life_events_empty_primary: 'Her kan livets historier få plass.',
  life_events_empty_secondary: 'Knytt deg til graven hvis du vil bidra med minner og historier.',
  life_events_empty_cta: 'Knytt deg til {firstName}',
  add_events_message: 'Her kan du dele minner, øyeblikk og ord som viser hvem {firstName} var.',
  life_events_load_failed: 'Kunne ikke hente livshistorien.',
  life_events_load_failed_description: 'Prøv igjen. Innholdet ditt er ikke endret.',
  try_again: 'Prøv igjen',
  life_event_media_update_failed: 'Kunne ikke oppdatere bildet. Prøv igjen.',
  life_event_media_delete_failed: 'Kunne ikke fjerne mediet. Prøv igjen.',
  event_label_name: 'Hendelsens tittel',
  event_placeholder_name: 'Skriv inn tittel',
  event_required_name: 'Legg til tittel.',
  event_label_date: 'Dato for hendelsen',
  event_placeholder_date: 'Velg dato',
  event_required_date: 'Velg dato.',
  event_label_theme: 'Velg tema',
  event_placeholder_theme: 'Velg tema',
  event_required_theme: 'Velg tema.',
  event_label_country: 'Land',
  event_placeholder_country: 'Velg land',
  event_required_country: 'Velg land.',
  event_theme_selected: 'Valgt farge:',
  event_label_description: 'Historietekst',
  event_placeholder_description: 'Skriv historien her',
  event_required_description: 'Velg historietekst.',
  event_theme_light: 'Lyst tema',
  event_theme_dark: 'Mørkt tema',
  create_event: 'Opprett historie',
  create_event_grave_info: 'Legg til en livshendelse på graven til {graveName}.',
  edit_event: 'Rediger historie',
  show_all: 'Vis alle',
  set_as_cover: 'Sett som forside',
  creator: 'Skaper',
  previous: 'Forrige',
  view_more_events: 'Se flere livshistorier',
  view_more: 'Se mer',
  connect_grave_title: 'Graver du kan knytte til {graveName}',
  connect_grave_select_title: 'Velg graven du vil knytte til',
  connect_grave_relations_title: 'Sett relasjoner',
  connect_grave_relation_subject: '{name} er',
  connect_grave_relation_object: 'til {name}',
  connect_grave_confirm: 'Knytt gravene',
  connect_grave_section_direct: 'Dine graver',
  connect_grave_section_other: 'Andre relevante',
  link_to_grave: 'Knytt til denne graven',
  your: 'Din',
  graves_not_found: 'Ingen graver tilgjengelig akkurat nå.',
  connect_grave_empty_title: 'Det finnes ingen andre graver her ennå',
  connect_grave_empty_message: 'Når du får tilgang til flere, kan du knytte dem sammen.',
  connect_grave_load_failed: 'Vi klarte ikke å hente gravene akkurat nå.',
  share: 'Del',
  linked_copied: 'Lenke kopiert til utklippstavlen',
  share_memory: 'Del minne',
  copy_link: 'Kopier lenke',
  media_not_added: 'Ingen media lagt til enda.',
  delete_event_title: 'Bekreft sletting av historien?',
  grave_is_private_title: '{graveName}s grav er privat',
  grave_is_private_message: 'Kun nære slektninger kan se minner, historier og delt innhold her.',
  grave_relations_private_title: 'Relasjoner er private',
  grave_relations_private_message:
    'Grunnet privat grav er relasjoner kun synlige for nære slektninger.',
  grave_user_not_found_message:
    'Her samles relasjonene rundt {firstName}. Start med deg selv, og legg til dem som betyr noe.',
  grave_user_not_found_message_primary: 'Her samles relasjonene rundt {firstName}.',
  grave_user_not_found_message_secondary: 'Start med deg selv, og legg til dem som betyr noe.',
  grave_relations_empty_primary: 'Her ser du hvem som hører til.',
  grave_relations_empty_secondary:
    'Knytt deg til graven for å se hvem som hører til rundt {firstName}.',
  grave_relations_empty_cta: 'Knytt deg til {firstName}',
  connect_with_grave: 'Velg din relasjon til {graveName}',
  join_set_relation_free: 'Velg din relasjon til {firstName}',
  join_sheet_title: 'Velg din relasjon til {name}',
  join_sheet_intro: 'Et personlig rom for nærhet til {name} – tilgjengelig når du ønsker det.',
  join_sheet_auth_title: 'Logg inn for å fortsette',
  join_sheet_auth_intro:
    'Logg inn for å reagere, legge til en refleksjon eller skrive en kommentar.',
  join_sheet_intent_react_title: 'Logg inn for å reagere på Gnister',
  join_sheet_intent_react_intro: 'Når du er logget inn, kan du reagere og være med i samtalen.',
  join_sheet_intent_weekly_question_title: 'Logg inn for å svare på ukens spørsmål',
  join_sheet_intent_weekly_question_intro:
    'Når du er logget inn, kan du dele ditt eget svar som en Gnist.',
  join_sheet_intent_reflect_title: 'Logg inn for å legge til en refleksjon',
  join_sheet_intent_reflect_intro: 'Når du er logget inn, kan du dele din refleksjon.',
  join_sheet_intent_composer_title: 'Logg inn for å skrive en kommentar',
  join_sheet_intent_composer_intro: 'Når du er logget inn, kan du være med i samtalen.',
  join_sheet_intent_submit_title: 'Logg inn for å publisere kommentaren din',
  join_sheet_intent_submit_intro: 'Når du er logget inn, kan kommentaren din deles.',
  guest_quota_notice_title: 'Flere søk i dag',
  guest_quota_notice_body:
    'For å fortsette å søke i dag, kan du logge inn eller opprette en konto.',
  please_sign_in_to_continue: 'Logg inn for å fortsette.',
  join_sheet_subtitle: 'Et sted for nærhet til {name}.',
  join_sheet_name_fallback: 'dem du bryr deg om',
  connect_grave_message:
    'Sett din relasjon til en kjær. Denne funksjonen krever Premium-abonnement. Oppgrader for tilgang.',
  cancel_relation_request: 'Avbryt relasjonsforespørsel',
  cancel_claim_request: 'Avbryt eierskapsforespørsel',
  grave_welcome_title: 'Velkommen til graven til {name}.',
  grave_intro_text: 'Her kan du lese, reflektere, dele historier, eller bare være stille.',
  grave_natural_feelings_text:
    'Det er naturlig å tenke på eget liv og egne tap når du besøker en grav. Det er helt greit. Du er ikke alene.',
  grave_what_you_can_do_title: 'Dette kan du gjøre her:',
  grave_read_stories: 'Lese historier og minner',
  grave_react_comment_care: 'Reagere og kommentere',
  grave_share_reflections: 'Dele egne refleksjoner',
  grave_light_candle: 'Tid og nærvær',
  grave_why_nettgrav_matters_title: 'Nettgrav misjonen',
  grave_support_end_of_time_center:
    'Hver Nettgrav støtter arbeidet til End Of Time Center, som jobber for en friskere verden hvor færre dør av sykdom.',
  grave_team_end_of_time_message:
    'Hos Nettgrav kan du også lese meldinger fra våre partnere – selskaper som ønsker å gjøre mer for deg og bidra til en bedre verden.',
  grave_enter_grave_button: 'Lukk',
  my_light_welcome_title: 'Mitt lys',
  my_light_you_are_the_light: 'Du er lyset.',
  my_light_intro_text: 'Dette er ditt rom.',
  my_light_sparks_relationships_graves: 'Her kommer det løsninger for det som betyr noe.',
  my_light_what_you_find_here_title: 'Alt som bygges her har som mål å bidra til gode sosiale liv.',
  my_light_sparks: 'Med styrke, omsorg og menneskelig nærhet i sentrum.',
  my_light_graves: 'Dette er et sted for deg.',
  my_light_loved_ones: 'For det du bærer, og det du ønsker å gi videre.',
  my_light_everything_begins_with_you: 'Mer vil komme.',
  my_light_enter_button: 'Skjønner',
  my_light_profile_occupation_label: 'Yrke eller rolle',
  my_light_profile_occupation_placeholder: 'Hva jobber du med?',
  my_light_profile_bio_label: 'Om meg',
  my_light_profile_bio_placeholder: 'Skriv noen linjer om deg',
  compass_tab: 'Mitt kompass',
  compass_title: 'Mitt kompass',
  compass_title_other: 'Slik holder {name} kurs',
  compass_subtitle: 'Det jeg vil holde fast i.',
  compass_empty_lead: 'Noen velger å skrive ned retningen de vil holde fast i.',
  compass_empty_copy: 'Det kan gjøre både livet og relasjonene klarere.',
  compass_empty_cta: 'Skriv Mitt kompass',
  compass_help_primary: 'Skriv det slik det er for deg.',
  compass_label_pressure_pattern: 'Det som kan dra meg ut av kurs',
  compass_nav_pressure_pattern: 'Ut av kurs',
  compass_help_pressure_pattern: 'Hva gjør at du mister retning?',
  compass_placeholder_pressure_pattern: 'Når jeg vil være likt mer enn ærlig.',
  compass_label_anchor_statement: 'Det som ikke er til forhandling for meg',
  compass_nav_anchor_statement: 'Ikke til forhandling',
  compass_help_anchor_statement: 'Det jeg ikke går på kompromiss med.',
  compass_placeholder_anchor_statement: 'Jeg lyver ikke for meg selv.',
  compass_label_choice_question: 'Spørsmålet som holder meg på kurs',
  compass_nav_choice_question: 'Spørsmålet mitt',
  compass_help_choice_question: 'Ett spørsmål før viktige valg.',
  compass_placeholder_choice_question: 'Er dette sant, eller bare trygt?',
  compass_label_known_for: 'Slik merker du at jeg er ute av kurs',
  compass_nav_known_for: 'Slik du merker det',
  compass_help_known_for: 'Hva andre kan legge merke til.',
  compass_placeholder_known_for: 'Jeg blir stille og trekker meg unna.',
  compass_label_growth_edge: 'Slik finner jeg tilbake',
  compass_nav_growth_edge: 'Slik finner jeg tilbake',
  compass_help_growth_edge: 'Hva hjelper deg tilbake i retning?',
  compass_placeholder_growth_edge: 'Jeg trenger stillhet og én ærlig samtale.',
  compass_label_visibility: 'Synlighet',
  compass_visibility_self_only: 'Kun meg',
  compass_visibility_moons: 'Måner',
  compass_visibility_family_friends: 'Familie og venner',
  compass_visibility_public: 'Offentlig',
  compass_visibility_shown_for: 'Synlig for: {visibility}',
  compass_visibility_owner_hint:
    'Slik vises kompasset ditt for andre ut fra synligheten du har valgt.',
  compass_visibility_reason_family_friends:
    'Du ser dette fordi du er registrert som familie eller venn.',
  compass_visibility_reason_moons: 'Du ser dette fordi du er registrert som måne.',
  compass_visibility_reason_public: 'Du ser dette fordi kompasset er delt offentlig.',
  compass_visibility_reason_default: 'Synligheten styres av eieren.',
  compass_safety_hint: 'Kompasset kan endres når livet endrer seg.',
  compass_share_nudge: 'Vil du dele kompasset med noen nære?',
  compass_share_nudge_moons: 'Del med måner',
  compass_share_nudge_family: 'Del med familie og venner',
  compass_share_nudge_public: 'Del offentlig',
  compass_step_indicator: 'Felt {current} av {total}',
  compass_step_counter: '{current}/{total}',
  compass_summary_title: 'Slik holder jeg kurs',
  compass_prev: 'Forrige',
  compass_prev_alt: '← Forrige',
  compass_prev_to: '← Til {label}',
  compass_next: 'Videre',
  compass_next_alt: 'Neste →',
  compass_next_to: 'Til {label} →',
  compass_save: 'Lagre',
  compass_saving: 'Lagrer...',
  compass_saved: 'Lagret',
  compass_save_error: 'Kunne ikke lagre akkurat nå.',
  compass_signal_cta: 'Takk for at du delte',
  compass_signal_sent: 'Tegn sendt',
  compass_signal_sent_to: 'Takk sendt til {name}',
  compass_signal_toast_sent: 'Takk sendt.',
  compass_signal_error: 'Kunne ikke sende takk akkurat nå.',
  compass_signal_hint: 'En stille takk for at de delte kompasset sitt. Det vises ikke offentlig.',
  compass_signal_sent_hint: 'Det vises bare for {name}.',
  compass_signal_guest_hint: 'Logg inn for å la dem vite at du så dette.',
  compass_signal_guest_cta: 'Logg inn',
  compass_can_change: 'Du kan endre når du ønsker det.',
  compass_shared_none: 'Ingen kompass skrevet ennå.',
  my_light_profile_cancel: 'Lukk',
  my_light_profile_save: 'Lagre',
  my_light_about_title: 'Om meg',
  conversation_starters_tab_self: 'Spør meg om',
  conversation_starters_tab_other: 'Spør {name}',
  conversation_starters_title_self: 'Spør meg om',
  conversation_starters_title_other: 'Spør {name}',
  conversation_starters_subtitle: 'Noen samtaler trenger bare et sted å begynne.',
  conversation_starters_placeholder: 'Skriv noe andre gjerne kan spørre deg om',
  conversation_starters_suggestion_1: 'hvorfor jeg',
  conversation_starters_suggestion_2: 'hvordan jeg',
  conversation_starters_suggestion_3: 'hva jeg lærte da',
  conversation_starters_suggestion_4: 'hva som fikk meg til å',
  conversation_starters_visibility_label: 'Hvem kan se dette?',
  conversation_starters_visibility_everyone: 'Alle',
  conversation_starters_visibility_moons: 'Måner',
  conversation_starters_visibility_family_friends: 'Familie og venner',
  conversation_starters_visibility_self_only: 'Kun meg',
  conversation_starters_add: 'Legg til',
  conversation_starters_ask: 'Spør {name}',
  conversation_starters_chat_draft: 'Hei {name}. Du skriver at jeg kan spørre deg om «{starter}».',
  conversation_starters_empty: 'Legg til noe som kan åpne en god samtale.',
  conversation_starters_save_error: 'Kunne ikke lagre samtaleinngangen akkurat nå.',
  conversation_starters_delete_error: 'Kunne ikke slette samtaleinngangen akkurat nå.',
  conversation_starters_chat_error: 'Kunne ikke åpne samtalen akkurat nå.',
  day_title: 'Dagen',
  day_subtitle: 'Noe å tenke på, noen å forstå og noe å ta vare på.',
  day_reflection_label: 'En tanke for dagen',
  day_reflection_1: 'Hva har du forstått annerledes med tiden?',
  day_reflection_2: 'Hvilket spørsmål følger deg akkurat nå?',
  day_reflection_3: 'Hva skulle du ønske flere mennesker var nysgjerrige på?',
  day_reflection_4: 'Hva har et annet menneske lært deg uten å vite det?',
  day_reflection_5: 'Hva betyr nærhet for deg i dag?',
  day_reflection_action: 'Gå til Skap Gnist',
  day_connection_label: 'Forstå sammen',
  day_connection_title: '{name} har skrevet noe de ønsker å forstå sammen med andre.',
  day_connection_empty_title: 'Har du noe du ønsker å forstå sammen med andre?',
  day_connection_empty_text:
    'Del det med egne ord og velg om Nettgrav kan la nye mennesker finne det.',
  day_connection_action: 'Les og forstå sammen',
  day_connection_empty_action: 'Del med egne ord',
  day_preserve_label: 'Ta vare på',
  day_preserve_title: 'Finnes det et bilde med en historie som bare du kjenner?',
  day_preserve_action: 'Gå til gravene dine',
  own_words_discovery_title: 'La Nettgrav knytte meg til nye mennesker',
  own_words_discovery_help:
    'Disse ordene kan vises i Dagen til personer du ikke kjenner. Du kan slå det av når du vil.',
  my_light_about_subtitle: 'Noen ord om meg, slik livet kjennes nå.',
  my_light_questions_title: 'Tre spørsmål',
  my_light_question_1: 'Hva er viktig for meg i livet akkurat nå?',
  my_light_question_2: 'Hva gir meg ro, mening eller energi i hverdagen?',
  my_light_question_3: 'Hva er jeg i ferd med å lære om meg selv?',
  spark_energy_tooltip: 'Din Gnist gjør verden til et bedre sted.',
  grave_support_title: 'Hva støtter denne graven?',
  grave_support_intro: 'Hver Nettgrav er en del av noe større.',
  grave_support_body:
    'Denne graven støtter End Of Time Center – et vitensenter med én radikal visjon: En verden uten død.',
  grave_support_help:
    'Sammen søker vi svar på hvorfor vi dør, og hvordan innsikten fra døden kan hjelpe oss å leve dypere og mer omsorgsfullt – for oss selv og hverandre.',
  grave_support_read_more: 'Les mer om End Of Time Center.',
  end_of_time_center_title: 'End Of Time Center',
  end_of_time_center_intro:
    'Nettgrav er det første produktet fra The End Of Time Corporation. Vi planlegger å etablere End Of Time Center – et vitensenter for forskning på liv og død, med et radikalt mål: Å forstå døden, og skape en fremtid der ingen trenger en grav.',
  end_of_time_center_body:
    'Her vil forskere, visjonære og problemløsere samles for å utvikle kunnskap, løsninger og nye perspektiver på livets største spørsmål. Sammen søker vi innsikt og inspirasjon som kan gjøre verden tryggere, varmere – og kanskje litt mer evig.',
  end_of_time_center_close: 'Lukk',
  about_this_grave: 'Om denne graven',
  my_light: 'Mitt lys',
  relation_confirmation_label: 'Autobekreft relasjon',
  auto_confirm_on: 'Automatisk',
  auto_confirm_off: 'Krever godkjenning',
  relation_requests: 'Relasjonsforespørsler',
  connection_request_sent_info:
    'Forespørselen om tilknytning er sendt til eieren av {graveName}. Når den er godkjent, vil graven vises under dine tilknyttede graver.',
  connection_request_sent: 'Tilknytningsforespørsel sendt.',
  connection_created_unverified:
    'Gravkoblingen er opprettet uten bekreftelse fra en gravforvalter.',
  connection_request_failed: 'Vi klarte ikke å sende forespørselen akkurat nå. Prøv igjen om litt.',
  linked_grave_unverified_status: 'Ikke bekreftet av en gravforvalter',
  grave_already_connected: '{graveName} is already connected',
  is_grave_already_connected: 'Is this grave already connected?',
  take_grave_ownership: 'Vil du bli eier av denne graven?',
  grave_privacy_public:
    'Denne graven er offentlig. Alle kan se og samhandle med offentlig innhold.',
  grave_privacy_private:
    'Denne graven er privat. Bare inviterte brukere kan se innholdet. Andre brukere ser ingenting.',
  grave_privacy_relatives:
    'Denne graven er satt til slektninger. Slektninger kan se både slektninger og offentlig innhold. Andre brukere kan bare se offentlig innhold.',
  please_fill_all_fields: 'Vennligst fyll ut alle obligatoriske felt',
  grave_invitations: 'Gravinvitasjoner',
  'relationships.manageInvites': 'Inviter familie og venner',
  invite_you_as: 'inviterer deg som',
  grave_invitation: 'Gravinvitasjon',
  grave_invitations_not_found_title: 'Ingen invitasjoner funnet',
  grave_invitations_not_found_subtile:
    'Du har ikke mottatt noen gravinvitasjoner ennå. Når noen inviterer deg, vil du se dem her.',
  invited_you_to_grave: '{name} inviterte deg til graven',
  search_by_name: 'Søk etter navn',
  confirm_delete_linked_grave_message:
    'Dette fjerner koblingen til denne graven. Du kan koble graven til igjen senere.',
  search_grave_placeholder: 'Søk etter navn',
  search_open: 'Åpne søk',
  search_open_full: 'Søk',
  search_submit: 'Søk',
  clear_search: 'Tøm søket',
  close_search: 'Lukk søk',
  search_grave_heading: 'Finn graven du leter etter',
  search_grave_intro: 'Søk etter navn, eller filtrer videre.',
  search_all_heading: 'Finn mennesker og graver',
  search_all_intro: 'Søk etter et menneske eller en grav ved navn.',
  search_all_placeholder: 'Søk etter mennesker og graver',
  search_people_heading: 'Finn personen du leter etter',
  search_people_intro: 'Søk etter navn for å finne mennesker.',
  search_people_placeholder: 'Søk etter mennesker',
  search_grave_guest_cta_title: 'Når du finner riktig grav',
  search_grave_guest_cta_body:
    'kan du knytte deg til den, legge igjen et tegn og følge opp over tid.',
  search_grave_guest_cta_button: 'Opprett konto',
  search_grave_loading_title: 'Vi henter graven...',
  search_grave_loading_subtitle: 'Dette tar vanligvis under et sekund.',
  search_all_loading_title: 'Vi henter resultatene...',
  search_all_loading_subtitle: 'Dette tar vanligvis under et sekund.',
  search_people_loading_title: 'Vi henter medlemmene...',
  search_people_loading_subtitle: 'Dette tar vanligvis under et sekund.',
  search_grave_none_subtext:
    'Prøv et annet navn eller søk med færre bokstaver. Du kan også filtrere videre på kommune og kirkegård.',
  search_grave_none_text: 'Ingen resultater funnet for',
  search: 'Søk',
  search_grave_perfect_matches: 'Kan dette være personen du leter etter?',
  search_grave_filter_heading: 'Filtrer etter land, kommune og kirkegård',
  search_grave_show_filters: 'Vis flere søkevalg',
  search_grave_hide_filters: 'Skjul søkevalg',
  search_grave_image_heading: 'Søk etter graver for å komme i gang.',
  search_grave_image_subtitle: 'Hvem leter du etter i dag?',
  search_grave_search_for: 'Søkeresultat for',
  search_grave_no_relation_hint:
    'Du kan besøke graven nå. Når du velger relasjon, blir den en del av rommet ditt her.',
  search_grave_visit_cta: 'Besøk graven',
  grave_invitation_email: 'E-postadresse',
  grave_invitation_email_placeholder: 'Skriv e-postadresse',
  grave_invitation_email_required: 'Legg til e-post.',
  grave_invitation_email_required_validation: 'Skriv inn en gyldig e-post',
  grave_invitation_invited_person_name: 'Navn',
  grave_invitation_invited_person_name_placeholder: 'Skriv navn',
  grave_invitation_name_required: 'Legg til navn.',
  grave_invitation_relation_to_grave: 'Deres forhold',
  grave_invitation_relation_to_grave_modal: 'Den inviterte sin relasjon til {graveName}',
  grave_invitation_relation_to_grave_help: 'Sett forholdet slik den inviterte personen vil se det.',
  grave_invitation_relation_required: 'Velg relasjon.',
  grave_invitation_select_relationship: 'Velg hvordan dere er knyttet sammen',
  grave_invitation_select_relationship_short: 'Velg relasjon',
  grave_invitation_relation_to_person: 'Slik vil de se {graveName}',
  grave_invitation_relation_to_person_modal: '{graveName} sin relasjon til den inviterte',
  grave_invitation_relation_to_person_help: 'Dette vises fra den inviterte personens ståsted.',
  grave_invitation_select_reciprocal: 'Velg relasjon (for eksempel far eller søsken)',
  grave_invitation_direction_required: 'Velg retning på relasjonen.',
  grave_invitation_administrator_access: 'Administrator­tilgang',
  grave_invitation_role_required: 'Velg rolle.',
  grave_invitation_administrator: 'Administrator',
  grave_invitation_normal: 'Normal',
  anniversary_create_name: 'Navn',
  anniversary_create_placeholder_name: 'Hva vil du kalle dagen?',
  anniversary_create_date_time: 'Dato',
  anniversary_create_name_required: 'Skriv inn navn',
  anniversary_create_date_time_required: 'Velg dato',
  anniversary_create_date_hint: 'Kan endres senere.',
  anniversaries_create_title: 'Legg til merkedag',
  anniversaries_create_hint: 'For samling, besøk eller en dag som betyr noe for dere.',
  spark_create_modal_category: 'Gnistkategori:',
  spark_suggestions_label: 'Litt inspirasjon:',
  spark_category_question: 'spørsmål',
  spark_category_insight: 'innsikt',
  spark_category_experience: 'erfaring',
  spark_category_discovery: 'oppdagelse',
  spark_category_emotion: 'følelse',
  spark_category_value: 'verdi',
  spark_category_energy: 'energi',
  spark_category_intention: 'hensikt',
  edit_spark: 'Rediger Gnist',
  share_spark: 'Del Gnisten',
  extinguish_park: 'Slukk Gnisten',
  spark_info_title: 'Hva er min Gnist?',
  spark_info_intro:
    'En Gnist begynner i deg. Det kan være en tanke, et spørsmål, en erfaring eller noe som får deg til å stoppe opp og kjenne etter. Når du deler den, kan den vekke refleksjon, nærhet eller handling hos andre.',
  spark_examples_title: 'Eksempler på en Gnist',
  spark_form_info:
    'Velg formen på Gnisten din. Da viser du hvordan du ønsker å dele sannheten din – som et spørsmål, en fortelling, en innsikt, en følelse eller en hensikt.',
  spark_example_question: 'Et spørsmål du undrer deg på.',
  spark_example_insight: 'En innsikt du har fått.',
  spark_example_experience: 'En opplevelse som rørte deg.',
  spark_example_value: 'En verdi du vil løfte frem.',
  spark_why_title: 'Hvorfor lage en Gnist?',
  spark_why_inspire: 'For å inspirere andre.',
  spark_why_express: 'For å sette ord på det du tenker og føler.',
  spark_why_share: 'For å dele noe som betyr noe for deg.',
  spark_why_build: 'For å bygge et varmere og mer åpent fellesskap.',
  spark_how_title: 'Hvordan lage en Gnist?',
  spark_how_step1: 'Skriv en tanke, et spørsmål, eller del en følelse.',
  spark_how_step2: 'Velg kategori: Spørsmål, Innsikt, Opplevelse, Verdi, Følelse, Energi.',
  spark_how_step3: 'Publiser – og la din gnist lyse for andre!',
  spark_helper_text:
    'Del din gnist – et spørsmål, en tanke eller en følelse. Små eller store ord kan gi lys til andre.',
  spark_show_inspirations: 'La deg inspirere – hent et spørsmål',
  spark_get_question: 'Hent et spørsmål',
  spark_selected_question: 'Hva er din Gnist?',
  spark_change_question: 'Bytt spørsmål',
  spark_optional_helper: 'Ditt bidrag kan være en gnist for andre.',
  spark_textarea_label: 'Hva vekker en Gnist i deg?',
  'sparks.media.limits': 'Opptil 5 bilder eller videoer. Maks 50 MB per fil.',
  'sparks.media.tooMany': 'Du kan legge til opptil 5 bilder eller videoer.',
  'sparks.media.tooLarge': '{name} er større enn 50 MB.',
  'sparks.media.invalidType': '{name} er ikke et støttet bilde- eller videoformat.',
  spark_reflection_label: 'Legg til ditt svar på gnisten.',
  spark_menu_button: 'Gnistmeny',
  spark_share_button: 'Del',
  share_life_event: 'Del livshendelse',
  delete_spark_title: 'Vil du slette denne Gnisten?',
  share_link_spark: 'Gnisten er klar for deling',
  public_view_description: 'Denne Gnisten deles med alle',
  moons_only_description: 'Denne Gnisten deles med dine måner',
  constellation_description: 'Denne Gnisten deles med ditt stjernebilde',
  memory_public_description: 'Alle som besøker {name} på Nettgrav kan lese innlegget.',
  memory_private_description: 'Innlegget ditt er bare synlig for deg',
  memory_relatives_description:
    'Det du deler her vises bare for de som har en relasjon til {name} på Nettgrav.',
  memory_privacy_label: 'Personvern',
  memory_description_label: 'Ord du legger igjen',
  file_remove_failed: 'Kunne ikke fjerne filen.',
  add_value: 'Legg til egenskap',
  spark_feeling_Reflecting: 'Reflekterende',
  spark_feeling_Reflecting_description: 'Skap en Gnist om noe du har tenkt mye på.',
  spark_feeling_Wonder: 'Undrende',
  spark_feeling_Wonder_description: 'Skap en Gnist med et spørsmål du lurer på.',
  spark_feeling_Connection: 'Tilknyttet',
  spark_feeling_Connection_description: 'Skap en Gnist som binder mennesker sammen.',
  spark_feeling_Freedom: 'Fri',
  spark_feeling_Hopeful: 'Håpefull',
  spark_feeling_Gratitude: 'Takknemlig',
  spark_feeling_Peace: 'Fredfull',
  spark_feeling_Freedom_description:
    'Skap en Gnist fra ditt frie, indre sted – et sted vi må ta vare på. Del uten frykt for å sette i gang forandring.',
  spark_feeling_tooltip: 'Velg perspektiv',
  memory_reaction_name_Healed: 'Vis at det trøstet',
  memory_reaction_name_Love: 'Vis kjærlighet',
  memory_reaction_name_Remembered: 'Jeg husker det også',
  memory_reaction_name_Cherished: 'Sett pris på minnet',
  views: 'visninger',
  grave_memories: 'Gravminner',
  grave_memories_placeholder: 'Legg igjen noen ord her.',
  grave_memories_message: 'Et sted å legge igjen ord når du er på besøk.',
  grave_post_on: 'Publisert på:',
  select_grave: 'Velg grav',
  select_a_grave: 'vennligst velg en grav',
  user_values_title: 'Dette ser vi i {name}',
  user_values_menu: 'Dette ser jeg i {name}',
  profile_values_tab_self: 'Det andre har forstått om meg',
  profile_values_tab_self_mobile: 'Forstått om meg',
  profile_values_tab_other: 'Det andre har forstått om {name}',
  profile_values_tab_other_mobile: 'Om personen',
  profile_people_tab_self: 'Menneskene mine',
  profile_people_tab_self_mobile: 'Mennesker',
  compass_tab_mobile: 'Kompass',
  profile_people_tab_other: 'Menneskene rundt {name}',
  profile_people_tab_other_mobile: 'Mennesker',
  my_light_profile_label: 'Mitt lys',
  my_light_profile_purpose_self:
    'Et sted for det du står for, menneskene rundt deg og det du ønsker å gi videre.',
  my_light_profile_purpose_other:
    'Et sted for det som kjennetegner {name}, menneskene rundt og det som skal leve videre.',
  intention_moment_section_title_self: 'Det andre har forstått om meg',
  intention_moment_section_title_other: 'Det andre har forstått om {name}',
  intention_moment_section_intro:
    'Øyeblikk andre la merke til, og samtaler om hvordan de ble opplevd.',
  intention_moment_add: 'Del et øyeblikk',
  intention_moment_empty_self_title: 'Ingen har delt et slikt øyeblikk ennå',
  intention_moment_empty_self_message:
    'Her kan andre dele et øyeblikk de la merke til, og du kan svare med ditt perspektiv.',
  intention_moment_empty_other_title: 'Er det noe du har lagt merke til hos {name}?',
  intention_moment_empty_other_message: 'Del et konkret øyeblikk og hva det gjorde med deg.',
  intention_moment_empty_readonly_title: 'Ingen har delt et slikt øyeblikk om {name} ennå',
  intention_moment_empty_readonly_message:
    'Her får øyeblikk som mennesker nær {name} velger å dele, plass.',
  intention_moment_create_title: 'Noe du la merke til hos {name}',
  intention_moment_edit_title: 'Rediger øyeblikket',
  intention_moment_observed_label: 'Hva skjedde?',
  intention_moment_observed_help:
    'Fortell om en konkret handling, et valg eller et øyeblikk med {name}.',
  intention_moment_observed_placeholder: 'Beskriv situasjonen slik du opplevde den.',
  intention_moment_impact_label: 'Hva gjorde det med deg?',
  intention_moment_impact_help: 'Hva tenkte, følte eller gjorde du annerledes etterpå?',
  intention_moment_impact_placeholder: 'Det gjorde at jeg ...',
  intention_moment_share: 'Del øyeblikket',
  intention_moment_update: 'Lagre',
  intention_moment_save_error: 'Øyeblikket kunne ikke lagres. Prøv igjen.',
  intention_moment_card_impact: 'Det gjorde med meg',
  intention_moment_legacy_value: 'Et ord som ble valgt: {value}',
  intention_moment_delete_title: 'Slette øyeblikket?',
  intention_moment_delete_message: 'Bidraget blir fjernet permanent.',
  intention_moment_hide_title: 'Fjerne dette fra profilen din?',
  intention_moment_hide_message:
    'Bidraget blir fjernet. Ordene blir ikke endret eller tillagt deg.',
  intention_moment_hide_action: 'Fjern',
  intention_moment_creator_consent:
    'Jeg er komfortabel med offentlig visning hvis {name} også ønsker det.',
  intention_moment_private_until_both:
    'Kortet er privat mellom dere til begge uttrykkelig har valgt offentlig visning.',
  intention_moment_response_title: 'Slik var det for deg',
  intention_moment_response_observer_label: 'Dette ble lagt merke til',
  intention_moment_response_prompt: 'Hva var viktig for deg i denne situasjonen?',
  intention_moment_response_help:
    'Fortell med egne ord. Det kan ha vært sammensatt, eller noe du ikke hadde tenkt over før.',
  intention_moment_response_placeholder: 'Slik opplevde jeg det som foregikk i meg ...',
  intention_moment_subject_consent: 'Jeg ønsker at hele kortet kan vises offentlig i Mitt lys.',
  intention_moment_public_only_together:
    'Kortet blir bare offentlig fordi dere begge har valgt det.',
  intention_moment_response_save: 'Del mitt perspektiv',
  intention_moment_card_subject_response: 'Slik var det for {name}',
  intention_moment_respond: 'Svar med ditt perspektiv',
  intention_moment_edit_response: 'Rediger mitt perspektiv',
  intention_moment_continue_chat: 'Fortsett i chatten',
  intention_moment_chat_error: 'Kunne ikke åpne samtalen.',
  intention_moment_content_locked:
    'Etter at mottakeren har svart, kan ordene over ikke endres. Du kan fortsatt endre samtykket ditt.',
  user_values_add_cta: 'Si noe du ser',
  user_values_empty_title: 'Del det du ser i {firstName}.',
  user_values_empty_message: 'Det er godt å høre det mens vi lever.',
  user_values_empty_self_title: 'Det andre ser i deg',
  user_values_empty_self_message: 'Når noen deler det de ser i deg, vises det her.',
  user_values_modal_title: 'Hva ser du i {name}?',
  user_values_modal_edit_title: 'Rediger egenskap',
  user_values_modal_heading: 'Velg en egenskap som du kjenner igjen, og si hvorfor.',
  user_values_selected_label: 'Jeg ser dette i {name}',
  user_values_selected_message: 'Hva får deg til å velge “{personality}”?',
  user_values_placeholder: 'Skriv noen ord om det du har sett eller opplevd.',
  user_values_create_cta: 'Del',
  user_values_update_cta: 'Del',
  user_values_privacy_public_description: 'Synlig for alle som besøker siden til {name}.',
  user_values_privacy_private_description: 'Bare du og {name} ser denne egenskapen.',
  user_values_privacy_relatives_description:
    'Folk du inviterer til å støtte {name} ser denne egenskapen.',
  gift_from: 'Tente et lys',
  grave_values: 'Ord om {graveName}',
  grave_values_fallback: 'Ord om',
  grave_values_load_failed: 'Kunne ikke hente ordene akkurat nå',
  grave_values_load_failed_description: 'Prøv igjen. Det du allerede har delt er fortsatt lagret.',
  grave_values_options_load_failed: 'Kunne ikke hente egenskapene',
  grave_values_options_load_failed_description: 'Prøv igjen før du deler ordene dine.',
  grave_values_privacy_label: 'Hvem kan se dette?',
  grave_values_created: 'Egenskapen er lagt til.',
  grave_values_updated: 'Egenskapen er oppdatert.',
  grave_values_deleted: 'Egenskapen er fjernet.',
  grave_values_save_failed: 'Kunne ikke lagre egenskapen. Prøv igjen.',
  the_value_archive: 'Egenskaper',
  edit_value_archive: 'Rediger egenskap',
  create_value_archive: 'Opprett egenskap',
  update_value_archive: 'Oppdater egenskap',
  value_archive_title: 'Velg en egenskap og legg til historie',
  value_archive_selected: 'Egenskap som beskriver {graveName}',
  value_archive_selected_message:
    'Du husker {graveName} som {personality}. Del noen ord som viser dette.',
  no_suggestions: 'Ingen forslag tilgjengelig',
  value_archive_placeholder: 'Skriv noen ord som viser til egenskapen',
  select_personality_warning: 'Vennligst velg en egenskap.',
  enter_description_warning: 'Husk å legge til noen ord som viser til egenskapen.',
  grave_values_empty_primary: 'Ord og små historier om hvem {firstName} var for andre.',
  grave_values_empty_secondary: 'Knytt deg til graven for å dele dine ord om {firstName}.',
  grave_values_empty_cta: 'Knytt deg til {firstName}',
  no_values_added: '{firstName} sin historie rommer mer.',
  add_values_message:
    'Egenskaper er ord som beskriver hvordan personen var å møte – det som satte spor hos andre.',
  confirm_delete_value_message:
    'Dette fjerner egenskapen fra dette stedet. Du kan legge den til igjen senere.',
  confirm_delete_product_message:
    'Dette fjerner produktet. Du kan legge produktet til igjen senere.',
  added_personality_value: 'la til',
  create_grave: 'Opprett grav',
  create_grave_mode_label: 'Hva vil du opprette?',
  create_grave_mode_grave: 'Ny grav',
  create_grave_mode_with_ceremony: 'Ny grav med dødsannonse',
  create_grave_mode_with_ceremony_mobile: 'Med dødsannonse',
  create_grave_mode_with_ceremony_help:
    'Du kan legge til det viktigste nå. Resten kan komme senere. Dette gjelder dødsfall av mennesker',
  create_grave_ceremony_accuracy_confirm_label:
    'Jeg bekrefter at opplysningene er riktige så langt jeg vet.',
  create_grave_ceremony_confirm_required: 'Bekreft at opplysningene er riktige så langt du vet.',
  create_grave_death_notice_section: 'Dødsannonse',
  create_grave_ceremony_section: 'Seremoni',
  create_grave_ceremony_message_label: 'Melding til familie og venner',
  create_grave_ceremony_message_placeholder: 'Skriv en kort beskjed.',
  create_grave_ceremony_place_of_death_label: 'Hvor døde personen',
  create_grave_ceremony_place_of_death_placeholder: 'f.eks. hjemme, på sykehjem eller sykehus',
  create_grave_ceremony_timing_pending: 'Tid og sted er ikke satt ennå',
  create_grave_ceremony_timing_pending_help: 'Du kan oppdatere dette senere på graven.',
  create_grave_ceremony_funeral_date_label: 'Seremoni (dato)',
  create_grave_ceremony_funeral_time_label: 'Seremoni (tid)',
  create_grave_ceremony_funeral_time_placeholder: 'f.eks. 12:00',
  create_grave_ceremony_funeral_at_label: 'Seremoni (dato og tid)',
  create_grave_ceremony_funeral_venue_label: 'Sted',
  create_grave_optional_field_help: 'Valgfritt',
  create_grave_ceremony_funeral_venue_placeholder: 'f.eks. Lade kirke',
  create_grave_any_proof: 'Har du dokumenter for å bekrefte dødsfallet?',
  create_grave_validation_name_required: 'Legg til navn.',
  create_grave_validation_gender_required: 'Velg kjønn.',
  create_grave_validation_birthday_required: 'Velg fødselsdato.',
  create_grave_validation_death_date_required: 'Velg dødsdato.',
  create_grave_validation_country_required: 'Velg land.',
  create_grave_validation_municipality_required: 'Velg kommune.',
  create_grave_validation_cemetery_required: 'Velg kirkegård.',
  create_grave_validation_relation_required: 'Velg relasjon.',
  create_grave_validation_reciprocal_relation_required: 'Velg relasjonen mellom dere.',
  create_grave_validation_reason_required: 'Velg dødsårsak.',
  create_grave_validation_other_reason_required: 'Velg annen dødsårsak.',
  create_grave_select_document_heading: 'Velg dokument',
  create_grave_select_document_message: 'Velg dokumentet du vil laste opp og godta vilkårene',
  spark_feeling: 'Velg perspektiv',
  added_spark_feeling_Reflecting: 'skaper gnist med refleksjon',
  added_spark_feeling_Wonder: 'skaper gnist med undring',
  added_spark_feeling_Connection: 'skaper gnist med forbindelse',
  added_spark_feeling_Freedom: 'skaper gnist med frihet',
  added_spark_feeling_Hopeful: 'skaper gnist med håp',
  added_spark_feeling_Gratitude: 'skaper gnist med takknemlighet',
  added_spark_feeling_Peace: 'skaper gnist med fred',
  added_reflection_feeling_Reflecting: 'reflekterer med refleksjon',
  added_reflection_feeling_Wonder: 'reflekterer med undring',
  added_reflection_feeling_Connection: 'reflekterer med forbindelse',
  added_reflection_feeling_Freedom: 'reflekterer med frihet',
  added_reflection_feeling_Hopeful: 'reflekterer med håp',
  added_reflection_feeling_Gratitude: 'reflekterer med takknemlighet',
  added_reflection_feeling_Peace: 'reflekterer med fred',
  spark_reflections_header: 'Refleksjoner',
  spark_add_reflection: 'Legg til refleksjon',
  spark_reflections_empty: 'Bli den første som legger til en refleksjon.',
  spark_reflections_count: '{count, plural, one {# refleksjon} other {# refleksjoner}}',
  spark_reflectors_count: '{count, plural, one {# person} other {# personer}}',
  spark_reflecting_on: 'Reflekterer over',
  spark_reflection_feeling: 'Tilstand: {state}',
  spark_original_label: 'Opprinnelig gnist',
  spark_reflection_context_label: 'Refleksjon',
  spark_unknown_user: 'Noen',
  spark_reactions_empty: 'Ingen reaksjoner i dette utvalget ennå.',
  memory_feeling_Remembering: 'Husker',
  memory_feeling_Remembering_description:
    'Gjenopplev fine øyeblikk og historier som holder minnet levende.',
  memory_feeling_Honoring: 'Setter pris på',
  memory_feeling_Honoring_description:
    'Uttrykk takknemlighet og anerkjenn verdiene og sporene de etterlot.',
  memory_feeling_Reflecting: 'Reflekterer',
  memory_feeling_Reflecting_description:
    'Ta en pause for å kjenne etter hva deres liv og nærvær betyr for deg.',
  memory_feeling_Thankful: 'Takknemlig',
  memory_feeling_Thankful_description:
    'Del hva du er takknemlig for – deres kjærlighet, visdom eller minner du bærer med deg.',
  memory_feeling_Missing: 'Savner',
  memory_feeling_Missing_description:
    'Sett ord på savnet, og det tomrommet deres fravær etterlater.',
  memory_feeling_Forgiving: 'Tilgir',
  memory_feeling_Forgiving_description: 'Velger å tilgi og slippe taket.',
  added_memory_feeling_Remembering: 'husker {graveName}',
  added_memory_feeling_Honoring: 'setter pris på {graveName}',
  added_memory_feeling_Reflecting: 'reflekterer over {graveName}',
  added_memory_feeling_Thankful: 'er takknemlig for {graveName}',
  added_memory_feeling_Missing: 'savner {graveName}',
  added_memory_feeling_Forgiving: 'tilgir {graveName}',
  view_header_desktop: 'Forhåndsvisning på skrivebord',
  view_header_mobile: 'Forhåndsvisning på mobil',
  memory_posts: 'Minneinnlegg',
  view_deceased_name: 'Gravens navn',
  grave_duplicate_title: 'Denne graven ser ut til å finnes allerede',
  grave_duplicate_message:
    'En grav med samme navn og detaljer finnes allerede i Nettgrav. Vi oppretter ikke en ny grav når vi finner en sikker match. Besøk den som finnes for å knytte deg til den.',
  grave_duplicate_button: 'Gå til eksisterende grav',
  create_grave_pending_review_notice:
    'Graven er sendt til Nettgrav for godkjenning og er ikke offentlig synlig ennå.',
  create_grave_create_error: 'Graven kunne ikke opprettes. Kontroller opplysningene og prøv igjen.',
  create_grave_potential_duplicates_title: 'Vi fant en lignende grav',
  create_grave_potential_duplicates_message:
    'Sjekk om en av disse er samme person før du oppretter en ny grav.',
  create_grave_potential_duplicates_button: 'Gå til graven',
  grave_create_invalid_date_title: 'Ugyldig datorekkefølge',
  grave_create_invalid_date_message:
    'Dødsdato kan ikke være før fødselsdato. Sjekk datoene og prøv igjen.',
  memory_feeling_tooltip: 'Stemning',
  memory_feeling: 'Stemning',
  conscious_verified_badge:
    'Du mottar et verifisert merke – et tegn på tillit, nærvær og omsorg i fellesskapet',
  conscious_supports_free_graves:
    'Du hjelper å holde alle graver åpne og ivaretatt, slik at alle kan minnes sine kjære uavhengig av betalingsevne.',
  conscious_ad_free_safe_space:
    'Du støtter et trygt, reklamefritt rom basert på tilhørighet, varme og ærlighet.',
  conscious_supports_community_and_mission:
    'Ditt bidrag opprettholder Nettgrav-fellesskapet og det bredere End Of Time-misjonen, nå og i fremtiden.',
  partner_page_title: 'Partnere – The End of Time',
  partner_page_mission: 'Støtt minne, takknemlighet og sannhet.',
  partner_welcome_title: 'Velkommen!',
  partner_welcome_message:
    'Bli partner. Støtt minne, takknemlighet og sannhet for familier og samfunn.',
  partner_company_name: 'Firmanavn',
  partner_company_website: 'Firmanettside',
  partner_company_mission: 'Kort misjonserklæring',
  partner_company_logo: 'Logo',
  partner_continue: 'Fortsett',
  partner_choose_context_title: 'Velg hvor du vil støtte',
  partner_appears_memory_album: 'Vises forsiktig ved siden av familienes minnealbum.',
  partner_appears_value_archive: 'Takknemlighet er mulig takket være våre partnere.',
  partner_appears_funeral_room: 'I partnerskap med deg for erindring.',
  partner_appears_anniversary_calendar: 'Feirer minner med hjelp fra partnere.',
  partner_appears_groups: 'Fellesskapsstøtte muliggjort av partnere.',
  partner_appears_store: 'Brakt til deg med omsorg av partnere.',
  partner_upload_or_generate_title: 'Last opp eller generer annonsen din',
  partner_upload_image_video: 'Last opp bilde/video',
  partner_select_theme: 'Velg tema',
  partner_select_theme_remembrance: 'Erindring',
  partner_select_theme_gratitude: 'Takknemlighet',
  partner_select_theme_support: 'Støtte',
  partner_or: 'Eller',
  partner_describe_generate:
    "Beskriv hva du vil generere (f.eks. 'et mykt lys med dempet bakgrunn')",
  partner_generate_ai: 'Generer med AI',
  partner_upload_success: 'Kreativt innhold lastet opp!',
  partner_generate_success: 'Generert med AI!',
  partner_write_message_title: 'Skriv din melding',
  partner_write_message_placeholder: 'Skriv en varm, støttende melding…',
  partner_make_warmer: 'Gjør den varmere / poetisk',
  partner_live_preview: 'Forhåndsvisning i sanntid',
  partner_message_preview_placeholder: 'Din melding vil vises her.',
  partner_set_commitment_title: 'Sett ditt engasjement',
  partner_commitment_cpm: 'CPM (per 1 000 visninger)',
  partner_commitment_cpm_desc: '~6 200 visninger/måned, 140 kr CPM',
  partner_commitment_cpc: 'CPC (per klikk)',
  partner_commitment_cpc_desc: 'Betal kun for hvert klikk',
  partner_commitment_flat: 'Fast månedlig sponsing',
  partner_commitment_flat_desc: 'Fast pris, alt inkludert',
  partner_campaign_summary: 'Din kampanjesammendrag',
  partner_estimated_monthly_reach: 'Estimert månedlig rekkevidde',
  partner_commitment: 'Engasjement',
  partner_submit_review: 'Send til gjennomgang',
  partner_status_thank_you: 'Takk! Partnerskapet gjennomgås innen 24 timer.',
  partner_status_subtitle:
    'Du får oppdatering via e-post når det er godkjent. Du kan følge status på dashbordet.',
  partner_go_to_dashboard: 'Gå til dashbord',
  partner_your_campaigns: 'Dine kampanjer',
  partner_placement: 'Plassering',
  partner_status: 'Status',
  partner_impressions: 'Visninger',
  partner_clicks: 'Klikk',
  partner_actions: 'Handlinger',
  partner_view_company: 'Vis selskap',
  partner_sponsored: 'End Of Time Call',
  partner_call_cta: 'End Of Time Call',
  partner_supported_by: 'Støttet av ❤️ {count} bevisste medlemmer',
  partner_highlight_this_partner: 'Fremhev denne partneren',
  partner_about: 'Om',
  partner_partner_since: 'Partner siden: {date}',
  partner_causes_supported: 'Støttede saker:',
  partner_active_campaigns: 'Aktive kampanjer:',
  partner_families_supported: 'Familier støttet',
  partner_testimonials: 'Anbefalinger:',
  partner_total_highlights: 'Totalt fremhevet',
  partner_see_support_helps: 'Se hvordan støtten hjelper',
  partner_share_impact: 'Del denne partnerens innvirkning',
  partner_invite_more_causes: 'Inviter partneren til å støtte flere saker',
  partner_review_preview_title: 'Gjennomgå & forhåndsvis',
  partner_review_ad_preview: 'Annonse­forhåndsvisning',
  partner_review_placement: 'Plassering',
  partner_review_company: 'Selskap',
  partner_review_website: 'Nettsted',
  partner_review_mission: 'Misjon',
  partner_review_billing: 'Fakturering',
  partner_confirm_submit: 'Bekreft & send',
  partner_appears_key_memory_album: 'Minne­album',
  partner_appears_key_value_archive: 'Egenskaper',
  partner_appears_key_funeral_room: 'Kirkestue',
  partner_appears_key_anniversary_calendar: 'Merkedags­kalender',
  partner_appears_key_groups: 'Grupper/Fellesskap',
  partner_appears_key_store: 'Butikk/Netthandel',
  account_form_email_label: 'E-post',
  account_form_email_placeholder: 'Skriv inn e-posten din',
  account_form_email_required: 'Fyll inn e-post',
  account_form_email_invalid: 'Fyll inn en gyldig e-postadresse',
  account_form_userName_label: 'Navn',
  account_form_userName_placeholder: 'Skriv inn navnet ditt',
  account_form_userName_required: 'Fyll inn navnet ditt',
  account_form_userName_invalid: 'Navnet må inneholde minst én bokstav',
  account_form_gender_label: 'Kjønn',
  account_form_gender_placeholder: 'Velg kjønn',
  account_form_gender_required: 'Velg kjønn',
  account_form_gender_option_male: 'Mann',
  account_form_gender_option_female: 'Kvinne',
  account_form_gender_option_other: 'Annet',
  account_form_password_label: 'Passord',
  account_form_password_placeholder: 'Skriv inn passordet ditt',
  account_form_password_required: 'Fyll inn passord',
  account_form_password_min: 'Bruk minst 8 tegn.',
  account_form_password_max: 'Bruk maksimalt 128 tegn.',
  account_form_confirmPassword_label: 'Bekreft passord',
  account_form_confirmPassword_placeholder: 'Bekreft passordet ditt',
  account_form_confirmPassword_required: 'Bekreft passordet ditt',
  account_form_confirmPassword_match: 'Passordene stemmer ikke overens',
  not_authorized: 'Du er ikke autorisert',
  account_form_country_label: 'Land',
  account_form_country_placeholder: 'Velg land',
  account_form_country_required: 'Velg landet ditt',
  account_form_dateOfBirth_label: 'Fødselsdato',
  account_form_dateOfBirth_placeholder: 'Velg dato',
  account_form_dateOfBirth_required: 'Velg fødselsdatoen din',
  account_form_dateOfBirth_underage: 'Tilgjengelig fra 13 år.',
  account_form_language_label: 'Språk',
  account_form_language_placeholder: 'Velg språk',
  account_form_language_required: 'Velg foretrukket språk',
  language_english: 'Engelsk',
  language_norwegian: 'Norsk',
  language_danish: 'Dansk',
  language_swedish: 'Svensk',
  language_finnish: 'Finsk',
  account_form_checked_label: 'Jeg godtar {termsLink}',
  account_form_checked_required: 'Godta for å fortsette.',
  account_form_creating_account: 'Oppretter konto...',
  see_more: 'Se mer',
  filter_button: 'Filtrer graver',
  account_form_submit: 'Opprett konto',
  registration_too_many_attempts: 'For mange registreringsforsøk. Vent litt før du prøver igjen.',
  registration_failed: 'Vi kunne ikke opprette kontoen. Prøv igjen.',
  grave_tab: 'Søk',
  home_welcome: 'Ta graven i skyen med nettgrav.no.',
  home_subheading: 'Tilgjengelig og nær i livet ditt. Søk på navn for å komme i gang.',
  home_create_account: 'Opprett konto',
  home_login: 'Logg inn',
  home_terms: 'Ved å fortsette godtar du våre',
  footer_copyright: '© 2013–2026 Nettgrav.no.',
  footer_built_by: 'The End Of Time Corporation',
  footer_teotc_name: 'Nettgrav utvikles i Norge av The End of Time Corporation.',
  footer_intro_eyebrow: 'Nettgrav — der kjærligheten aldri slutter.',
  footer_intro_body: 'Produkter og tjenester fra ett perspektiv — det som står seg i all tid.',
  footer_col_nettgrav: 'Nettgrav',
  footer_col_explore: 'Utforsk',
  footer_col_teotc: 'End of Time',
  footer_col_contact: 'Kontakt',
  footer_find_grave: 'Finn en grav',
  footer_graves: 'Søk i alle graver',
  footer_about: 'Om Nettgrav',
  footer_create_spark: 'Skap Gnist',
  footer_my_light: 'Mitt lys',
  footer_rooms: 'Rom',
  footer_partner: 'Partner',
  footer_how_it_works: 'Slik fungerer Nettgrav',
  footer_create_nettgrav: 'Opprett en Nettgrav',
  footer_about_teotc: 'Om TEOTC',
  footer_nettarv: 'Nettarv',
  footer_matvarebutikken: 'Matvarebutikken',
  footer_become_partner: 'Bli partner',
  footer_privacy: 'Personvern',
  footer_terms: 'Vilkår',
  footer_cookies: 'Cookies',
  footer_end_of_time_center: 'The End of Time Center',
  footer_end_of_time_chat: 'End Of Time Chat',
  my_light_info_title: 'Mitt lys',
  my_light_info_intro: 'Et sted for det som betyr mest for deg, i ditt eget tempo.',
  my_light_info_body_1: 'Mitt lys er din livsside i Nettgrav.',
  my_light_info_body_2:
    'Her knytter du deg til mennesker du bryr deg om, bygger relasjoner over tid – og kan gjøre det viktigste tydelig.',
  my_light_info_body_3: 'Dette handler ikke om å dele mest.',
  my_light_info_body_4: 'Det handler om å være til stede.',
  my_light_info_section_what_you_can_do_title: 'Hva du kan gjøre i Mitt lys',
  my_light_info_body_5: 'Du kan:',
  my_light_info_body_6: 'styrke relasjonene til menneskene du bryr deg om',
  my_light_info_body_7: 'dele ord og nærvær som gjør godt',
  my_light_info_body_8: '• si gode ord til hverandre – mens vi lever',
  my_light_info_body_9: 'velge Måner – de nærmeste du stoler på',
  my_light_info_body_10:
    'sette retning med Mitt kompass og gjøre det viktigste tydelig i Etter meg',
  my_light_info_body_11: 'Mitt lys rommer både livet nå – og retningen videre.',
  my_light_info_section_not_title: 'Hva dette ikke er',
  my_light_info_body_12:
    'Mitt lys er ikke et sosialt nettverk. Det handler ikke om tempo, oppmerksomhet eller vekst.',
  my_light_info_body_13: 'Her kan det viktigste deles med ro, nærhet og omtanke.',
  my_light_info_section_why_title: 'Hvorfor finnes det?',
  my_light_info_body_14: 'Fordi mennesker trenger hverandre.',
  my_light_info_body_15: 'Og fordi det er godt å si det som betyr noe – mens vi lever.',
  my_light_info_cta: 'Gå til Mitt lys',
  'my_light_guest_preview.eyebrow': 'For deg som er gjest',
  'my_light_guest_preview.supporting': 'Her ser du hva Mitt lys inneholder.',
  'my_light_guest_preview.primary_cta': 'Logg inn til Mitt lys',
  'my_light_guest_preview.secondary_cta': 'Opprett konto',
  'my_light_guest_preview.panel_label': 'Dette inneholder Mitt lys',
  'my_light_guest_preview.modules_title': 'Slik ser Mitt lys ut',
  'my_light_guest_preview.modules_intro': 'Dette er områdene du møter i Mitt lys.',
  'my_light_guest_preview.card_about_title': 'Om meg',
  'my_light_guest_preview.card_about_body':
    'En kort introduksjon, noen linjer om hvem du er, og tre spørsmål som fanger livet slik det kjennes nå.',
  'my_light_guest_preview.card_relations_title': 'De nære rundt deg',
  'my_light_guest_preview.card_relations_body':
    'Her ser du de nærmeste rundt deg, og hvem som har en særlig rolle når noe betyr mest.',
  'my_light_guest_preview.card_compass_title': 'Mitt kompass',
  'my_light_guest_preview.card_compass_body':
    'Her setter du ord på hva som holder deg på kurs, hva som betyr mest, og hva andre bør forstå om deg.',
  'my_light_guest_preview.card_moons_title': 'Måner',
  'my_light_guest_preview.card_moons_body':
    'Måner er de nærmeste du stoler på, som påvirker livet ditt med nærhet, retning og trygghet.',
  'my_light_guest_preview.card_after_me_title': 'Etter meg',
  'my_light_guest_preview.card_after_me_body':
    'Etter meg er stedet der du gjør det viktigste tydelig for dem du er glad i.',
  'my_light_guest_preview.footer_title': 'Et personlig sted for relasjon og ansvar',
  'my_light_guest_preview.sample_name': 'Eksempelprofil',
  'my_light_guest_preview.sample_role': 'Lærer og forelder',
  'my_light_guest_preview.sample_bio':
    'Jeg prøver å gi plass til ærlige samtaler, rolige morgener og menneskene jeg trenger å holde meg nær.',
  'my_light_guest_preview.answer_1': 'Å verne om tiden med menneskene jeg er glad i.',
  'my_light_guest_preview.answer_2': 'Gåturer, stillhet og én sann samtale.',
  'my_light_guest_preview.connection_name_1': 'Anna Berg',
  'my_light_guest_preview.connection_role_1': 'Søster',
  'my_light_guest_preview.connection_name_2': 'Isak Berg',
  'my_light_guest_preview.connection_role_2': 'Familievenn',
  'my_light_guest_preview.compass_value_1': 'Jeg vil ikke miste kontakten med det som betyr mest.',
  'my_light_guest_preview.compass_value_2': 'Skaper dette mer sannhet, eller bare mindre ubehag?',
  'my_light_guest_preview.moon_name_1': 'Liv',
  'my_light_guest_preview.moon_role_1': 'Nær venn',
  'my_light_guest_preview.moon_name_2': 'Maren',
  'my_light_guest_preview.moon_role_2': 'Datter',
  'my_light_guest_preview.moon_status': 'Måne',
  'my_light_guest_preview.after_me_status': 'Oppdatert',
  'my_light_guest_preview.after_me_updated': 'Oppdatert nylig',
  'my_light_guest_preview.after_me_message':
    'Hvis noe skjer, la det få være enkelt, varmt og uten gjetting.',
  end_of_time_center_title: 'The End of Time Center',
  end_of_time_center_intro: 'Et arbeid som begynner der livet tar slutt.',
  end_of_time_center_body_1:
    'En grav finnes fordi et menneske har dødd – og det i seg selv forplikter.',
  end_of_time_center_body_2:
    'The End of Time Center søker forståelse av hvorfor liv tar slutt – og hvordan kunnskap, innsikt og forskning kan bidra til at færre liv gjør det i fremtiden.\nIkke gjennom løfter, men gjennom langsiktig og ansvarlig arbeid.',
  end_of_time_center_section_1_title: 'Fra tap til handling',
  end_of_time_center_section_1_body_1:
    'For mange stopper alt ved døden.\nThe End of Time Center begynner der.',
  end_of_time_center_section_1_body_2:
    'Når et menneske dør, oppstår spørsmål som ikke kan besvares av minner alene. Her samles forskning, refleksjon og utvikling med mål om å forstå livets sårbarhet, tidens rolle i sykdom, aldring og død.',
  end_of_time_center_section_1_body_3: 'Dette er ikke et minnearbeid.\nDet er et ansvar.',
  end_of_time_center_section_2_title: 'Graven som bro',
  end_of_time_center_section_2_body_1:
    'Gjennom Nettgrav blir graven mer enn et sted for stillhet.\nDen blir en bro mellom det som har vært, og det som kan bli.',
  end_of_time_center_section_2_body_2:
    'Handlinger knyttet til graven – som lys, sirkler og tilstedeværelse – er forankret i The End of Time Center. Slik gis graven en retning videre, mot forståelse, sammenheng og forskning på livets grenser.\nDette arbeidet omtales som End of Time Care.',
  end_of_time_center_section_3_title: 'Et langsiktig arbeid',
  end_of_time_center_section_3_body_1:
    'The End of Time Center er et langsiktig initiativ under The End Of Time Corporation. Arbeidet er forankret i Norge og utvikles med respekt for livets kompleksitet og menneskets behov for mening.',
  end_of_time_center_section_3_body_2:
    'Dette er ikke et prosjekt som skal vokse raskt.\nDet er et arbeid som skal stå over tid.',
  end_of_time_center_section_4_title: 'Derfor finnes The End of Time Center',
  end_of_time_center_section_4_body_1:
    'Fordi et liv tok slutt.\nDet ble til en grav.\nOg fordi det forplikter.',
  end_of_time_chat_title: 'End Of Time Chat',
  end_of_time_chat_intro: 'Samtaler som tåler stillhet',
  end_of_time_chat_beta_label: 'Beta-versjon',
  end_of_time_chat_beta_short:
    'Den grunnleggende krypteringsbeskyttelsen er aktiv. Fordi dette er en beta, kan enkelte funksjoner og deler av grensesnittet endres.',
  end_of_time_chat_open_beta: 'Åpne beta-chatten',
  end_of_time_chat_explore_security: 'Slik beskyttes samtalene dine',
  end_of_time_chat_security_eyebrow: 'Privat som utgangspunkt',
  end_of_time_chat_security_summary_title: 'Beskyttelsesstatus',
  end_of_time_chat_security_active: 'Aktiv',
  end_of_time_chat_security_note:
    'Samtalene dine er beskyttet med kryptering og andre sikkerhetstiltak, men ingen digital tjeneste kan garantere fullstendig sikkerhet.',
  end_of_time_chat_beta_title: 'Klar til bruk, fortsatt under forbedring',
  end_of_time_chat_beta_body:
    'End of Time Chat er nå tilgjengelig som beta. Du kan møte uferdige detaljer mens vi forbedrer stabilitet, samtaler, synkronisering og helhetsopplevelsen.',
  end_of_time_chat_beta_point_1:
    'Funksjoner og detaljer i grensesnittet kan endres i beta-perioden.',
  end_of_time_chat_beta_point_2:
    'Midlertidige problemer med synkronisering eller tilkobling av samtaler kan oppstå.',
  end_of_time_chat_beta_point_3:
    'Ikke bruk en beta-tjeneste til nødsituasjoner eller tidskritisk kommunikasjon.',
  end_of_time_chat_security_title: 'Bygget for å beskytte samtalen',
  end_of_time_chat_security_intro:
    'Kryptering er ikke et valgfritt tillegg. Det er en del av hvordan meldinger, grupper og samtaler er utformet fra starten.',
  end_of_time_chat_e2ee_title: 'Ende-til-ende-kryptering',
  end_of_time_chat_e2ee_body:
    'Innholdet i samtalen krypteres på deltakernes enheter. Nettgrav transporterer krypterte data, ikke en lesbar kopi av samtalen din.',
  end_of_time_chat_pq_title: 'Hybrid post-kvantebeskyttelse',
  end_of_time_chat_pq_body:
    'Hybrid X-Wing-nøkkelutveksling kombinerer etablert kryptografi med post-kvantebeskyttelse. Dette bidrar til å redusere risikoen for at kryptert trafikk lagres i dag og dekrypteres av fremtidige kvantedatamaskiner.',
  end_of_time_chat_mls_title: 'Sikker rotasjon av gruppenøkler',
  end_of_time_chat_mls_body:
    'Messaging Layer Security oppdaterer gruppehemmeligheter når medlemskap og samtaletilstand endres, og bidrar til å begrense konsekvensene av en kompromittert nøkkel over tid.',
  end_of_time_chat_cta_title: 'Et tryggere rom for samtaler som betyr noe',
  end_of_time_chat_cta_body:
    'Bruk betaen, fortell oss hva som ikke fungerer som forventet, og hjelp oss med å gjøre privat kommunikasjon mer pålitelig.',
  end_of_time_chat_feedback: 'Rapporter et beta-problem',
  end_of_time_chat_body_1: 'Kommer snart',
  end_of_time_chat_body_2:
    'Noen samtaler er for sårbare for det åpne. Andre er for sanne til å forsvinne.',
  end_of_time_chat_body_3:
    'End of Time Chat er laget for mennesker som ønsker et trygt rom for nære samtaler – der relasjoner kan få leve videre med ærlighet, ømhet og tid.',
  end_of_time_chat_section_1_title: 'Et rom, ikke en strøm',
  end_of_time_chat_section_1_body_1:
    'Dette er ikke en sosial plattform.\nDet er ikke et sted for synlighet, tempo eller prestasjon.',
  end_of_time_chat_section_1_body_2:
    'End of Time Chat er et lukket rom mellom mennesker som har valgt hverandre.\nSamtalene får være det de er – uten publikum.',
  end_of_time_chat_section_2_title: 'Bygget for trygghet',
  end_of_time_chat_section_2_body_1:
    'Samtalene er ende-til-ende-kryptert og bygget med sikkerhet som grunnprinsipp. Det som deles, forblir mellom dem det tilhører.',
  end_of_time_chat_section_2_body_2:
    'Teknologien er der for én grunn:\nÅ beskytte det menneskelige.',
  end_of_time_chat_section_3_title: 'Hvorfor End Of Time Chat finnes',
  end_of_time_chat_section_3_body_1:
    'Fordi relasjoner ikke slutter når livet blir vanskelig.\nFordi nærhet trenger rom som ikke utnytter sårbarhet.\nFordi noen ord bare kan deles når det er trygt å gjøre det.',
  end_of_time_chat_section_3_body_2:
    'End of Time Chat er også skapt for samtalene man ønsker å ta mens man lever.\nFor å kunne si det man tror på.\nFor å vise hva som er viktig.\nFor å være den som sier jeg elsker deg først.',
  end_of_time_chat_section_3_body_3:
    'Det er styrke i å være ekte.\nOgså når det ikke blir møtt.\nOgså når det gjør en sårbar.',
  end_of_time_chat_section_4_title: 'En del av Nettgrav',
  end_of_time_chat_section_4_body_1:
    'End of Time Chat er utviklet som en del av Nettgrav.\nEt sted for liv, relasjoner og tilstedeværelse – også etter tap.',
  end_of_time_chat_section_5_title: 'Et grunnleggende prinsipp',
  end_of_time_chat_section_5_body_1:
    'End of Time Chat er ikke et produkt.\nDet er et rom som beskytter relasjoner.',
  about_nettgrav_title: 'Om Nettgrav',
  about_nettgrav_intro:
    'Nettgrav er skapt for nærhet både til dem som er gravlagt og til dem som lever videre.',
  about_nettgrav_body_1:
    'Når døden inntreffer, oppstår behov som en fysisk grav alene ikke alltid kan romme. Nettgrav gjør det mulig å være til stede også på nett – på tvers av tid, avstand og livssituasjoner.',
  about_nettgrav_body_2:
    'Graven er mer enn et sted. Den rommer et menneske, et levd liv og relasjonene rundt. Nettgrav er laget for å gi dette rommet verdighet og varighet, slik at nærhet kan fortsette på egne premisser.',
  about_nettgrav_body_3:
    'Nettgrav eksisterer uavhengig av den fysiske graven. Selv om en grav endres, flyttes eller gjenbrukes, består Nettgraven som et varig sted for tilhørighet, historier og sammenheng.',
  about_nettgrav_body_4:
    'Tjenesten er utviklet i Norge med fokus på varighet, respekt og menneskelig nærhet. Nettgrav er støttet av offentlige innovasjonsmidler gjennom Innovasjon Norge, og er i stor grad bygget med støtte fra familie og venner.',
  about_nettgrav_body_5:
    'Nettgrav er en del av The End Of Time Corporation – et norsk, langsiktig arbeid som utvikler tjenester i møte med døden, tiden og menneskets behov for mening og sammenheng.',
  create_spark_title: 'Skap Gnist',
  create_spark_intro: 'Et rom for det som er sant for deg',
  create_spark_body_1: 'Å stå for det man tror på kan være en emosjonell reise.',
  create_spark_body_2:
    'Skap Gnist gir rom for å sette ord på det som er sant for deg – mens du lever.',
  create_spark_body_3: 'En gnist kan være en tanke, en verdi, en undring eller en refleksjon.',
  create_spark_body_4: 'Noe du ønsker å uttrykke, uten krav om fasit eller respons.',
  create_spark_body_5:
    'Å skape gnist handler ikke om å overbevise andre, men om å være ærlig i møte med seg selv og verden rundt.',
  create_spark_body_6: 'I Nettgrav finnes både liv og minner.',
  create_spark_body_7: 'Gravene rommer historien. Gnister rommer det som lever nå.',
  partner_title: 'Partner',
  partner_intro:
    'Nettgrav samarbeider med partnere som ønsker å bidra til gode liv for mennesker og familier som bruker Nettgrav.',
  partner_body_1:
    'Samarbeid på Nettgrav handler om å støtte mennesker i livets viktige øyeblikk – med nærhet, omsorg og langsiktighet. Sammen ønsker vi å fremme emosjonell og psykisk robusthet, og valg som gir mening og står seg over tid.',
  partner_body_2:
    'For organisasjoner og merkevarer som ønsker å bygge samfunn gjennom deling og raushet, finnes vårt partnerprogram i samarbeid med End of Time – et nettverk som investerer ressurser der de trengs.',
  partner_cta: 'Bli partner',
  how_it_works_title: 'Slik fungerer Nettgrav',
  how_it_works_intro: 'Nettgrav er et sted for nærhet til dine mennesker og det som betyr noe.',
  how_it_works_lead_1:
    'Et sted som finnes ved siden av den fysiske graven – og som består over tid.',
  how_it_works_lead_2: 'Denne siden forklarer hvordan Nettgrav fungerer, og hva du kan forvente.',
  how_it_works_section_1_title: 'Et sted ved siden av den fysiske graven',
  how_it_works_section_1_body_1: 'Den fysiske graven er et sted man kan besøke.',
  how_it_works_section_1_body_2:
    'Nettgrav gjør det mulig å være til stede også på nett, når avstand, tid eller livssituasjon gjør det vanskelig å komme dit.',
  how_it_works_section_1_body_3: 'Nettgrav er uavhengig av varigheten på den fysiske graven.',
  how_it_works_section_1_body_4:
    'Selv om en grav endres, flyttes eller gjenbrukes, består Nettgraven som et varig sted for tilhørighet.',
  create_nettgrav_title: 'Opprette en Nettgrav',
  create_nettgrav_intro: 'En Nettgrav kan opprettes når det trengs.',
  create_nettgrav_body_1:
    'For å opprette en Nettgrav legger du inn navnet på den som er gravlagt, og velger kommune og gravlund dersom dette er kjent.',
  create_nettgrav_body_2: 'Nettgrav er ikke avhengig av den fysiske graven.',
  create_nettgrav_body_3: 'Den gravlagte er vårt utgangspunkt – ikke stedet.',
  create_nettgrav_section_create_title: 'Opprette grav på nett',
  create_nettgrav_section_missing_title: 'Når kommune eller gravlund mangler',
  create_nettgrav_missing_body_1:
    'Nettgrav vil over tid ikke fokusere på å registrere alle kommuner og gravlunder.',
  create_nettgrav_missing_body_2: 'Hvis kommunen eller gravlunden ikke finnes i listen, velger du:',
  create_nettgrav_missing_body_3: 'Nettgrav som kommune',
  create_nettgrav_missing_body_4: 'End Of Time Cemetery som gravlund',
  create_nettgrav_missing_body_5: 'Da opprettes Nettgraven uten kostnad.',
  create_nettgrav_missing_body_6:
    'Denne Nettgraven fungerer på samme måte som alle andre, og gir et varig digitalt sted for nærhet, minner og relasjoner.',
  create_nettgrav_section_place_title: 'Digital grav opprettelse – et sted som varer',
  create_nettgrav_place_body_1: 'Nettgrav bygger på en enkel tanke:',
  create_nettgrav_place_body_2: 'Den gravlagte er et annet sted enn den fysiske graven.',
  create_nettgrav_place_body_3:
    'Derfor er Nettgrav laget for dem som lever videre – familie, venner og nære – og for forbindelsen som består over tid.',
  create_nettgrav_place_body_4:
    'End Of Time Cemetery er Nettgravs egen gravlund, laget for å romme Nettgraver uavhengig av fysisk sted, og ment å stå seg over tid.',
  create_nettgrav_section_login_title: 'Logg inn og opprett ny Nettgrav',
  create_nettgrav_login_body_1: 'Logg inn og opprett ny Nettgrav',
  create_nettgrav_login_cta: 'Logg inn og opprett ny Nettgrav',
  how_it_works_section_2_title: 'Finn eller besøk en grav',
  how_it_works_section_2_body_1: 'På Nettgrav kan du:',
  how_it_works_section_2_body_2: 'finne eksisterende graver',
  how_it_works_section_2_body_3: 'opprette en ny Nettgrav',
  how_it_works_section_2_body_4: 'besøke en grav på nett',
  how_it_works_section_2_body_5: 'knytte din relasjon til den som er gravlagt',
  how_it_works_section_2_body_6:
    'bli kjent med mennesket graven representerer. Du trenger ikke gjøre noe bestemt. Det er mulig å bare være innom – stille og uten krav.',
  how_it_works_section_3_title: 'Små handlinger som betyr noe',
  how_it_works_section_3_body_1: 'Nettgrav er bygget rundt enkle handlinger:',
  how_it_works_section_3_body_2: 'sende en gave',
  how_it_works_section_3_body_3: 'dele noen ord',
  how_it_works_section_3_body_4: 'legge til et bilde eller et minne',
  how_it_works_section_3_body_5: 'markere merkedager',
  how_it_works_section_3_body_6: 'Alt er frivillig og kan gjøres når det føles riktig.',
  how_it_works_section_3_body_7: 'Ingen forventninger. Ingen tidsfrister.',
  how_it_works_section_4_title: 'Familie og nære',
  how_it_works_section_4_body_1: 'Nettgrav kan deles med familie og mennesker som hører til.',
  how_it_works_section_4_body_2: 'Du velger selv:',
  how_it_works_section_4_body_3: 'hvem som har tilgang',
  how_it_works_section_4_body_4: 'hva som deles',
  how_it_works_section_4_body_5: 'hvordan graven forvaltes over tid',
  how_it_works_section_4_body_6: 'Slik kan flere være til stede – på egne premisser.',
  how_it_works_section_5_title: 'Personvern og trygghet',
  how_it_works_section_5_body_1: 'Nettgrav er laget for emosjonell og menneskelig trygghet.',
  how_it_works_section_5_body_2: 'Innhold kan være:',
  how_it_works_section_5_body_3: 'privat',
  how_it_works_section_5_body_4: 'synlig for inviterte',
  how_it_works_section_5_body_5: 'åpent for alle som besøker graven',
  how_it_works_section_5_body_6: 'Du har kontroll og kan endre dette når det føles riktig.',
  how_it_works_section_6_title: 'Skap Gnist – liv som lever nå',
  how_it_works_section_6_body_1: 'I tillegg til Nettgrav finnes Skap Gnist.',
  how_it_works_section_6_body_2:
    'Skap Gnist er et rom for refleksjon, tanker og det som er sant for deg – mens du lever.',
  how_it_works_section_6_body_3: 'Her kan ord deles som uttrykk for liv, mening og sammenheng.',
  how_it_works_section_6_body_4: 'Gravene rommer historien.',
  how_it_works_section_6_body_5: 'Gnister rommer det som lever nå.',
  how_it_works_section_7_title: 'Et sted laget for å vare',
  how_it_works_section_7_body_1: 'Nettgrav er bygget med tanke på tid.',
  how_it_works_section_7_body_2:
    'Det er et sted som ikke forsvinner, og som ikke krever vedlikehold.',
  how_it_works_section_7_body_3: 'Et varig rom for nærhet til livet.',
  how_it_works_section_7_body_4: 'Du kan komme tilbake når du vil.',
  how_it_works_section_7_body_5: 'Det holder å være der.',
  orbit_section_header: 'Jordens posisjon',
  orbit_intro_text:
    'Vi reiser alle sammen på denne store reisen rundt solen. Du er aldri alene her.',
  orbit_day_progress: 'Dag {day} av 365',
  orbit_position_label: 'Jordens posisjon: {position}°',
  page_not_found: 'Denne siden finnes ikke.',
  grave_load_server_error: 'Noe gikk galt på serveren. Last inn siden på nytt.',
  grave_load_failed: 'Vi klarte ikke å hente gravstedet. Prøv igjen.',
  grave_user_load_failed: 'Vi klarte ikke å hente brukerinformasjonen. Prøv igjen.',
  grave_static_data_load_failed: 'Vi klarte ikke å hente nødvendig informasjon. Prøv igjen.',
  search_event: 'Søk etter hendelse, dato',
  add_new: 'Legg til ny',
  search_tab_all: 'Alle',
  search_tab_graves: 'Graver',
  search_tab_members: 'Mennesker',
  search_people_none_text: 'Ingen medlemmer funnet for',
  user_age: 'Alder:',
  user_shared_grave: 'delt grav',
  user_shared_graves: 'delte graver',
  view_life_page: 'Se Liv-siden',
  see_my_light: 'Se Mitt lys',
  see_user_light: 'Se {name} sitt lys',
  relation_to: 'til',
  user_values_heading:
    'Her kan de som er knyttet til deg uttrykke hvordan de opplever deg. Du kan også besøke en person og gjøre godt for dem.',
  add_user_values: 'Si noe du ser',
  user_values_modal_title: 'Hva ser du i {name}?',
  user_values_modal_subtitle:
    'To let someone know that you value and see their inner being is truly valuable. The value given and received is unending.',
  user_values_select_category: 'Select category',
  user_values_select_value: 'Velg et ord som du kjenner igjen.',
  user_values_save: 'Save',
  user_values_note_placeholder: 'Legg til et notat',
  family_tree_page_title: 'Familietrær',
  family_tree_set_relationships: 'Sett relasjoner',
  family_tree_set_relationship: 'Sett relasjon',
  family_tree_choose_my_relation: 'Velg min relasjon',
  family_tree_people_you_might_know: 'Forslag til slekt',
  family_tree_no_suggestions: 'Ingen forslag ennå',
  family_tree_relations_in_tree: 'Relasjoner i treet',
  family_tree_relations_radius_hint:
    'Viser relasjoner som er med i treet innenfor {count} generasjoner.',
  family_tree_focus_in_tree: 'Fokuser i treet',
  family_tree_group_parents: 'Foreldre',
  family_tree_group_partners: 'Partnere',
  family_tree_group_siblings: 'Søsken',
  family_tree_group_children: 'Barn og etterkommere',
  family_tree_group_grandparents_list: 'Besteforeldre og eldre slektsledd',
  family_tree_group_extended_family: 'Andre i familien',
  family_tree_open_relation: 'Åpne',
  family_tree_open_grave: 'Gå til grav',
  family_tree_open_light: 'Gå til lys',
  family_tree_suggestion_likely_relation: 'Kan være din {relation}',
  family_tree_suggestion_via: 'Via {name}',
  family_tree_your_relations: 'Dine relasjoner',
  family_tree_empty_title: 'Familietreet kommer her.',
  family_tree_empty_description:
    'Du kan allerede sette relasjoner til gravlagte og se båndene ta form. Dette er en tidlig versjon – flere grener og funksjoner kommer snart.',
  family_tree_card_title: 'Ditt familietre',
  family_tree_card_members: '{count} medlemmer',
  family_tree_card_description: 'Du og dine to sønner er her',
  family_tree_view_tree: 'Vis familietre',
  family_tree_empty_state:
    'Relasjonene dine vises her. Start med å knytte en relasjon til en grav eller en person.',
  family_tree_no_relations: '{firstName}s nettverk er ikke komplett uten dette.',
  family_tree_connect_relation: 'Knytt relasjon',
  family_tree_load_more: 'Last mer',
  family_tree_no_info: 'Ingen informasjon',
  family_tree_single_node_hint:
    'Familietreet bygges ved å knytte relasjoner til graver og personer, for eksempel foreldre eller barn.',
  family_tree_modal_title: 'Velg din relasjon til {name}',
  family_tree_modal_suggestion_title: 'Velg din relasjon til {name}',
  family_tree_modal_claim_title: 'Omsorgsansvar for graven',
  family_tree_modal_add_mother_title: 'Legg til mor',
  family_tree_modal_add_father_title: 'Legg til far',
  family_tree_role_mother: 'mor',
  family_tree_role_father: 'far',
  family_tree_role_person: 'person',
  family_tree_modal_tab_relation: 'Relasjon',
  family_tree_modal_tab_care: 'Bli verge',
  family_tree_modal_select_grave_label: 'Skriv og velg grav-/livsside',
  family_tree_modal_select_grave_placeholder: 'Skriv og velg et navn',
  family_tree_modal_search_person_label: 'Finn person',
  family_tree_modal_search_person_placeholder: 'Finn {role}',
  family_tree_modal_search_person_hint: 'Skriv minst to bokstaver for å søke på navn.',
  family_tree_modal_locked_relation_label: 'Relasjon',
  family_tree_modal_locked_relation_value: 'Registreres som: {relation}',
  family_tree_modal_invite_person: 'Ingen treff ennå. Prøv fullt navn eller en annen stavemåte.',
  family_tree_modal_relation_to_person_label: 'Din relasjon til {name}',
  family_tree_modal_relation_to_you_label: 'Hva er denne personens relasjon til deg?',
  family_tree_modal_relation_to_you_with_name_label: 'Hva er {name}s relasjon til deg?',
  family_tree_connect_relations_modal_title: 'Koble relasjoner',
  family_tree_connect_relations_modal_subtitle: 'Enkelt å koble ulike slektninger til hverandre',
  family_tree_connect_relations_first_label: 'Velg en slektning',
  family_tree_connect_relations_second_label: 'Velg slektningen du vil knytte til den over',
  family_tree_connect_relations_third_label: 'Velg {from}s relasjon til {to}',
  family_tree_connect_relations_third_label_default: 'Velg første persons relasjon til den andre',
  family_tree_connect_relations_fourth_label: 'Hva er {to}s relasjon til {from}',
  family_tree_connect_relations_fourth_label_default:
    'Hva er den andre personens relasjon til den første',
  family_tree_tab: 'Familietre',
  waiting_for_approval: 'Venter på godkjenning',
  family_tree_tree_tab: 'Tre',
  family_tree_no_grave_selected: 'Velg en person for å starte familietreet.',
  family_tree_me_label: 'Meg',
  family_tree_you_label: 'Deg',
  family_tree_you_are_relation: 'Du er {relation}',
  family_tree_additional_connections: '+{count} flere',
  family_tree_connected_relatives: 'Tilknyttede slektninger',
  family_tree_modal_reciprocal_label: '{name}s relasjon til deg',
  family_tree_modal_more_relations: 'Flere valg',
  family_tree_modal_confirm_relation: 'Bekreft relasjonen',
  family_tree_modal_confirm_care: 'Bekreft omsorgsansvar',
  family_tree_modal_relation_search_placeholder: 'Søk relasjoner',
  family_tree_modal_relation_search_no_results: 'Ingen samsvarende relasjoner',
  family_tree_depth: 'Dybde',
  family_tree_radius_label: 'Generasjoner',
  family_tree_radius_help: 'Vis flere generasjoner i familietreet.',
  family_tree_radius_decrease: 'Vis færre generasjoner',
  family_tree_radius_increase: 'Vis flere generasjoner',
  family_tree_zoom_label: 'Zoom',
  family_tree_zoom_in: 'Zoom inn',
  family_tree_zoom_out: 'Zoom ut',
  family_tree_fit_view: 'Tilpass hele treet',
  family_tree_center_viewer: 'Sentrer på meg',
  family_tree_toggle_panel: 'Panel',
  family_tree_children: 'Barn',
  family_tree_partners: 'Partnere',
  family_tree_siblings: 'Søsken',
  family_tree_relation_of_user: '{relation} til {name}',
  family_tree_deceased_relation_to_user: '{deceased} er {relation} til {name}',
  family_tree_unknown_person: 'Denne personen',
  family_tree_senses_title: 'Sanser',
  family_tree_add_skill: 'Legg til talent',
  family_tree_talent_name_placeholder: 'Velg et forslag eller skriv talent, gave eller evne',
  family_tree_talent_note_placeholder: 'Valgfri merknad (hvordan dette vises i livet)',
  family_tree_no_skills: 'Ingen talenter lagt til ennå',
  family_tree_cycles_broken_title: 'Mønstre som ble endret',
  family_tree_add_cycle_broken: 'Legg til endring',
  family_tree_cycle_name_placeholder:
    'Velg et forslag eller skriv et mønster eller en endring selv',
  family_tree_cycle_note_placeholder: 'Hva gjorde denne endringen mulig?',
  family_tree_no_cycles_broken: 'Ingen endringer lagt til ennå',
  family_tree_shared_lineage_title: 'Mønstre i familien',
  family_tree_shared_lineage_intro: 'Noen ting går igjen gjennom generasjoner.',
  family_tree_no_shared_lineage: 'Her kan slike mønstre bli synlige over tid.',
  family_tree_trait_signal_personal_memory: 'Personlig minne',
  family_tree_trait_signal_possible_family_pattern: 'Mulig familiemønster',
  family_tree_trait_signal_family_confirmed: 'Familiebekreftet',
  family_tree_trait_signal_personal_transformation: 'Personlig endring',
  family_tree_trait_signal_possible_family_transformation: 'Mulig familieendring',
  family_tree_trait_signal_family_confirmed_transformation: 'Familiebekreftet endring',
  family_tree_group_cycles: 'Endringer',
  family_tree_find_and_add: 'Finn og legg til trekk',
  family_tree_done: 'Ferdig',
  family_tree_search_loading: 'Laster...',
  family_tree_search_no_matches: 'Ingen treff. Du kan fortsatt legge til manuelt under.',
  family_tree_unified_search_placeholder: 'Søk i sanser, talenter og endringer...',
  family_tree_suggested_senses: 'Foreslåtte sanser',
  family_tree_suggested_talents: 'Foreslåtte talenter',
  family_tree_suggested_cycles: 'Foreslåtte endringer',
  family_tree_origin_personal: 'Personlig',
  family_tree_origin_possible_family_pattern: 'Mulig familiemønster',
  family_tree_origin_family_pattern: 'Familiemønster',
  family_tree_origin_personal_change: 'Personlig endring',
  family_tree_origin_possible_family_change: 'Mulig familieendring',
  family_tree_origin_family_change: 'Familieendring',
  family_tree_added_by_you: 'Lagt til av deg',
  family_tree_chip_added_in_family: 'Lagt til i familien',
  family_tree_agree: 'Kjenner igjen',
  family_tree_agreed: 'Kjenner igjen',
  family_tree_shared_in_lineage: 'Delt i slektslinjen',
  family_tree_kind_sense: 'Sans',
  family_tree_kind_talent: 'Talent',
  family_tree_kind_cycle: 'Endring',
  family_tree_lineage_type_cycle: 'Endring',
  family_tree_lineage_type_talent: 'Talent',
  family_tree_parents_title: 'Foreldre',
  family_tree_no_parents: 'Ingen foreldre registrert',
  family_tree_add_mother: 'Legg til mor',
  family_tree_add_father: 'Legg til far',
  family_tree_detached_title: 'Kjente personer uten kobling ennå',
  family_tree_detached_description:
    'Disse personene er registrert, men har ennå ikke en familiekobling i dette treet.',
  family_tree_close_panel: 'Lukk detaljpanelet',
  family_tree_remove_talent: 'Fjern talent',
  family_tree_remove_change: 'Fjern endring',
  family_tree_add_note: 'Legg til tekst',
  family_tree_edit_note: 'Rediger tekst',
  still_alive: 'fortsatt i live',
  user_has_already_been_taken: 'Brukeren er allerede tatt',
  relation_already_exists: 'Relasjonen finnes allerede',
  coin_store_categories: 'Kategorier',
  coin_store_price: 'Pris',
  coin_store_category_all: 'Alle',
  coin_store_category_flowers: 'Blomster',
  coin_store_category_plants: 'Planter',
  coin_store_category_candles: 'Lys',
  coin_store_category_cure: 'Cure',
  coin_store_occasions: 'Anledninger',
  coin_store_add_to_cart: 'Velg denne',
  coin_store_preview: 'Se forhåndsvisning',
  coin_store_preview_frame: 'Se sirkelen',
  coin_store_preview_candle: 'Se lyset',
  coin_store_already_subscribed: 'Allerede abonnert',
  coin_store_no_products: 'Ingen produkter tilgjengelige',
  coin_store_no_frames: 'Ingen rammer tilgjengelige',
  coin_store_no_flowers: 'Ingen blomster tilgjengelige',
  coin_store_no_candles: 'Ingen lys tilgjengelige',
  coin_store_no_plants: 'Ingen planter tilgjengelige',
  coin_store_no_cure_products: 'Ingen Cure-produkter tilgjengelige',
  coin_store_search_placeholder: 'Søk',
  coin_store_sort_placeholder: 'Sorter',
  coin_store_sort_name: 'Navn',
  coin_store_sort_price_low: 'Pris: Lav til høy',
  coin_store_sort_price_high: 'Pris: Høy til lav',
  coin_store_tab_all: 'ALLE',
  coin_store_tab_physical: 'FYSISK',
  coin_store_tab_digital: 'DIGITAL',
  coin_store_tab_gift: 'GI EN TJENESTE',
  coin_store_category_frames: 'Sirkler',
  coin_store_hero_heading: 'End Of Time Collection',
  coin_store_hero_subheading: 'Hver flamme og sirkel bringer nærværet tilbake.',
  coin_store_hero_image_alt: 'store illustration',
  coin_store_hero_pill_label: 'Everlight – følger døgnrytmen ved graven',
  coin_store_hero_note1: 'rolig animasjon, skånsom for øynene',
  coin_store_hero_note2: 'designet for nærvær – ikke støy',
  coin_store_filters: 'Filter',
  nav_section: 'Navigasjon',
  account_section: 'Konto',
  aria_menu: 'meny',
  aria_profile_menu: 'profilmeny',
  aria_notifications: 'varsler',
  aria_home: 'hjem',
  aria_my_light: 'mitt lys',
  aria_open_search: 'åpne søk',
  aria_close_search: 'lukk søk',
  verified: 'Bekreftet',
  claimed_by_you: 'Registrert av deg',
  claimed_explainer: 'Denne graven er bekreftet og knyttet til din konto.',
  composer_visibility: 'Synlighet',
  composer_public: 'Offentlig',
  composer_relatives: 'Slektsringer',
  composer_private: 'Privat',
  composer_public_desc: 'alle',
  composer_relatives_desc: 'Synlig for slekt/følgere',
  composer_private_desc: 'Kun for deg',
  composer_more: 'Flere valg …',
  composer_fewer: 'Færre valg',
  composer_caption_ph: 'Bildetekst (valgfritt)',
  composer_add_link_prompt: 'Lim inn en lenke (URL)',
  composer_add_link: 'Legg til lenke',
  composer_add_emoji: 'Legg til emoji',
  composer_search_emoji: 'Søk etter emojier',
  reply: 'Svar',
  store_products: 'Sirkler og lys',
  store_products_subheading: 'Velg nå. Bruk det fra Mine valg etter kjøpet.',
  store_intro_eyebrow: 'Nærvær på Nettgraven',
  store_intro_title: 'For noen du tenker på',
  store_intro_body: 'Her finner du lys og sirkler som kan gi tanken din et personlig uttrykk.',
  store_intro_candles: 'Tenn et lys',
  store_intro_frames: 'Velg en sirkel',
  store_intro_inventory: 'Se Mine valg',
  store_frames_description:
    'En digital sirkel rundt profilbildet på graven. Etter kjøpet velger du hvilken grav den skal brukes på fra Mine valg.',
  store_candles_description:
    'Et digitalt lys du kan tenne på en grav nå eller på en merkedag. Ett kjøp gir ett lys i Mine valg.',
  store_view_all: 'Se alle {category}',
  store_choose_frame: 'Velg denne sirkelen',
  store_choose_candle: 'Velg dette lyset',
  store_preview_no_grave: 'Du kan fullføre valget nå og velge grav fra Mine valg etter kjøpet.',
  store_preview_example_grave: 'Eksempel på en grav',
  store_cart_open: 'Åpne ditt valg',
  store_cart_close: 'Lukk ditt valg',
  store_cart_decrease: 'Reduser antall',
  store_cart_increase: 'Øk antall',
  store_cart_remove: 'Fjern fra valget',
  store_cart_empty: 'Du har ikke valgt noe ennå.',
  store_continue_checkout: 'Gå videre',
  store_favorites_section: 'Lagret til senere',
  store_favorite_add: 'Lagre til senere',
  store_favorite_remove: 'Fjern fra lagrede',
  coin_store_select_frame_title: 'Velg en sirkel',
  coin_store_select_frame_subtitle: 'Velg en sirkel du vil legge til i samlingen din.',
  coin_store_select_frame_confirm: 'Velg denne?',
  frame_upload_title: 'Add New Frame',
  frame_upload_name_label: 'Name',
  frame_upload_name_placeholder: 'Frame name',
  frame_upload_name_required: 'Enter frame name',
  frame_upload_kind_label: 'Kind',
  frame_upload_kind_svg: 'SVG',
  frame_upload_kind_lottie: 'Lottie',
  frame_upload_kind_gif: 'GIF',
  frame_upload_kind_apng: 'APNG',
  frame_upload_kind_webp: 'WebP',
  frame_upload_kind_mp4: 'MP4',
  frame_upload_kind_webm: 'WebM',
  frame_upload_kind_mov: 'MOV',
  frame_upload_kind_tgs: 'TGS',
  frame_upload_viewbox_label: 'ViewBox',
  frame_upload_viewbox_placeholder: 'e.g., 0 0 100 100',
  frame_upload_viewbox_extra: "Format: 'minX minY width height'",
  frame_upload_inner_circle_label: 'Inner Circle',
  frame_upload_inner_circle_extra: 'Circle center (cx, cy) and radius (r) in viewBox units',
  frame_upload_inner_circle_cx_placeholder: 'cx',
  frame_upload_inner_circle_cy_placeholder: 'cy',
  frame_upload_inner_circle_r_placeholder: 'r',
  frame_upload_asset_file_label: 'Asset File',
  frame_upload_asset_file_button: 'Select file',
  frame_upload_asset_file_required: 'Please select at least one file.',
  frame_upload_price_label: 'Price',
  frame_upload_price_placeholder: 'Enter price',
  frame_upload_price_required: 'Enter price',
  frame_upload_description_label: 'Description',
  frame_upload_description_placeholder: 'Describe this frame',
  frame_upload_color_label: 'Farge',
  frame_upload_color_red: 'Rød',
  frame_upload_color_blue: 'Blå',
  frame_upload_color_green: 'Grønn',
  frame_upload_theme_label: 'Tema',
  frame_upload_theme_light: 'Lys',
  frame_upload_theme_dark: 'Mørk',
  frame_upload_submit: 'Upload',
  frame_upload_delete_title: 'Delete Frame',
  frame_upload_delete_content: 'Dette er permanent.',
  frame_upload_delete_ok: 'Delete',
  frame_apply: 'Bruk',
  frame_buy_more: 'Velg sirkel',
  frame_available_quantity: 'Tilgjengelig: x{count}',
  frame_applied_at: 'Aktiv på:',
  frame_no_graves_yet: 'Dine knyttede graver kommer her',
  frame_no_graves_active: 'Ingen aktive graver ennå.',
  no_frames_available: 'Du har ingen sirkler ennå. Se sirklene du kan velge mellom.',
  frame_modal_title: 'Velg sirkel eller legg til bilde',
  frames_store_title: 'Sirkler',
  send_gift: 'Tenn et lys',
  gift_message_label: 'Ord til graven',
  gift_event_context_time: 'på {event} · {time}',
  gift_message_placeholder: 'Skriv noen ord, om du vil',
  no_gifts_available: 'Ingen gaver tilgjengelige.',
  no_gifts_yet: 'Tenn et lys for {graveName}',
  candles: 'Lys',
  choose_candle: 'Velg lys',
  add_candle: 'Legg til lys',
  buy_gifts: 'Kjøp gaver',
  gifts_title: 'Gaver',
  gifts_empty_state: 'No gifts have been added yet.',
  previous_gift: 'Forrige gave',
  next_gift: 'Neste gave',
  gift_update_success: 'Gift updated',
  gift_delete_success: 'Gift deleted',
  gifts_load_error: 'Unable to load gifts right now.',
  gift_update_error: 'Unable to update gift.',
  gift_delete_error: 'Unable to delete gift.',
  gift_edit_title: 'Rediger gave',
  gift_sent: 'Gave sendt',
  gift_send_error: 'Kunne ikke sende gave',
  gift_event_by_user: '{event} av {user}',
  edit_text_description: 'Legg til, endre eller fjern tekst',
  my_light_tooltip: 'Gnisten din gjør verden til et bedre sted.',
  products_title: 'Sirkler og lys',
  products_add_product: 'Legg til produkt',
  products_edit_product: 'Rediger produkt',
  products_table_index: 'Nr.',
  products_table_name: 'Navn',
  products_table_image_or_frame: 'Bilde eller ramme',
  products_table_price: 'Pris',
  products_table_description: 'Beskrivelse',
  products_table_action: 'Handling',
  products_action_edit: 'Rediger',
  products_action_delete: 'Slett',
  products_form_type_label: 'Type',
  products_form_type_frame: 'Ramme',
  products_form_type_cure: 'Gravstell',
  products_form_type_flower: 'Blomst',
  products_form_type_plant: 'Plante',
  products_form_type_candle: 'Lys',
  products_form_cure_name_label: 'Navn',
  products_form_cure_name_placeholder: 'Produktnavn',
  products_form_cure_name_required: 'Angi produktnavn',
  products_form_cure_lengths_label: 'Varighet',
  products_form_cure_lengths_placeholder: 'Oppgi abonnementslengder',
  products_form_cure_lengths_required: 'Oppgi varigheter',
  products_form_cure_price_label: 'Pris',
  products_form_cure_price_placeholder: 'Angi pris',
  products_form_cure_price_required: 'Oppgi pris',
  products_form_cure_description_label: 'Beskrivelse',
  products_form_cure_description_placeholder: 'Beskriv produktet',
  products_form_cure_image_label: 'Bilde',
  products_form_cure_image_required: 'Velg et bilde.',
  products_form_upload_button: 'Last opp',
  products_form_translations_label: 'Oversettelser',
  products_form_add_translation: 'Legg til oversettelse',
  products_form_translations_help:
    'Legg inn valgfri språkspesifikk tekst for å overstyre den engelske standarden.',
  products_form_translation_locale_label: 'Språk',
  products_form_translation_locale_required: 'Velg et språk',
  products_form_translation_locale_placeholder: 'Velg språk',
  products_form_translation_name_label: 'Navn',
  products_form_translation_name_required: 'Skriv inn et navn',
  products_form_translation_name_placeholder: 'Oversatt produktnavn',
  products_form_translation_description_label: 'Beskrivelse',
  products_form_translation_description_placeholder: 'Oversatt beskrivelse (valgfritt)',
  products_form_translation_remove: 'Fjern oversettelse',
  products_delete_error_in_use: 'Kan ikke slette dette produktet fordi det fortsatt er i bruk.',
  checkout_purchase_success: 'Kjøpet ble fullført',
  checkout_payment_failed: 'Betalingen mislyktes',
  checkout_missing_payment_method_id: 'Mangler betalingsmetode-ID',
  lighthouse_title: 'End Of Time Collection',
  lighthouse_subtitle: 'Hver flamme og sirkel bringer nærværet tilbake.',
  lighthouse_description:
    'Et urokkelig lys i horisonten, som leder kjærligheten gjennom mørke farvann. Rolige hav, stille styrke og en stråle som sier: Du er aldri alene. En mild hyllest til kystens hjerter og til alle som bar andre trygt hjem.',
  lighthouse_go_to_store: 'Gå til samlingen',
  frame_info_title: 'Slik setter du en ramme',
  frame_info_description:
    '1. Gå til graven du ønsker å endre.\n2. Klikk på profilbildet til graven.\n3. Velg en ramme – den blir synlig på graven med en gang.',
  profile_and_settings: 'Profil & innstillinger',
  help_and_support: 'Hjelp & støtte',
  report_problem: 'Rapporter et problem',
  light_theme: 'Lyst tema',
  dark_theme: 'Mørkt tema',
  toggle_theme: 'Bytt tema',
  toggle_theme_to_dark: 'Bytt til mørk modus',
  toggle_theme_to_light: 'Bytt til lys modus',
  partner_title: 'Partner',
  partner_become_seller: 'Bli partner (selgerkonto)',
  partner_status_pending: 'Partnerstatus: venter godkjenning',
  partner_apply: 'Søk om å bli partner',
  partner_open_portal: 'Åpne partnerportalen',
  partner_dashboard: 'Partner-dashbord',
  partner_create_ad: 'Opprett annonse/produkt',
  partner_payouts: 'Utbetalinger',
  'designSystem.showcase.title': 'Design System',
  'designSystem.colors.title': 'Portalfargeskjema',
  'designSystem.colors.silver': 'Sølv',
  'designSystem.colors.gold': 'Gull',
  'designSystem.colors.roseGold': 'Rosegull',
  'designSystem.colors.bronze': 'Bronse',
  'designSystem.colors.titanium': 'Titan',
  'designSystem.colors.emerald': 'Smaragd',
  'designSystem.colors.platinum': 'Platina',
  'designSystem.colors.copper': 'Kobber',
  'designSystem.colors.amethyst': 'Ametyst',
  'designSystem.colors.sapphire': 'Safir',
  'designSystem.colors.ruby': 'Rubin',
  'designSystem.colors.obsidian': 'Obsidian',
  'designSystem.colors.aqua': 'Akvamarin',
  'designSystem.colors.sunset': 'Solnedgang',
  'designSystem.colors.surfaces': 'Overflatefarger',
  'designSystem.colors.text': 'Tekstfarger',
  'designSystem.colors.metallic': 'Metalliske paletter',
  'designSystem.colors.viewMetallicIcons': 'Vis metallikon-demo',
  'designSystem.anniversaries.upcoming': 'Merkedager som kommer',
  'designSystem.anniversaries.breakdown.title': 'Neste 7 dager',
  'designSystem.anniversaries.grave': 'Grav',
  'designSystem.anniversaries.user': 'Bruker',
  'designSystem.anniversaries.public': 'Offentlig',
  'designSystem.anniversaries.total': 'Totalt',
  'designSystem.grid.sectionTitle': 'Grid-oppsett',
  'designSystem.grid.controls.title': 'Interaktive kontroller',
  'designSystem.grid.controls.align': 'Vertikal justering',
  'designSystem.grid.controls.justify': 'Horisontal justering',
  'designSystem.grid.controls.horizontalGutter': 'Horisontal avstand (px)',
  'designSystem.grid.controls.verticalGutter': 'Vertikal avstand (px)',
  'designSystem.grid.controls.wrap': 'Bryt linjer',
  'designSystem.grid.controls.currentProps': 'Aktive egenskaper',
  'designSystem.grid.preview.title': 'Forhåndsvisning',
  'designSystem.grid.align.top': 'Topp',
  'designSystem.grid.align.middle': 'Midten',
  'designSystem.grid.align.bottom': 'Bunn',
  'designSystem.grid.align.stretch': 'Strekk',
  'designSystem.grid.justify.start': 'Start',
  'designSystem.grid.justify.center': 'Senter',
  'designSystem.grid.justify.end': 'Slutt',
  'designSystem.grid.justify.spaceBetween': 'Fordel mellom',
  'designSystem.grid.justify.spaceAround': 'Fordel rundt',
  'designSystem.grid.justify.spaceEvenly': 'Fordel jevnt',
  'designSystem.grid.box.label': 'Kolonne {index}',
  'designSystem.grid.box.span': 'span {value}',
  'designSystem.grid.box.offset': 'Forskyvning {value}',
  'designSystem.grid.box.order': 'Rekkefølge {value}',
  'designSystem.grid.box.flex': 'flex {value}',
  'designSystem.grid.box.grow': 'Fyller resterende plass',
  'designSystem.grid.responsive.title': 'Responsivt eksempel',
  'designSystem.grid.responsive.description':
    'Endre vindusstørrelsen for å se avstander og justering endre seg mellom brytepunkter.',
  'designSystem.grid.box.responsive': 'xs 24 → md 12',
  'designSystem.grid.box.responsiveDetail': 'Stabler på mobil, deles på desktop',
  'designSystem.grid.box.responsiveAlign': 'Deler avstand automatisk via kontekst',
  'designSystem.grid.docs.title': 'Grid-oppsett – Row & Col',
  'designSystem.grid.docs.notes':
    'Row beregner responsiv avstand og justering, og Col speiler verdiene via kontekst for jevne oppsett.',
  'designSystem.mediaUpload.triggerLabel': 'Select files',
  'designSystem.mediaUpload.type.media': 'media',
  'designSystem.mediaUpload.type.image': 'images',
  'designSystem.mediaUpload.type.video': 'videos',
  'designSystem.mediaUpload.type.audio': 'audio',
  'designSystem.mediaUpload.type.file': 'files',
  'designSystem.mediaUpload.dropHint': 'Drag & drop to upload or browse files',
  'designSystem.mediaUpload.dropActive': 'Release to upload',
  'designSystem.mediaUpload.emptyState': 'No files selected yet',
  'designSystem.mediaUpload.previewVideoLabel': 'Preview of {name}',
  'designSystem.mediaUpload.previewImageAlt': 'Preview of {name}',
  'designSystem.mediaUpload.removeFile': 'Remove {name}',
  'designSystem.mediaUpload.editFile': 'Edit {name}',
  'designSystem.mediaUpload.zoom': 'Zoom',
  'designSystem.mediaUpload.unnamed': 'Untitled file',
  'designSystem.mediaUpload.showcase.defaultLabel': 'Media library',
  'designSystem.mediaUpload.showcase.defaultDescription':
    'Upload new photos, videos or audio to share with your team.',
  'designSystem.mediaUpload.showcase.controlTitle': 'Configuration',
  'designSystem.mediaUpload.showcase.mediaTypeLabel': 'Media type',
  'designSystem.mediaUpload.showcase.multipleLabel': 'Allow multiple files',
  'designSystem.mediaUpload.showcase.maxFilesLabel': 'Max files',
  'designSystem.mediaUpload.showcase.duplicatesLabel': 'Allow duplicate files',
  'designSystem.mediaUpload.showcase.dragLabel': 'Enable drag & drop',
  'designSystem.mediaUpload.showcase.selectedCount':
    '{count, plural, =0 {No files yet} one {# file selected} other {# files selected}}',
  'designSystem.mediaUpload.showcase.helper': 'Maximum {limit} MB per file',
  'designSystem.mediaUpload.showcase.tooLarge': '{name} exceeds the {limit} MB limit',
  'designSystem.mediaUpload.showcase.untitledFile': 'Selected file',
  'designSystem.mediaUpload.showcase.trigger': 'Upload {label}',
  'designSystem.mediaUpload.showcase.dropHint': 'Drag & drop {label} or browse files',
  'designSystem.mediaUpload.showcase.examplesTitle': 'Examples',
  'designSystem.mediaUpload.showcase.imageTitle': 'Gallery images',
  'designSystem.mediaUpload.showcase.imageDescription':
    'Upload retina-ready hero images for landing pages.',
  'designSystem.mediaUpload.showcase.imageHelper': 'PNG or JPG up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.videoTitle': 'Promo video',
  'designSystem.mediaUpload.showcase.videoDescription':
    'Collect a single teaser video for campaigns.',
  'designSystem.mediaUpload.showcase.videoHelper':
    'MP4 up to {limit} MB. We’ll transcode automatically.',
  'designSystem.mediaUpload.showcase.audioTitle': 'Audio tribute',
  'designSystem.mediaUpload.showcase.audioDescription': 'Gather spoken memories or music clips.',
  'designSystem.mediaUpload.showcase.audioHelper': 'MP3 or WAV up to {limit} MB.',
  'designSystem.mediaUpload.showcase.fileTitle': 'Document upload',
  'designSystem.mediaUpload.showcase.fileDescription': 'Store memorial programs or consent forms.',
  'designSystem.mediaUpload.showcase.fileHelper': 'PDF or DOCX up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.buttonTitle': 'Quick upload button',
  'designSystem.mediaUpload.showcase.buttonDescription':
    'Single tap button with icon for quick uploads.',
  'designSystem.mediaUpload.showcase.buttonHelper': 'Tap the button to pick one or more files.',
  'designSystem.mediaUpload.showcase.buttonTrigger': 'Choose files',
  'designSystem.mediaUpload.showcase.imageButtonCaption':
    'Tap the media button or drop hero images here.',
  'designSystem.mediaUpload.showcase.imageButtonAria': 'Add gallery image',
  'designSystem.mediaUpload.showcase.videoButtonCaption':
    'Drop or select a promo trailer to share.',
  'designSystem.mediaUpload.showcase.videoButtonAria': 'Add campaign video',
  'library.mediaUpload.trigger': '{count, plural, =0 {Upload media} other {Add more media}}',
  'library.mediaUpload.helper': 'Drag files here or browse from your device.',
  'search.publicNotice.title': 'Offentlige opplysninger',
  'search.publicNotice.body': 'Logg inn for å se bilder, minner og mer.',
  // Header/Notifications additions
  design_system: 'Design system',
  settings: 'Innstillinger',
  logout: 'Logg ut',
  account_menu: 'Kontomeny',
  guest_menu: 'Meny',
  'guest_menu.subtitle': 'Utforsk mer av Nettgrav eller logg inn for å fortsette.',
  more_information: 'Mer informasjon',
  accepted: 'Godkjent',
  rejected: 'Avvist',
  // Groups & Group Details
  'groups.title': 'Rom',
  'groups.loading': 'Laster rom…',
  'groups.error': 'Kunne ikke laste rom',
  'groups.empty': 'Ingen rom ennå.',
  'groups.createGroup': 'Opprett rom',
  'groups.form.name': 'Navn',
  'groups.form.description': 'Beskrivelse',
  'groups.form.category': 'Kategori',
  'groups.form.paid': 'Betalt rom',
  'groups.mode.explore': 'Utforsk',
  'groups.mode.mine': 'Mine rom',
  'groups.search': 'Søk i rom',
  'groups.category': 'Kategori',
  'groups.category.all': 'Alle kategorier',
  'groups.create.title': 'Opprett et rom',
  'groups.form.desc': 'Beskrivelse (valgfritt)',
  'groups.form.create': 'Opprett rom',
  'groups.view': 'Vis',
  'groups.join': 'Bli med i rommet',
  'groups.empty.hint': 'Prøv å endre filter eller opprett et nytt rom.',
  loading: 'Laster…',
  'error.generic': 'Noe gikk galt.',
  'pagination.prev': 'Forrige',
  'pagination.next': 'Neste',
  notifications_load_more: 'Last mer',
  'groups.subtitle': 'Hva vil du snakke om i dag?',
  'groups.categories.label': 'Kategorier',
  'groups.mine.filters.sub': 'Filtrer rom etter din rolle.',
  'groups.mine.filter.all': 'Alle',
  'groups.mine.filter.led': 'Ledet av deg',
  'groups.mine.filter.member': 'Medlem',
  'groups.mine.filter.pending': 'Venter',
  'groups.mine.section.led': 'Rom du holder',
  'groups.mine.section.led.sub': 'Rom der du er eier eller admin.',
  'groups.mine.section.member': 'Rom du er med i',
  'groups.mine.section.member.sub': 'Rom der du er aktivt medlem.',
  'groups.mine.section.pending': 'Ventende forespørsler',
  'groups.mine.section.pending.sub': 'Rom der forespørsel eller invitasjon fortsatt venter.',
  'groups.mine.empty.title': 'Ingen rom i denne delen ennå',
  'groups.mine.empty.hint': 'Bytt filter eller utforsk rom å bli med i.',
  'groups.mine.empty.cta': 'Utforsk rom',
  'groups.mine.empty.all.title': 'Du er ikke med i noen rom ennå',
  'groups.mine.empty.all.hint': 'Utforsk rom eller opprett en for å komme i gang.',
  'groups.mine.overview.title': 'Mine rom',
  'groups.mine.overview.sub': 'Rom du holder, deltar i eller venter på å bli med i.',
  'groups.mine.load_error.title': 'Kunne ikke laste rommene dine',
  'groups.mine.load_error.text': 'Prøv igjen om et øyeblikk.',
  'groups.mine.retry': 'Prøv igjen',
  'groups.mine.search_empty.title': 'Ingen rom passer med søket',
  'groups.mine.search_empty.text': 'Prøv et annet romnavn eller nullstill søket.',
  'groups.mine.search_empty.clear': 'Nullstill søk',
  'groups.mine.feed.error.title': 'Kunne ikke laste siste aktivitet',
  'groups.mine.feed.error.text': 'Rommene dine er fortsatt tilgjengelige ovenfor.',
  'groups.sidebar.mine.title': 'Dine siste rom',
  'groups.sidebar.mine.sub': 'Rask tilgang til rom du allerede følger.',
  'groups.category_name.local': 'Lokal',
  'groups.category_name.science_and_tech': 'Vitenskap og teknologi',
  'groups.category_name.education': 'Utdanning',
  'groups.category_name.health': 'Helse',
  'groups.category_name.lifestyle': 'Livsstil',
  'groups.category_name.travel': 'Reise',
  'groups.category_name.sports': 'Sport',
  'groups.category_name.technology': 'Teknologi',
  'groups.category_name.family': 'Familie',
  'groups.category_name.grief_and_loss': 'Sorg og tap',
  'groups.category_name.spirituality': 'Religion og tro',
  'groups.category_name.relationships': 'Relasjoner',
  'groups.category_name.life_choices': 'Livsvalg',
  'groups.category_name.existence': 'Eksistens',
  'groups.category_name.guidance': 'Veiledning',
  'groups.create.cta': 'Opprett rom',
  'groups.empty.title': 'Ingen rom funnet',
  'groups.empty.hint': 'Det finnes ingen rom som passer søket ditt akkurat nå.',
  'groups.empty.initial.title': 'Ingen åpne rom ennå',
  'groups.empty.initial.hint':
    'Opprett det første rommet og inviter mennesker til en samtale som betyr noe.',
  'groups.empty.clear': 'Nullstill søk og filtre',
  'groups.card.view': 'Vis',
  'groups.card.enter': 'Gå inn',
  'groups.card.owner': 'Den som holder rommet',
  'groups.card.owner.you': 'Du',
  'create_group.title': 'Opprett rom',
  'create_group.open_title': 'Åpne et rom',
  'create_group.open_subtitle': 'Et rom samler mennesker rundt det som betyr noe.',
  'create_group.name_prompt': 'Hva skal rommet hete?',
  'create_group.name': 'Hva heter rommet?',
  'create_group.name.placeholder': 'Navn på rommet',
  'create_group.desc_prompt': 'Hva rommer dette rommet?',
  'create_group.desc': 'Hva ønsker du at rommet skal romme?',
  'create_group.desc.placeholder': 'Hva kan deles her?',
  'create_group.category': 'Retning',
  'create_group.category.optional_label': 'Retning (valgfritt)',
  'create_group.category.placeholder': 'Velg retning',
  'create_group.category.required': 'Velg retning.',
  'create_group.paid': 'Betalt rom (valgfritt)',
  'create_group.free': 'Gratis',
  'create_group.submit': 'Opprett rom',
  'create_group.open_submit': 'Åpne rommet',
  'create_group.cancel': 'Avbryt',
  'create_group.cover.label': 'Rombilde (valgfritt)',
  'create_group.cover.preview_alt': 'Forhåndsvisning av rombilde',
  'create_group.cover.empty': 'Ingen rombilde valgt ennå.',
  'create_group.cover.choose': 'Velg rombilde',
  'create_group.cover.adjust_crop': 'Juster beskjæring',
  'create_group.cover.remove': 'Fjern',
  'create_group.cover.hint':
    'Bildet legges til når rommet opprettes, og kan endres senere i Innstillinger.',
  'create_group.cover.upload_error':
    'Kunne ikke laste opp rombilde. Du kan legge det til i Innstillinger.',
  'create_group.cover.image_only': 'Velg en bildefil.',
  'groups.settings.cover.crop': 'Tilpass rombildet',
  'groups.settings.cover.safe_area': 'Hold viktige detaljer innenfor den stiplede rammen.',
  crop_zoom: 'Zoom',
  'gravesHub.title': 'Dine nære',
  'gravesHub.hero.eyebrow': 'Holde nær',
  'gravesHub.hero.title': 'Personene jeg tar vare på',
  'gravesHub.hero.subtitle':
    'Alt om dem du følger opp finnes her—oppdateringer, datoer og hvem som er med.',
  'gravesHub.hero.graveCount':
    'Du følger {count, plural, one {# person} other {# personer}} i Nettgrav.',
  'gravesHub.hero.cta': 'Legg til en ny',
  'gravesHub.hero.secondary': 'Se invitasjoner',
  'gravesHub.myGraves': 'Mine graver',
  'gravesHub.myGraves.count': '{count}',
  'gravesHub.create': 'Legg til en person',
  'gravesHub.myGraves.empty':
    'Ingen her ennå. Legg til noen eller godta en invitasjon for å komme i gang.',
  'gravesHub.myGraves.emptyAction': 'Legg til en ny',
  'gravesHub.myGraves.viewInvites': 'Godta invitasjon',
  'gravesHub.guest':
    'Her finner du gravene du hører til. Et sted for nærhet, tilstedeværelse og omsorg over tid. Logg inn for å komme i gang.',
  'gravesHub.guest_preview.name_1': 'Lorense Hansen',
  'gravesHub.guest_preview.role_1': 'Bestemor',
  'gravesHub.guest_preview.name_2': 'Oskar Johansen',
  'gravesHub.guest_preview.role_2': 'Far',
  'gravesHub.guest_preview.name_3': 'Anna Solberg',
  'gravesHub.guest_preview.role_3': 'Familievenn',
  'gravesHub.guest_preview.place': 'Vestre gravlund, Oslo',
  'gravesHub.guest_preview.selected_copy':
    'Her kan du åpne gravsiden og invitere andre som også hører til rundt graven.',
  'gravesHub.guest_preview.visit': 'Åpne gravsiden',
  'gravesHub.guest_preview.invite': 'Inviter familie',
  'gravesHub.guest_preview.update_author_1': 'Maren delte et innlegg',
  'gravesHub.guest_preview.update_time_1': 'For 2 timer siden',
  'gravesHub.guest_preview.update_body_1':
    'Maren er takknemlig for Lorense Hansen. Et tegn på nærvær, uten at det trenger å være mange ord.',
  'gravesHub.guest_preview.update_author_2': 'Isak delte et innlegg',
  'gravesHub.guest_preview.update_time_2': 'I går',
  'gravesHub.guest_preview.update_body_2':
    'Isak savner Lorense Hansen. Innlegg, bilder og lenker fra de nærmeste vises her.',
  'gravesHub.loading.graves': 'Samler personene du følger opp...',
  'gravesHub.loading.error': 'Vi kunne ikke hente personene dine nå. Oppdater for å prøve igjen.',
  'gravesHub.loading.completed': 'Synkronisert på {seconds}s',
  'gravesHub.feed.title': 'Gravveggen',
  'gravesHub.feed.noSelection': 'Velg en person for å være til stede.',
  'gravesHub.feed.empty': 'Her er det foreløpig stille.',
  'gravesHub.invite': 'Inviter familie til å ta vare på graven',
  'gravesHub.selected.copy': 'Besøk graven når det passer for deg.',
  'gravesHub.memory.photoOnly': 'La til et bilde på graven',
  'gravesHub.memory.view': 'Les minne',
  'gravesHub.memory.empty': 'Ingen minner ennå. Del en historie som hjelper familien å huske.',
  'gravesHub.memory.loadMore': 'Vis flere oppdateringer',
  'gravesHub.visitNamed': 'Besøk {name}s grav',
  'gravesHub.visitFallback': 'Besøk graven',
  'gravesHub.invitations.shortcut':
    '{count, plural, one {# invitasjon venter} other {# invitasjoner venter}}',
  'gravesHub.invitations.title': 'Invitasjoner til felles omsorg',
  'gravesHub.invitations.manage': 'Administrer',
  'gravesHub.invitations.invitedBy': 'Vil hjelpe deg med å ta vare på graven',
  'gravesHub.invitations.accept': 'Godta',
  'gravesHub.invitations.decline': 'Avslå',
  'gravesHub.invitations.acceptSuccess': 'Invitasjonen er akseptert',
  'gravesHub.invitations.declineSuccess': 'Invitasjonen er avslått',
  'gravesHub.invitations.actionError': 'Noe gikk galt. Prøv igjen.',
  'gravesHub.gettingStarted.title': 'I dag',
  'gravesHub.gettingStarted.reminders': 'E‑postpåminnelser',
  'gravesHub.gettingStarted.remindersHint':
    'Få et vennlig varsel før viktige dager eller nye oppdateringer.',
  'gravesHub.starter.anniversaries.title': 'Merkedager',
  'gravesHub.starter.anniversaries.body': 'Legg til datoer som hjelper familien å huske sammen.',
  'gravesHub.starter.anniversaries.action': 'Legg til dato',
  'gravesHub.starter.memory.title': 'Bilder',
  'gravesHub.starter.memory.body': 'Legg til bilder familien kan ønske å bevare sammen.',
  'gravesHub.starter.memory.action': 'Legg til bilder',
  'gravesHub.shortcuts.title': 'Snarveier',
  'gravesHub.shortcuts.invite': 'Inviter familie til å hjelpe',
  'gravesHub.shortcuts.invite.copy':
    'Del tilgang så familien kan legge til minner, bilder og sammenheng.',
  'gravesHub.shortcuts.email': 'E‑postinnstillinger',
  'gravesHub.shortcuts.email.copy': 'Finjuster påminnelser og varsler.',
  'gravesHub.shortcuts.open': 'Åpne graven',
  'gravesHub.shortcuts.open.copy':
    'Besøk hele gravsiden for historier, bilder og det dere tar vare på sammen.',
  'gravesHub.tips.title': 'Holde kontakten',
  'home.actions.title': 'Nettgrav: Et varig hjem for livene våre.',
  'home.actions.subtitle': 'Et nettverk bygget for sannhet, samhold, drevet av varig mening.',
  'home.actions.create.title': 'Opprett en Nettgrav',
  'home.actions.create.body':
    'Samle familien og skap deres permanente Nettgrav – helt kostnadsfritt. Del ord, bilder og lys, og ivareta historien sammen uansett hvor dere er i verden.',
  'home.actions.create.cta': 'Start Nettgrav',
  'home.actions.find.title': 'Finn en grav',
  'home.actions.find.body':
    'Finn den du savner. Se bekreftede minner og bli varslet om viktige dager.',
  'home.actions.find.cta': 'Søk etter graver',
  'home.actions.invite.title': 'Inviter bidragsytere',
  'home.actions.invite.body':
    'Inviter bidragsytere. Del tilgang med dine nærmeste for å bygge livshistorien sammen og holde minnet levende.',
  'home.actions.invite.cta': 'Send invitasjoner',
  'home.actions.spark.title': 'Tenn din Gnist',
  'home.actions.spark.body':
    'Del det som er viktig for deg nå. Din Gnist er rommet for dine refleksjoner og indre sannheter. Del ditt lys med verden og skap en gnist av ettertanke hos andre.',
  'home.actions.spark.cta': 'Skap Gnist',
  'gravesHub.tips.applyFrame.title': 'Gjør siden personlig',
  'gravesHub.tips.applyFrame.body': 'Velg en ramme som passer.',
  'gravesHub.tips.applyFrame.cta': 'Bruk en ramme',
  'gravesHub.tips.invite.title': 'Ta med nære du stoler på',
  'gravesHub.tips.invite.body': 'Del ansvar og tilgang, slik at omsorgen bæres sammen.',
  'gravesHub.tips.invite.cta': 'Send invitasjon',
  'gravesHub.tips.reminders.title': 'Påminnelse på e‑post',
  'gravesHub.tips.reminders.body': 'Få en påminnelse på e‑post før viktige hendelser.',
  'gravesHub.tips.info.title': 'Bygg en jevn omsorgsrytme',
  'gravesHub.tips.info.body': 'Bruk påminnelser og del tilgang for å holde omsorgen levende.',
  'gravesHub.store.title': 'Små handlinger med stor betydning',
  'gravesHub.store.description': 'Små handlinger kan skape nærvær.',
  'gravesHub.store.candle.title': 'Velg et lys',
  'gravesHub.store.candle.body': 'En stille handling av kjærlighet.',
  'gravesHub.store.candle.cta': 'Utforsk lys',
  'gravesHub.store.frame.title': 'Velg en sirkel',
  'gravesHub.store.frame.body': 'Finn den som speiler forbindelsen.',
  'gravesHub.store.frame.cta': 'Utforsk sirkler',
  'gravesHub.store.tree.title': 'Plant et tre',
  'gravesHub.store.tree.body': 'Plant en levende hyllest i deres navn gjennom våre partnere.',
  'gravesHub.store.tree.cta': 'Plant et tre',
  'gravesHub.notifications.updated': 'Påminnelsesvalg oppdatert',
  'gravesHub.notifications.error': 'Vi kunne ikke oppdatere påminnelsene. Prøv igjen.',
  'gravesHub.notifications.noSelection': 'Velg en person for å fortsette.',
  'gravesHub.sidePanel.title': 'Støtte og veiledning',
  'gravesHub.sidePanel.empty':
    'Velg en person for å se tips og verktøy for å holde siden oppdatert.',
  // Post-kjøp bruk av ramme
  'postPurchase.applyFrame.title': 'Bruk kjøpet ditt nå?',
  'postPurchase.applyFrame.body': 'Du kan legge det du nettopp kjøpte på en grav med en gang.',
  'postPurchase.applyFrame.select': 'Velg en person',
  'postPurchase.applyFrame.apply': 'Bruk på denne siden',
  'postPurchase.applyFrame.inventory': 'Gå til Mine valg',
  'postPurchase.applyFrame.skip': 'Hopp over nå',
  // Inventar hurtigbruk
  'inventory.applyFrame': 'Bruk den nå',
  'inventory.applyFrame.select': 'Velg en person',
  'inventory.applyFrame.open': 'Åpne siden',
  'inventory.apply.select': 'Velg en person',
  'inventory.apply.button.frame': 'Bruk sirkelen nå',
  'inventory.apply.button.candle': 'Tenn lyset nå',
  'inventory.apply.button.default': 'Bruk dette nå',
  'inventory.apply.title.frame': 'Hvem skal få sirkelen?',
  'inventory.apply.title.candle': 'Hvem tenner du lyset for?',
  'inventory.apply.title.default': 'Bruk det du kjøpte nå',
  'inventory.apply.link.store': 'Finn et nytt lys i butikken',
  'inventory.buyMore.frame': 'Finn en ny sirkel',
  'inventory.buyMore.candle': 'Finn et nytt lys',
  'inventory.buyMore.default': 'Finn noe nytt',
  grave_candles_light_now: 'Tenn lyset for {name}',
  grave_candles_browse_store: 'Finn et nytt lys',
  cover_photo_adjust_hint: 'Juster bildet slik det føles riktig',
  cover_photo_drag_hint: 'Dra for å justere',
  cover_photo_reset: 'Tilbakestill utsnitt',
  frame_apply_success: 'Ramme lagt på',
  frame_apply_failed: 'Kunne ikke legge på rammen',
  remove_grave_frame: 'Fjern profilramme',
  frame_remove_success: 'Rammen ble fjernet',
  frame_remove_failed: 'Kunne ikke fjerne rammen',
  'create_group.invite.title': 'Inviter (valgfritt)',
  'create_group.invite.placeholder_name': 'Skriv navn eller e-post',
  'create_group.invite.placeholder_msg': 'Skriv noen ord',
  loading: 'Laster…',
  'per_page.label': 'Per side',
  'notifications.group_invite.eyebrow': 'Gruppeinvitasjon',
  'notifications.group_invite.title': '{inviterName} inviterte deg til {groupName}',
  'notifications.group_invite.body': 'Godta invitasjonen for å bli med i gruppesamtalen.',
  'notifications.group_invite.accepted': 'Gruppeinvitasjonen er godtatt.',
  'notifications.group_invite.declined': 'Gruppeinvitasjonen er avslått.',
  'notifications.group_invite.action_error': 'Kunne ikke oppdatere gruppeinvitasjonen.',
  'notifications.group_join_request.eyebrow': 'Forespørsel om gruppeinnmelding',
  'notifications.group_join_request.title': '{requesterName} ba om å bli med i {groupName}',
  'notifications.group_join_request.accepted': 'Forespørselen om gruppeinnmelding er godkjent.',
  'notifications.group_join_request.declined': 'Forespørselen om gruppeinnmelding er avslått.',
  'notifications.group_join_request.action_error':
    'Kunne ikke oppdatere forespørselen om gruppeinnmelding.',
  'groups.accept.working': 'Godtar invitasjonen din…',
  'groups.accept.ok': 'Du har blitt med i rommet.',
  'groups.accept.view': 'Gå til rommet',
  'groups.accept.fail': 'Invitasjonen er ugyldig eller utløpt.',
  'groups.accept.back': 'Tilbake til rom',
  'groups.accept.title': 'Gruppeinvitasjon',
  'groups.accept.loading': 'Laster invitasjon...',
  'groups.accept.auth_required': 'Logg inn eller opprett en konto for å se gruppeinvitasjonen.',
  'groups.accept.member_count': '{count, plural, one {# medlem} other {# medlemmer}}',
  'groups.accept.invite_label': 'Gruppeinvitasjon',
  'groups.members.label': 'De som er med: {count}',
  'groups.confirm.delete': 'Slette dette rommet?',
  'groupDetails.loading': 'Laster rommet…',
  'groupDetails.error': 'Kunne ikke laste rommet',
  'groupDetails.edit': 'Rediger rommet',
  'groups.banner.join': 'Bli med',
  'groups.banner.request_join': 'Be om å bli med',
  'groups.banner.joined': 'Medlem',
  'groups.files.empty': 'Ingen filer ennå.',
  'groups.join.unavailable': 'Å bli med krever invitasjon eller godkjenning av eier.',
  'groups.join.success': 'Du ble med i rommet.',
  'groups.leave': 'Forlat rommet',
  'groups.leave.confirm': 'Forlate dette rommet?',
  'groups.leave.success': 'Du har forlatt rommet.',
  'groups.leave.unavailable': 'Kunne ikke forlate rommet.',
  'groupDetails.form.name': 'Navn',
  'groupDetails.form.description': 'Beskrivelse',
  'groupDetails.form.category': 'Kategori',
  'groupDetails.addMember.title': 'Inviter til rommet',
  'groupDetails.addMember.searchLabel': 'Inviter person (søk på navn)',
  'groupDetails.addMember.placeholder': 'Søk etter personer…',
  'groupDetails.addMember.selected': 'Valgt',
  'groupDetails.addMember.selectedId': 'Valgt bruker-ID:',
  'groupDetails.addMember.role': 'Rolle',
  'groupDetails.addMember.status': 'Status',
  'groupDetails.addMember.submit': 'Inviter',
  'groupDetails.addMember.loadMore': 'Last inn flere',
  'groupDetails.members.title': 'De som er med',
  'groupDetails.members.empty': 'Ingen medlemmer ennå.',
  'groupDetails.members.table.id': 'ID',
  'groupDetails.members.table.user': 'Bruker',
  'groupDetails.members.table.role': 'Rolle',
  'groupDetails.members.table.status': 'Status',
  'groupDetails.members.table.actions': 'Handlinger',
  'groupDetails.members.remove': 'Fjern',
  'groupDetails.confirm.remove': 'Vil du fjerne denne personen fra rommet?',
  'groupDetails.categoryPrefix': 'Kategori: {name}',
  'groupDetails.fallbackTitle': 'Rom #{id}',
  create_grave_validation_full_date_required: 'Velg år, måned og dag',
  create_grave_date_help: 'Velg år, deretter måned og dag',
  'checkout.gift.buyAsGift': 'Kjøp som gave',
  'checkout.gift.recipient': 'Mottaker',
  'checkout.gift.recipient.placeholder': 'Brukernavn eller slug til mottaker',
  'nav.sparks': 'Skap Gnist',
  'nav.my_family': 'Familietre',
  'nav.home': 'Hjem',
  'nav.groups': 'Rom',
  'rooms.navigation.unread_label':
    'Rom, {count, plural, one {# ulest melding} other {# uleste meldinger}}',
  'rooms.mine.navigation.unread_label':
    'Mine rom, {count, plural, one {# ulest melding} other {# uleste meldinger}}',
  'rooms.inbox.muted': 'Varsler er dempet',
  'rooms.inbox.room_unread_label':
    '{count, plural, one {# ulest melding} other {# uleste meldinger}}',
  'nav.familyTree': 'Familietre',
  'nav.graves': 'Mine graver',
  'nav.store': 'Nærvær',
  'nav.primary': 'Hovednavigasjon',
  'nav.mobile_graves': 'Graver',
  'header.openMessages': 'Åpne meldinger',
  'messenger.searchPlaceholder': 'Søk i samtaler',
  'messenger.newConversation': 'Ny samtale',
  'messenger.loading': 'Laster samtaler…',
  'messenger.error': 'Vi klarte ikke å laste meldingene dine.',
  'messenger.emptyState': 'Ingen samtaler ennå. Start en samtale for å holde kontakten.',
  'messenger.selectThread': 'Velg en samtale for å vise meldinger.',
  'messenger.emptyMessages': 'Ingen meldinger ennå. Si hei for å starte samtalen.',
  'messenger.attach': 'Legg ved fil',
  'messenger.emoji': 'Sett inn emoji',
  'messenger.send': 'Send',
  'messenger.call': 'Start samtale',
  'messenger.typing': 'Skriver…',
  'messenger.online': 'Pålogget',
  'messenger.status.online': 'Pålogget',
  'messenger.status.offline': 'Frakoblet',
  'messenger.status.lastSeen': 'Sist sett {time}',
  'messenger.status.group': 'Gruppesamtale',
  'messenger.status.groupCount': '{online} av {total} pålogget',
  'messenger.loadingContacts': 'Laster kontakter…',
  'messenger.errorContacts': 'Vi klarte ikke å laste kontaktene dine.',
  'messenger.noContacts':
    'Ingen relasjoner funnet ennå. Legg til relasjoner for å starte en samtale.',
  'messenger.conversations': 'Samtaler',
  'messenger.status.live': 'Live',
  'messenger.status.reconnecting': 'Kobler til på nytt…',
  'messenger.status.connecting': 'Kobler til…',
  'messenger.loadOlder': 'Last inn eldre meldinger',
  'messenger.decryptionFailed': 'Meldingen kunne ikke dekrypteres.',
  'messenger.encryptedPlaceholder': '🔒 Kryptert melding venter på synkronisering…',
  'messenger.mls.syncingEncryption': 'Synkroniserer kryptering… (prøver på nytt)',
  'messenger.mls.pendingSync': 'Synkroniserer krypterte meldinger…',
  'messenger.mls.notEnabled': 'Denne chatten støtter ikke MLS. Start en ny kryptert samtale.',
  'messages.title': 'Messages',
  'messages.search': 'Search conversations',
  'messages.new.title': 'Start a conversation',
  'messages.new.recipient': 'Recipient ID',
  'messages.new.subject': 'Subject (optional)',
  'messages.new.start': 'Start',
  'messages.empty': 'No conversations yet',
  'messages.empty.hint': 'Start one from the form on the left.',
  'messages.list.unread': 'Unread',
  'messages.list.open': 'Open',
  'messages.thread.title': 'Conversation',
  'messages.thread.loading': 'Loading messages…',
  'messages.thread.error': 'Could not load messages.',
  'messages.thread.placeholder': 'Write a message…',
  'messages.thread.send': 'Send',
  'pagination.prev': 'Forrige',
  'pagination.next': 'Neste',
  'error.generic': 'Something went wrong.',
  'sparks.weeklyQuestion.title': 'Ukens spørsmål',
  'sparks.weeklyQuestion.body': 'Hva gjør at du føler deg mest knyttet til dem du har mistet?',
  'sparks.weeklyQuestion.answerCta': 'Skap Gnist',
  'sparks.create.title': 'Lag en gnist',
  'sparks.create.hint': 'Vær snill. Vær ekte. Hold det varmt.',
  'sparks.create.linkGrave': 'Knytt til en grav',
  'sparks.create.submit': 'Tenn',
  'sparks.composer.open': 'Skap Gnist',
  'sparks.topics.title': 'Temaer',
  'sparks.topics.empty': 'Ingen temaer ennå.',
  'sparks.highlights.title': 'Høydepunkter',
  'sparks.highlights.empty': 'Ingen høydepunkter ennå.',
  'sparks.feed.empty': 'Ingen gnister ennå.',
  'sparks.filters.title': 'Filter',
  'sparks.filters.newest': 'Nyeste',
  'sparks.filters.mostActive': 'Mest aktive',
  'sparks.filters.stars': 'Stjerner',
  'sparks.filters.open': 'Filter og temaer',
  'sparks.quote.title': 'En tanke i dag',
  'sparks.quote.loading': 'Finner dagens tanke…',
  'sparks.quote.empty': 'Hva om livet handler om å gjøre verden litt bedre for noen?',
  'sparks.suggestions.title': 'Forslag',
  'sparks.suggestions.empty': 'Ingen forslag ennå.',
  'sparks.rooms.title': 'Rom for det vi har felles',
  'sparks.rooms.body':
    'Møt mennesker som kjenner seg igjen i det som betyr noe for deg. Del erfaringer, finn støtte og utforsk det dere er opptatt av.',
  'sparks.rooms.cta': 'Utforsk Rom',
  spark_submit_error: 'Det oppstod en feil under publisering. Prøv igjen.',
  media_uploaded: 'Opplastingen er fullført',
  search_set_relation_title: 'Finn graven for å sette relasjon',
  filter_graves: 'Filtrer graver',
  country: 'Land',
  municipality: 'Kommune',
  search_placeholder: 'Søk etter navn',
  clear: 'Tøm',
  set_relation: 'Velg din relasjon',
  go_to_grave: 'Gå til graven',
  relation_confirmed: 'Relasjon bekreftet',
  relation_waiting_for_approval: 'Relasjon venter på godkjenning',
  relation_modal_title: 'Sett relasjon',
  relation_modal_desc: 'Velg begge sider av relasjonen. Vi lagrer når begge er valgt.',
  their_relation_to_you: 'Deres relasjon til deg',
  your_relation_to_them: 'Din relasjon til dem',
  optional_note: 'Valgfri merknad',
  relation_note_placeholder: 'Legg til en kort merknad eller et minne (valgfritt)',
  bond_saved_confirmation: 'Relasjonen lagres: {a} og {b}.',
  select_both_relations_hint: 'Velg begge relasjonene for å fortsette.',
  save_relation: 'Lagre relasjon',
  cancel: 'Avbryt',
  results_count_one: 'Viser {count} treff',
  results_count_other: 'Viser {count} treff',
  search_grave_results_one: '{count} grav funnet',
  search_grave_results_other: '{count} treff',
  search_grave_load_more: 'Last inn flere graver',
  spark_feeling_tooltip_freedom: 'Stå med frihet, åpen og fryktløs.',
  spark_feeling_tooltip_reflecting: 'Gå med refleksjon i stillhet.',
  spark_feeling_tooltip_wonder: 'Se med undring, øyne åpne og nye.',
  spark_feeling_tooltip_gratitude: 'Lev med takknemlighet, navngi det som er godt.',
  spark_feeling_tooltip_peace: 'Hvil med fred, mykt nærvær for hjertet.',
  spark_feeling_tooltip_hopeful: 'Gå med håp mot det som kommer.',
  spark_feeling_tooltip_connection: 'Vær med andre i delt bånd.',
  spark_category_question_description: 'Inviter andre til å undre sammen.',
  spark_category_story_description: 'Fortell et øyeblikk slik det skjedde.',
  spark_category_Story: 'Fortelling',
  spark_category_insight_description: 'Del en sannhet du har sett.',
  spark_category_feeling_description: 'Sett ord på det som lever i deg nå',
  spark_category_Feeling: 'Følelse',
  discard_draft: 'Legg bort utkast',
  spark_category_intention_description: 'Si hva du ønsker å bringe.',
  'designSystem.timePicker.label.hour': 'Time',
  'designSystem.timePicker.label.minute': 'Minutt',
  'designSystem.timePicker.label.period': 'Del av døgnet',
  'designSystem.timePicker.placeholder.hour': 'Velg time',
  'designSystem.timePicker.placeholder.minute': 'Velg minutt',
  'designSystem.timePicker.placeholder.period': 'Velg del av døgnet',
  'designSystem.timePicker.clear': 'Tøm klokkeslett',
  'designSystem.timePicker.period.am': 'AM',
  'designSystem.timePicker.period.pm': 'PM',
  'designSystem.select.noResults': 'Ingen treff',
  'designSystem.select.clear': 'Fjern valg',
  'designSystem.select.searchPlaceholder': 'Skriv for å søke',
  aunt_in_law_parent: 'Svigertantes forelder',
  aunt_in_law_sibling: 'Svigertantes søsken',
  aunt_in_law_sibling_daughter: 'Svigertantes søskens datter',
  aunt_in_law_sibling_daughter_daughter: 'Svigertantes søskens datters datter',
  brother_in_law_parent: 'Svogerens forelder',
  brother_in_law_sibling: 'Svogerens søsken',
  brother_in_law_sibling_son: 'Svogerens søskens sønn',
  brother_in_law_sibling_son_son: 'Svogerens søskens sønns sønn',
  brother_in_law_son: 'Svogerens sønn',
  father_in_law_parent: 'Svigerfars forelder',
  father_in_law_sibling: 'Svigerfars søsken',
  father_in_law_sibling_parent: 'Svigerfars søskens forelder',
  father_in_law_sibling_sibling: 'Svigerfars søskens søsken',
  father_in_law_sibling_sibling_son: 'Svigerfars søskens søskens sønn',
  father_in_law_sibling_son: 'Svigerfars søskens sønn',
  father_in_law_sibling_son_son: 'Svigerfars søskens sønns sønn',
  father_in_law_son: 'Svigerfars sønn',
  father_parent_sibling_sibling: 'Fars forelders søskens søsken',
  father_sibling_sibling: 'Fars søskens søsken',
  father_sibling_sibling_son: 'Fars søskens søskens sønn',
  first_cousin_once_removed_in_law: 'Inngiftet søskenbarn én generasjon forskjøvet',
  grandfather_in_law: 'Svigerbestefar',
  grandmother_in_law: 'Svigerbestemor',
  mother_in_law_daughter: 'Svigermors datter',
  mother_in_law_parent: 'Svigermors forelder',
  mother_in_law_sibling: 'Svigermors søsken',
  mother_in_law_sibling_daughter: 'Svigermors søskens datter',
  mother_in_law_sibling_daughter_daughter: 'Svigermors søskens datters datter',
  mother_in_law_sibling_parent: 'Svigermors søskens forelder',
  mother_in_law_sibling_sibling: 'Svigermors søskens søsken',
  mother_in_law_sibling_sibling_daughter: 'Svigermors søskens søskens datter',
  mother_parent_sibling_sibling: 'Mors forelders søskens søsken',
  mother_sibling_sibling: 'Mors søskens søsken',
  parent_spouse: 'Forelders ektefelle',
  sister_in_law_daughter: 'Svigerinnens datter',
  sister_in_law_parent: 'Svigerinnens forelder',
  sister_in_law_sibling: 'Svigerinnens søsken',
  sister_in_law_sibling_daughter: 'Svigerinnens søskens datter',
  sister_in_law_sibling_daughter_daughter: 'Svigerinnens søskens datters datter',
  spouse_daughter: 'Ektefelles datter',
  spouse_son: 'Ektefelles sønn',
  uncle_in_law_parent: 'Svigeronkels forelder',
  uncle_in_law_sibling: 'Svigeronkels søsken',
  uncle_in_law_sibling_son: 'Svigeronkels søskens sønn',
  uncle_in_law_sibling_son_son: 'Svigeronkels søskens sønns sønn',
  'home_page.brand_name': 'Nettgrav',
  'home_page.hero_title': 'Det som binder oss sammen',
  'home_page.hero_subtitle':
    'Nettgrav samler menneskene, verdiene og historiene som former et liv. Her kan du ta vare på det som betyr noe, mens livet leves og for dem som kommer etter.',
  'home_page.cta_my_light': 'Utforsk Mitt lys',
  'home_page.cta_search_graves': 'Finn grav',
  'home_page.cta_create_grave': 'Opprett en Nettgrav',
  'home_page.cta_shop_frames': 'Til merkedagen',
  'home_page.chip_invite_family': 'Familie',
  'home_page.chip_share_memory': 'Tro',
  'home_page.chip_light_candle': 'Håp',
  'home_page.chip_apply_frame': 'Kjærlighet',
  'home_page.hero_pick_grave': 'Velg en grav',
  'home_page.hero_select_details': 'Velg for å se detaljer',
  'home_page.chip_anniversary_tomorrow': 'Årsdag i morgen',
  'home_page.hero_quote': 'Hun lærte oss at kjærlighet er noe man gjør, ikke bare føler.',
  'home_page.life_preview_label': 'Mitt lys',
  'home_page.life_preview_title': 'Det som er viktig, fortjener en plass',
  'home_page.life_preview_body':
    'Et sted for det du står for, menneskene rundt deg og det du ønsker å gi videre.',
  'home_page.life_preview_values_title': 'Det jeg står for',
  'home_page.life_preview_values_body': 'Verdier og ord som forteller noe om deg.',
  'home_page.life_preview_compass_title': 'Mitt kompass',
  'home_page.life_preview_compass_body': 'Retningen du ønsker å holde fast i.',
  'home_page.life_preview_people_title': 'Menneskene mine',
  'home_page.life_preview_people_body': 'Relasjonene som former livet ditt.',
  'home_page.life_preview_after_title': 'Etter meg',
  'home_page.life_preview_after_body': 'Det du ønsker at andre skal vite en dag.',
  'home_page.life_preview_cta': 'Se hvordan Mitt lys fungerer',
  'home_page.btn_light_candle': 'Se lysene',
  'home_page.btn_add_memory': 'Skriv noen ord',
  'home_page.btn_apply_frame': 'Livssirkler',
  'home_page.btn_invite_family': 'Inviter familie',
  'home_page.nearby_btn_light_candle': 'Besøk graven',
  'home_page.nearby_btn_add_memory': 'Skriv noen ord',
  'home_page.nearby_btn_apply_frame': 'Livssirkler',
  'home_page.nearby_btn_invite_family': 'Legg til bilde',
  'home_page.graves_hub_title': 'Et gravsted som alltid er nær',
  'home_page.graves_hub_subtitle':
    'Nettgrav er kostnadsfritt for alle familier. Besøk gravstedet når du vil, og ta vare på bilder, historier og minner sammen.',
  'home_page.people_care_for': 'Folk jeg bryr meg om',
  'home_page.people_add': '+ Legg til',
  'home_page.placeholder_name': 'Ingeborg Larsen',
  'home_page.tag_new_memory': 'Nytt minne',
  'home_page.pick_grave': 'Velg en grav',
  'home_page.select_to_view': 'Velg for å se detaljer',
  'home_page.birthday_soon': 'Bursdag snart',
  'home_page.recent_updates': 'Siste oppdateringer',
  'home_page.updates_placeholder': 'Oppdateringer eller påminnelser vises her.',
  'home_page.memorial_title': 'Hver person har en historie.',
  'home_page.memorial_subtitle':
    'På gravveggen kan familie og venner samle bilder, ord og opplevelser. Slik får flere bidra til historien om mennesket graven representerer.',
  'home_page.select_grave': 'Velg en grav',
  'home_page.add_guardian': 'Legg til verge',
  'home_page.invite_family_contribute': 'Inviter familie til å bidra',
  'home_page.share_memory_prompt': 'Del et bilde, skriv noen ord eller vis at du har vært her.',
  'home_page.btn_share_memory': 'Skriv på gravveggen',
  'home_page.from_family': 'Fra familien',
  'home_page.family_quote':
    '«Hun holdt alltid lysene tent om vinteren, så huset føltes varmt når vi kom inn.»',
  'home_page.added_days_ago': 'Lagt til for 3 dager siden',
  'home_page.explore_memorial': 'Utforsk {name}',
  'home_page.this_memorial': 'dette minnet',
  'home_page.family_beta': 'Beta',
  'home_page.social_title': 'Bygget for livet mellom mennesker',
  'home_page.social_subtitle':
    'Nettgrav samler samtaler, fellesskap og det vi ønsker å dele på ett sted. For relasjonene vi bygger mens vi lever, og nærheten vi tar vare på gjennom hele livet.',
  'home_page.social_chat_title': 'Samtaler som holder mennesker nær',
  'home_page.social_chat_body':
    'Skriv, ring eller møtes på video. Snakk privat én til én, eller samle familie og venner i en gruppe.',
  'home_page.social_chat_security': 'Ende-til-ende-kryptert med hybrid post-kvantebeskyttelse.',
  'home_page.social_chat_cta': 'Åpne Chat',
  'home_page.social_rooms_title': 'Rom for det vi har felles',
  'home_page.social_rooms_body':
    'Møt mennesker med erfaringer, interesser eller spørsmål som berører noe av det samme.',
  'home_page.social_rooms_cta': 'Utforsk Rom',
  'home_page.social_sparks_title': 'Skap Gnist',
  'home_page.social_sparks_body':
    'Del en tanke, erfaring eller undring. Noe lite for deg kan bety mye for andre.',
  'home_page.social_sparks_cta': 'Utforsk Gnister',
  'home_page.store_title': 'For noen du tenker på',
  'home_page.store_subtitle':
    'På Nettgraven kan lys og sirkler gi tanken din et personlig uttrykk.',
  'home_page.store_description':
    'Velg et lys for en merkedag, eller en sirkel som forteller noe om mennesket.',
  'home_page.store_quote':
    'En Nettgrav rommer mer enn navn og datoer. Den kan også fortelle om mennesket, relasjonene og det som fortsatt betyr noe.',
  'home_page.store_frames': 'Sirkler for livet',
  'home_page.store_candles': 'Lys for merkedager',
  'home_page.store_view': 'Se',
  'home_page.store_visit': 'Utforsk Nærvær',
  'home_page.reminders_title': 'Merkedager, på din måte',
  'home_page.reminders_subtitle':
    'Nettgrav samler merkedagene til dem du bryr deg om og hjelper deg å være til stede når det føles riktig.',
  'home_page.reminder_label_tomorrow': 'I morgen',
  'home_page.reminder_title_birthday': 'Ingeborgs bursdag',
  'home_page.reminder_body_birthday':
    '«Hun ville fylt 84 år. Hun elsket morgener, kaffe og at vi ringte.» En anledning til å minnes på din måte.',
  'home_page.reminder_label_next_week': 'Neste uke',
  'home_page.reminder_title_visit': 'Tid for et besøk',
  'home_page.reminder_body_visit':
    'Når det føles riktig å være til stede. Nettgrav minner deg, og du bestemmer.',
  'home_page.reminder_action_visit': 'Tilpass tidspunktet slik det passer for deg',
  'home_page.reminder_label_new': 'Nytt',
  'home_page.reminder_title_memory': 'Nytt bilde fra Line',
  'home_page.reminder_body_memory':
    'Line delte et minne. Når noen legger til noe, blir det en del av historien som varer.',
  'home_page.reminder_action_memory': 'Se minne',
  'home_page.family_title': 'Vi hører sammen gjennom generasjoner',
  'home_page.family_subtitle':
    'Se relasjonene mellom mennesker, ta vare på familiehistorien og gi neste generasjon et sted å finne den.',
  'home_page.family_grandparents': 'Besteforeldre',
  'home_page.family_linked_graves': 'I sammenheng',
  'home_page.family_children': 'Barn',
  'home_page.family_living': 'Levde og minnet',
  'home_page.family_open': 'Se familietreet',
  'home_page.why_title': 'Et menneske er mer enn et navn på en grav',
  'home_page.why_subtitle':
    'Nettgrav gir minner, relasjoner og historier et sted å leve videre. Kostnadsfritt for alle familier.',
  'home_page.why_secure_title': 'For alle familier',
  'home_page.why_secure_body':
    'Alle skal kunne gi dem de har mistet et meningsfullt gravsted, uavhengig av økonomi eller bosted.',
  'home_page.why_secure_item1': '',
  'home_page.why_secure_item2': '',
  'home_page.why_secure_item3': '',
  'home_page.why_connected_title': 'Bygget for nærhet',
  'home_page.why_connected_body':
    'Ta vare på minner sammen, hold kontakt med mennesker og finn fellesskap når du trenger det.',
  'home_page.why_connected_item1': '',
  'home_page.why_connected_item2': '',
  'home_page.why_connected_item3': '',
  'home_page.why_tools_title': 'Historien får bli',
  'home_page.why_tools_body':
    'Det dere samler i dag, gir kommende generasjoner et sted å finne menneskene og historiene som kom før dem.',
  'home_page.why_tools_item1': '',
  'home_page.why_tools_item2': '',
  'home_page.why_tools_item3': '',
  'home_page.why_footer_quote':
    '«Vi jobber mot vår egen irrelevans — og det er det mest meningsfulle vi vet å gjøre.»',
  'home_page.why_footer_source': 'End of Time Center — forskning på liv, død og det som varer',
  circle_description1:
    'Sirklene bærer profilbildet og gir et stille uttrykk for personens verdier, personlighet og nærvær.',
  presence_description1: 'Du velger graven, og lyset tennes der.',
  presence_description2: 'For mange er lys en god måte å vise håp og møte tanker på.',
  new_home_page_store_description:
    'Nettgrav er <link>End of Time Care</link> i praksis: omsorg som ikke slutter, men fortsetter i handlingene vi gjør for hverandre.',
  Mandag: 'Mandag',
  Tirsdag: 'Tirsdag',
  Onsdag: 'Onsdag',
  Torsdag: 'Torsdag',
  Fredag: 'Fredag',
  administrator: 'Administrator',
  administrator_access: 'Administratortilgang',
  invited_person_name: 'Navn på den inviterte',
  relation_to_grave: 'Den inviterte sin relasjon til {graveName}',
  relation_to_person: '{graveName} sin relasjon til den inviterte',
  select_role: 'Velg rolle',
  select_role_error: 'Velg brukerrollen',
  user_name: 'Brukernavn',
  remove_members_warring:
    'Fjern {remainingNumber} flere medlemmer eller avbryt invitasjonene deres (eller begge deler).',
  normal: 'Normal',
  invite_coming_soon: 'Invitasjoner kommer snart',
  family_tree_relation_kind_blood: 'Blodsbånd',
  family_tree_relation_kind_spouse: 'Ektefelle',
  family_tree_relation_kind_in_law: 'Inngiftet',
  family_tree_relation_kind_step: 'Stefamilie',
  family_tree_relation_kind_other: 'Annet',
  family_tree_relation_confidence_explicit: 'Eksplisitt',
  family_tree_spouses_label: 'Ektefeller',
  family_tree_sources_label: 'Kilder',
  family_tree_no_root: 'Velg en person for å se relasjonene.',
  family_tree_error: 'Vi kunne ikke laste dette familietreet. Vennligst prøv igjen.',
  family_tree_self_label: 'Fokusperson',
  family_tree_no_self: 'Ingen fokusperson',
  family_tree_group_descendants: 'Etterkommere',
  family_tree_group_in_laws: 'Inngiftede',
  family_tree_group_empty: 'Ingenting å vise ennå.',
  family_tree_meta_summary: '{count} personer • radius {radius}',
  find_grave_image_title: 'Graven gir et annet perspektiv på livet vårt. På din',
  find_grave_text: 'har du en egen vegg der kontaktene dine kan stille deg spørsmål.',
  'groups.sidebar.quick': 'Rom du kanskje vil like',
  'groups.sidebar.quick.sub': 'Rom som er åpne og i bruk.',
  'groups.categories.sub': 'Velg en kategori for å finne rom som passer for deg.',
  'groups.section.top': 'Utforsk rom',
  'groups.section.top.sub': 'Åpne rom du kan gå inn i nå.',
  'groups.section.mine.sub': 'Rom du eier eller deltar i.',
  'groups.section.suggested': 'Foreslått for deg',
  'groups.section.suggested.sub': 'Rom som matcher søket og filtrene dine.',
  'groups.section.new': 'Nye rom',
  'groups.section.new.sub': 'Nylig opprettede rom du kan bli med i.',
  'groups.rules.placeholder': 'Én regel per linje',
  'groups.rules.empty': 'Ingen egne retningslinjer er lagt til.',
  'groups.members.creator': 'Holder rommet',
  'groups.role.owner': 'Holder rommet',
  'groups.role.admin': 'Medansvarlig',
  'groups.role.member': 'Medlem',
  'groups.members.co_creators': 'Medansvarlige',
  'groups.members.send_message': 'Send melding',
  'groups.members.message_soon': 'Direktemeldinger fra rom kommer snart i End of Time-chat.',
  'groups.members.make_creator': 'Gjør til romansvarlig',
  'groups.members.remove_from_group': 'Fjern fra rommet',
  'groups.members.turn_on_post_approval': 'Slå på godkjenning av innlegg',
  'groups.members.turn_off_post_approval': 'Slå av godkjenning av innlegg',
  'groups.members.change_to_member_only': 'Endre til kun medlem',
  'groups.members.leave_group': 'Forlat rommet',
  'groups.members.cancel_at_period_end': 'Avsluttes ved slutten av perioden',
  'groups.members.period_end_info':
    'Når fornyelse stoppes, beholder personen tilgang til slutten av inneværende periode.',
  'groups.members.make_creator.success': 'Romansvarlig oppdatert.',
  'groups.members.action_error': 'Kunne ikke oppdatere medlem.',
  'groups.files.photos': 'Bilder',
  'groups.files.videos': 'Videoer',
  'groups.files.documents': 'Dokumenter',
  'groups.files.upload_photo': 'Last opp bilde',
  'groups.files.upload_video': 'Last opp video',
  'groups.files.upload_document': 'Last opp dokument',
  'groups.files.upload_success': 'Fil lastet opp.',
  'groups.files.upload_error': 'Kunne ikke laste opp fil.',
  'groups.files.upload_too_large': 'Filen er for stor. Maksimal størrelse er {size}.',
  'groups.files.delete_error': 'Kunne ikke slette fil.',
  'groups.files.delete_success': 'Filen er slettet.',
  'groups.files.type_tabs': 'Filtyper',
  'groups.files.open_photo': 'Åpne {name}',
  'groups.files.play_video': 'Spill av {name}',
  'groups.files.load_error.title': 'Kunne ikke laste filer',
  'groups.files.load_error.text': 'Prøv igjen om et øyeblikk.',
  'groups.files.retry': 'Prøv igjen',
  'groups.files.delete_confirm.title': 'Slette filen?',
  'groups.files.delete_confirm.text': '{name} fjernes permanent fra rommet.',
  'groups.files.loading': 'Laster filer...',
  'groups.files.photos.empty': 'Ingen bilder ennå.',
  'groups.files.videos.empty': 'Ingen videoer ennå.',
  'groups.files.documents.empty': 'Ingen dokumenter ennå.',
  'groups.files.sort': 'Sorter dokumenter',
  'groups.files.sort.newest': 'Nyeste',
  'groups.files.sort.name': 'Navn',
  'groups.files.view': 'Vis',
  'groups.files.download': 'Last ned',
  'groups.files.details': 'Detaljer',
  'groups.files.delete': 'Slett',
  'groups.files.action.view': 'Visning kommer snart.',
  'groups.files.action.download': 'Nedlasting blir tilgjengelig snart.',
  'groups.files.action.details': '{name} · {size} KB',
  'groups.subscribe.saved_methods': 'Lagrede betalingsmetoder',
  'groups.subscribe.saved_methods.loading': 'Laster lagrede metoder...',
  'groups.subscribe.saved_methods.none': 'Ingen lagrede betalingsmetoder funnet.',
  'groups.subscribe.saved_methods.use_other': 'Bruk en annen metode',
  'groups.subscribe.saved_methods.default': 'Standard',
  'groups.subscribe.next_step.saved':
    'Neste: vi bruker din lagrede metode og går videre til sikker bekreftelse.',
  'groups.subscribe.next_step.vipps': 'Neste: du går videre i Vipps for å bekrefte medlemskapet.',
  'groups.subscribe.next_step.card': 'Neste: du går videre i Stripe for å bekrefte medlemskapet.',
  'groups.subscribe.saved_method.invalid':
    'Lagret betalingsmetode er ikke lenger gyldig. Velg en annen metode og prøv igjen.',
  'groups.banner.members': '{count, number} medlemmer · {posts, number} innlegg/dag',
  'groups.banner.members_only': '{count, number} medlemmer',
  'groups.banner.default_subtitle': 'Et rom for rolige samtaler.',
  'groups.banner.held_by': 'Holdes av {name}',
  'groups.composer.label': 'Nytt innlegg',
  'groups.composer.helper': 'Del noen ord, et bilde eller en video i rommet.',
  'groups.composer.placeholder': 'Del noe i rommet…',
  'groups.section.about.title': 'Om rommet',
  'groups.section.about.text': 'Her ser du beskrivelse, rammer og hvem som holder rommet.',
  'groups.section.members.title': 'Menneskene i rommet',
  'groups.section.members.text': 'Se hvem som er med, og inviter flere når det passer.',
  'groups.section.files.title': 'Bilder, videoer og dokumenter',
  'groups.section.files.text': 'Alt som er lagt i rommet, samlet på ett sted.',
  'groups.section.requests.title': 'Forespørsler som venter',
  'groups.section.requests.text': 'Her kan du gå gjennom medlems- og innleggforespørsler.',
  'groups.section.settings.title': 'Rominnstillinger',
  'groups.section.settings.text': 'Juster rammer, synlighet og hvordan rommet fungerer.',
  'groups.preview.author': 'Den som holder rommet',
  'groups.preview.just_now': 'sier',
  'groups.cta.invite': 'Inviter',
  'groups.cta.post': 'Del',
  'groups.invite.subtitle': 'Inviter folk inn i dette rommet',
  'groups.invite.title': 'Inviter medlemmer',
  'groups.invite.sent': 'Invitasjon sendt.',
  'groups.join.toPost': 'Bli med i rommet for å dele.',
  'groups.see_comments': 'Se svar',
  'groups.tabs.about': 'Om',
  'groups.tabs.files': 'Filer',
  'groups.tabs.members': 'De som er med',
  'groups.tabs.requests': 'Forespørsler',
  'groups.tabs.settings': 'Innstillinger',
  'groups.tabs.mobile_nav': 'Romseksjon',
  phone_number: 'Telefonnummer',
  'admin.group_moderation.category.paid': 'Godkjenning av betalt rom',
  'admin.group_moderation.category.report': 'Rapportert rom',
  'admin.group_moderation.filter.all': 'Alle',
  'admin.group_moderation.filter.paid': 'Betalte godkjenninger',
  'admin.group_moderation.filter.reports': 'Rapporter',
  'admin.group_moderation.filter.unread': 'Uleste',
  'admin.group_moderation.note_placeholder': 'Valgfri merknad (påkrevd ved avslag).',
  'admin.group_moderation.reject_note_required': 'Legg til en avslagsmerknad før du avslår.',
  'admin.group_moderation.resolution.placeholder': 'Løsningsnotat (valgfritt).',
  'admin.group_moderation.search': 'Søk etter rom, årsak eller varsler',
  'admin.group_moderation.state.pending': 'Venter',
  'admin.group_moderation.state.resolved': 'Løst',
  'create_group.invite.sent_count': '{count} invitasjoner sendt',
  'create_group.visibility.closed': 'Lukket rom',
  'create_group.visibility.private': 'Privat rom',
  'create_group.visibility.public': 'Åpent rom',
  'groupDetails.confirm.remove.ok': 'Fjern',
  'groupDetails.confirm.remove.title': 'Fjern fra rommet',
  'groups.about.empty': 'Ingen beskrivelse ennå.',
  'groups.aria.invite_name': 'Inviter {name}',
  'groups.comments.create_error': 'Kunne ikke dele svaret.',
  'groups.comments.delete.confirm': 'Slette svaret?',
  'groups.comments.delete.title': 'Slett svar',
  'groups.comments.delete.body': 'Svaret fjernes fra samtalen. Dette kan ikke angres.',
  'groups.comments.placeholder': 'Skriv et svar...',
  'groups.post.delete.title': 'Slett innlegg',
  'groups.post.delete.body': 'Innlegget og svarene fjernes fra rommet. Dette kan ikke angres.',
  'groups.post.share': 'Del',
  'groups.post.share_success': 'Lenken til innlegget er kopiert.',
  'groups.post.share_error': 'Kunne ikke dele innlegget.',
  'groups.edit.name_required': 'Navn på rom er påkrevd.',
  'groups.edit.save_error': 'Kunne ikke lagre romdetaljer.',
  'groups.edit.saved': 'Romdetaljer lagret.',
  'groups.join.request_sent': 'Forespørsel sendt. Venter på godkjenning.',
  'groups.joined': 'Du ble med i rommet.',
  'groups.quiet.cta': 'Sett rommet til stille',
  'groups.quiet.active': 'Rommet er stille',
  'groups.quiet.confirm': 'Sette dette rommet til stille for nå?',
  'groups.quiet.enabled': 'Rommet er nå stille for en stund.',
  'groups.quiet.notice': 'Rommet er stille for nå.',
  'groups.paid.approval.approved': 'Betalt rom godkjent.',
  'groups.paid.approval.note_placeholder': 'Merknad (vises til romansvarlig/admin).',
  'groups.paid.approval.reject_note': 'Legg først til en avslagsmerknad.',
  'groups.paid.approval.rejected': 'Betalt rom avslått.',
  'groups.paid.approval.requested': 'Vurdering av betalt rom er sendt.',
  'groups.paid.connect_hint': 'Dette rommet krever betaling for å være med.',
  'groups.paid.connect_required': 'Koble til utbetalinger før du aktiverer betalt rom.',
  'groups.paid.details.audience.placeholder':
    'For personer som ønsker strukturert støtte og ukentlig oppfølging.',
  'groups.paid.details.benefits.placeholder':
    'Månedlige livesendinger, praktiske øvelser, direkte tilbakemelding...',
  'groups.paid.details.refund.placeholder':
    'Avslutt når som helst. Tilgang varer ut betalt periode.',
  'groups.paid.details_required':
    'Legg til medlemsfordeler og hvem rommet er for før du oppretter et betalt rom.',
  'groups.paid.enabled_hint': 'Sett en månedspris fra {min} til {max} NOK.',
  'groups.paid.enabled_hint_currency': 'Sett en månedspris fra {min} til {max} {currency}.',
  'groups.paid.price_range': 'Prisen må være mellom {min} og {max} NOK.',
  'groups.paid.price_range_currency': 'Prisen må være mellom {min} og {max} {currency}.',
  'groups.paid.why.title': 'Hvorfor betalte rom?',
  'groups.payout_mode.automatic': 'Automatisk via Stripe Connect',
  'groups.payout_mode.automatic.hint': 'Krever Stripe Connect-oppsett.',
  'groups.payout_mode.manual': 'Manuell månedlig utbetaling (Nettgrav)',
  'groups.payout_mode.manual.hint': 'Krever ikke Connect. Nettgrav utbetaler månedlig.',
  'groups.post.pending': 'Deler...',
  'groups.day.today': 'I dag',
  'groups.day.yesterday': 'I går',
  'groups.day.unknown': 'Tidligere',
  'groups.post.upload_error': 'Kunne ikke laste opp media. Prøv igjen.',
  'groups.report.details': 'Detaljer (valgfritt)',
  'groups.report.details.placeholder': 'Legg til kontekst som hjelper admin å vurdere raskt.',
  'groups.report.reason': 'Årsak',
  'groups.report.reason.abuse': 'Trakassering eller misbruk',
  'groups.report.reason.illegal': 'Ulovlig innhold',
  'groups.report.reason.other': 'Annet',
  'groups.report.reason.spam': 'Spam eller svindel',
  'groups.report.success': 'Takk. Rapporten er mottatt.',
  'groups.report.title': 'Rapporter rom',
  'groups.post.report': 'Rapporter innlegg',
  'groups.post.report.title': 'Rapporter innlegg',
  'groups.requests.action_error': 'Kunne ikke oppdatere forespørsel.',
  'groups.settings.save_error': 'Kunne ikke lagre innstillinger.',
  'groups.settings.saved': 'Innstillinger lagret.',
  'groups.settings.room_status': 'Romstatus',
  'groups.settings.room_status.active': 'Rommet er aktivt.',
  'groups.settings.unsaved.confirm':
    'Du har ulagrede endringer. Vil du forlate siden uten å lagre?',
  'groups.settings.categories.loading': 'Laster kategorier...',
  'groups.settings.categories.empty': 'Ingen kategorier er tilgjengelige.',
  'groups.settings.categories.error': 'Kunne ikke laste kategoriene.',
  'groups.settings.categories.retry': 'Prøv igjen',
  'groups.settings.current_rules': 'Slik fungerer rommet',
  'groups.settings.current_rules.hint': 'En oversikt over reglene som gjelder i rommet nå.',
  'groups.settings.membership.public': 'Alle kan bli med',
  'groups.settings.membership.closed': 'Romansvarlige godkjenner forespørsler',
  'groups.settings.membership.private': 'Kun via invitasjon',
  'groups.settings.cover': 'Rombilde',
  'groups.settings.cover.empty': 'Rommet har ikke noe bilde ennå.',
  'groups.settings.cover.upload': 'Last opp rombilde',
  'groups.settings.cover.remove': 'Fjern rombilde',
  'groups.settings.cover.instant_save': 'Endringer av rombildet lagres med én gang.',
  'groups.settings.cover.upload_success': 'Rombildet er oppdatert.',
  'groups.settings.cover.upload_error': 'Kunne ikke laste opp rombildet.',
  'groups.settings.cover.remove_success': 'Rombildet er fjernet.',
  'groups.settings.cover.remove_error': 'Kunne ikke fjerne rombildet.',
  'groups.quiet.reactivate': 'Gjør rommet aktivt',
  'groups.quiet.reactivate_confirm': 'Vil du gjøre rommet aktivt igjen?',
  'groups.quiet.disabled': 'Rommet er aktivt igjen.',
  'groups.quiet.update_error': 'Kunne ikke oppdatere romstatusen.',
  'groups.subscribe.pending': 'Betalingen fullføres. Oppdater om et øyeblikk.',
  'groups.subscribe.success': 'Støtten er aktiv. Du er nå med i rommet.',
  'groups.subscribe.title': 'Du trer inn som støttespiller',
  'groups.framework.title': 'Rammer for rommet',
  'groups.framework.subtitle': 'Dette er felles prinsipper for alle rom på Nettgrav.',
  'groups.framework.principle_1.title': 'Verdighet',
  'groups.framework.principle_1.body':
    'Vi møter hverandre med respekt. Ingen rangering. Ingen angrep.',
  'groups.framework.principle_2.title': 'Menneskelighet',
  'groups.framework.principle_2.body':
    'Vi skriver som mennesker. Ikke som roller. Ikke som merkevarer.',
  'groups.framework.principle_3.title': 'Stillhet',
  'groups.framework.principle_3.body': 'Stillhet er lov. Ingen forventning om respons.',
  'groups.framework.principle_4.title': 'Ansvar',
  'groups.framework.principle_4.body':
    'Romansvarlig bidrar til å holde rommet trygt og møter oppgaven med ansvar, ikke makt.',
  'groups.suggested_members': 'Forslag til hvem du kan invitere',
  'groups.time.2h': 'for et øyeblikk siden',
  'admin.group_moderation.approve': 'Godkjenn',
  'admin.group_moderation.empty': 'Tomt',
  'admin.group_moderation.mark_read': 'Merk som lest',
  'admin.group_moderation.mark_unread': 'Merk som ulest',
  'admin.group_moderation.mark_resolved': 'Sett som løst',
  'admin.group_moderation.mark_pending': 'Sett som venter',
  'admin.group_moderation.meta.group': 'Rom',
  'admin.group_moderation.meta.reason': 'Årsak',
  'admin.group_moderation.meta.reporter': 'Varsler',
  'admin.group_moderation.open_group': 'Åpne rom',
  'admin.group_moderation.refresh': 'Oppdater',
  'admin.group_moderation.reject': 'Avslå',
  'admin.group_moderation.resolution.at': 'Tidspunkt',
  'admin.group_moderation.resolution.by': 'Av',
  'admin.group_moderation.resolution.note': 'Merknad',
  'admin.group_moderation.subtitle': 'Håndter rapporter og godkjenninger for betalte rom.',
  'admin.group_moderation.summary.total': 'Totalt',
  'admin.group_moderation.summary.unread': 'Uleste',
  'admin.group_moderation.summary.visible': 'Synlige',
  'admin.group_moderation.nav': 'Moderering av rom',
  'admin.group_moderation.title': 'Moderering av rom',
  'create_group.intro': 'Åpne et rom med en tydelig retning.',
  'create_group.audience.label': 'Hvem er dette rommet for?',
  'create_group.audience.placeholder': 'Hvem skal kjenne seg hjemme her?',
  'create_group.audience.required': 'Legg til hvem rommet er for.',
  'create_group.safety_intent.label': 'Hvordan vil du holde rommet trygt?',
  'create_group.safety_intent.placeholder': 'Noen ord om tone og omtanke.',
  'create_group.safety_intent.hint':
    'For din egen bevissthet når du åpner rommet. Vises ikke offentlig.',
  'create_group.life_category.grief': 'Sorg',
  'create_group.life_category.life_choices': 'Livsvalg',
  'create_group.life_category.relationships': 'Relasjoner',
  'create_group.life_category.health': 'Helse',
  'create_group.life_category.existence': 'Eksistens',
  'create_group.life_category.guidance': 'Veiledning',
  'create_group.life_category.other': 'Annet',
  'create_group.invite.info': 'Inviter noen inn i rommet',
  'create_group.tip.name': 'Gi rommet et tydelig navn',
  'create_group.tip.visibility': 'Hvem kan se rommet?',
  'create_group.visibility': 'Synlighet',
  'create_group.visibility.public_desc': 'Alle kan lese. Man må bli med for å delta.',
  'create_group.visibility.closed_desc': 'Kun tilgjengelig via invitasjon.',
  'create_group.visibility.private_desc': 'Kun synlig for inviterte medlemmer.',
  'groupDetails.unavailable': 'Utilgjengelig',
  'groups.banner.subscribe': 'Støtt rommet',
  'groups.banner.support_with_price': 'Støtt rommet – {price} kr / mnd',
  'groups.banner.supported_badge': 'Støttet rom',
  'groups.banner.supported_subtitle': 'Dette rommet holdes åpent av dem som velger å støtte det.',
  'groups.banner.support_access_note':
    'Støtten gir tilgang til hele rommet. Kan avsluttes når som helst.',
  'groups.comments.empty': 'Ingen svar ennå.',
  'groups.comments.load_more': 'Vis flere',
  'groups.comments.post': 'Del',
  'groups.read_more': 'Les mer',
  'groups.show_less': 'Vis mindre',
  'groups.edit.no_changes': 'Ingen endringer',
  'groups.hide_comments': 'Skjul svar',
  'groups.invite': 'Inviter',
  'groups.members': 'De som er med',
  'groups.members.empty': 'Ingen medlemmer ennå.',
  'groups.members.no_results': 'Ingen medlemmer passer søket ditt.',
  'groups.members.actions': 'Handlinger for medlem',
  'groups.members.owner_admin': 'Eier/admin',
  'groups.members.see_all': 'Se alle',
  'groups.mine.feed.empty': 'Ingen samtaler ennå.',
  'groups.mine.feed.sub': 'Nye innlegg fra rom du er med i.',
  'groups.mine.feed.title': 'Siste aktivitet',
  'groups.paid.approval.approve': 'Godkjenn',
  'groups.paid.approval.reject': 'Avslå',
  'groups.paid.approval.request': 'Be om vurdering',
  'groups.paid.awaiting_approval': 'Venter på godkjenning',
  'groups.paid.connect_cta': 'Koble til utbetalinger',
  'groups.paid.details.audience': 'Målgruppe',
  'groups.paid.details.audience.hint': 'Hvem er dette rommet for?',
  'groups.paid.details.benefits': 'Fordeler',
  'groups.paid.details.benefits.hint': 'Hva får medlemmene?',
  'groups.paid.details.refund': 'Refusjon',
  'groups.paid.details.refund.hint': 'Beskriv refusjonsregler',
  'groups.paid.details.title': 'Detaljer for betalt rom',
  'groups.paid.onboarding_note': 'Betalt rom blir synlig etter godkjenning.',
  'groups.paid.preview.net': 'Netto til romansvarlig',
  'groups.paid.preview.platform': 'Nettgrav-andel',
  'groups.paid.preview.price': 'Pris',
  'groups.paid.preview.stripe': 'Stripe-gebyr',
  'groups.paid.preview.title': 'Prisoversikt',
  'groups.paid.why.body':
    'Rom gir mennesker mulighet til å bruke sin erfaring og kunnskap til å støtte andre og få bærekraft i det arbeidet.',
  'groups.paid.why.cta': 'Les mer om betalte rom',
  'groups.paid.why.point_1': 'Sett en månedlig pris som passer målgruppen.',
  'groups.paid.why.point_2': 'Gi medlemmene tydelige fordeler og oppfølging.',
  'groups.paid.why.point_3': 'Få trygg betaling med Vipps eller kort.',
  'groups.payout_mode': 'Utbetalingsmodus',
  'groups.photos.recent': 'Nylige bilder',
  'groups.photos.see_all': 'Se alle',
  'groups.photos.add': 'Legg til bilde',
  'groups.photos.loading': 'Laster bilder...',
  'groups.photos.load_error': 'Kunne ikke laste bildene.',
  'groups.photos.empty': 'Ingen bilder er delt ennå.',
  'groups.invite.search_label': 'Søk etter personer',
  'groups.invite.search_hint': 'Skriv minst to tegn for å søke.',
  'groups.invite.searching': 'Søker...',
  'groups.invite.no_results': 'Fant ingen personer.',
  'groups.posting': 'Innlegg',
  'groups.report.cta': 'Rapporter',
  'groups.report.submit': 'Send rapport',
  'groups.requests.confirm': 'Godkjenn',
  'groups.requests.decline': 'Avslå',
  'groups.requests.member_empty': 'Ingen medlemsforespørsler.',
  'groups.requests.member_title': 'Medlemsforespørsler',
  'groups.requests.post_empty': 'Ingen innlegg venter på godkjenning.',
  'groups.requests.post_title': 'Innleggsforespørsler',
  'groups.requests.load_error.title': 'Kunne ikke laste forespørsler',
  'groups.requests.load_error.text': 'Prøv igjen om et øyeblikk.',
  'groups.requests.retry': 'Prøv igjen',
  'groups.requests.member.requested': 'Ba om tilgang {time}',
  'groups.requests.attachment': 'Åpne vedlegg',
  'groups.requests.member.approve_success': 'Medlemsforespørselen er godkjent.',
  'groups.requests.member.decline_success': 'Medlemsforespørselen er avslått.',
  'groups.requests.post.approve_success': 'Innlegget er godkjent.',
  'groups.requests.post.decline_success': 'Innlegget er avslått.',
  'groups.requests.member.decline_title': 'Avslå medlemsforespørselen?',
  'groups.requests.post.decline_title': 'Avslå innlegget?',
  'groups.requests.member.decline_text': 'Forespørselen fra {name} blir avslått.',
  'groups.requests.post.decline_text': 'Innlegget fra {name} blir ikke publisert.',
  'groups.rules': 'Regler',
  'groups.settings.chat.admins': 'Kun admin',
  'groups.settings.chat.members': 'Medlemmer og admin',
  'groups.settings.chat_permissions': 'Rettigheter for romchat',
  'groups.settings.chat.readonly_note': 'Rettigheter for romchat er faste i denne versjonen.',
  'groups.settings.membership.admins': 'Kun romansvarlig og medansvarlige',
  'groups.settings.membership.anyone': 'Alle i rommet',
  'groups.settings.membership_approval': 'Godkjenning av medlemskap',
  'groups.settings.membership.readonly_note':
    'Godkjenning av medlemskap følger rommets synlighet og invitasjonsflyt.',
  'groups.settings.post_approval': 'Godkjenning av innlegg',
  'groups.settings.post_approval.none': 'Ingen godkjenning',
  'groups.settings.post_approval.require': 'Alle innlegg må godkjennes',
  'groups.settings.posting.admins': 'Kun admin',
  'groups.settings.posting.anyone': 'Alle i rommet',
  'groups.settings.posting_permissions': 'Rettigheter for publisering',
  'groups.settings.privacy': 'Personvern',
  'groups.subscribe.benefit_1': 'Eksklusivt innhold og oppfølging',
  'groups.subscribe.benefit_2': 'Trygt fellesskap med tydelige rammer',
  'groups.subscribe.benefit_3': 'Direkte støtte fra ansvarlige og veiledere',
  'groups.subscribe.breakdown': 'Oversikt',
  'groups.subscribe.card': 'Kort',
  'groups.subscribe.cta': 'Bli med og støtt',
  'groups.subscribe.cta_supporter': 'Bli støttespiller',
  'groups.subscribe.header': 'Du trer inn som støttespiller',
  'groups.subscribe.monthly': 'Månedlig støtte',
  'groups.subscribe.support_intro': 'Ved å støtte dette rommet:',
  'groups.subscribe.support_point_1': 'sitter du ved bordet',
  'groups.subscribe.support_point_2': 'er du med og bærer fellesskapet',
  'groups.subscribe.support_point_3': 'gjør du det mulig at rommet kan fortsette å leve',
  'groups.subscribe.amount_line': 'Beløp: {price} per måned',
  'groups.subscribe.cancel_anytime': 'Kan avsluttes når som helst.',
  'create_group.paid_price_currency': 'Månedspris ({currency})',
  'create_group.support.toggle': 'Gi mulighet for støtte til dette rommet',
  'create_group.support.amount': 'Månedlig støtte',
  'create_group.support.renewal_note': 'Støtten fornyes automatisk og kan avsluttes når som helst.',
  'create_group.support.possible.label': 'Hva gjør støtten mulig i dette rommet?',
  'create_group.support.possible.placeholder': 'Hva åpner du for når noen velger å støtte rommet?',
  'create_group.support.possible.required': 'Beskriv kort hva støtten gjør mulig.',
  'create_group.support.for_whom.label': 'Hvem kan dette rommet være viktig for?',
  'create_group.support.for_whom.placeholder': 'Hvem kan dette rommet være viktig for?',
  'create_group.support.for_whom.required': 'Beskriv hvem dette rommet kan være viktig for.',
  'create_group.support.cancel.label': 'Hvordan fungerer avslutning av støtte?',
  'create_group.support.cancel.placeholder':
    'Støtten kan avsluttes når som helst. Tilgang varer ut betalt periode.',
  'create_group.support.cancel.default':
    'Støtten kan avsluttes når som helst. Tilgang varer ut betalt periode.',
  'create_group.support.connect.info': 'For å motta støtte må du koble til utbetalinger.',
  'create_group.support.summary': 'Oversikt',
  'create_group.support.summary.amount': 'Støtte',
  'create_group.support.summary.platform': 'Nettgrav-andel',
  'create_group.support.summary.fee': 'Betalingsgebyr',
  'create_group.support.summary.you_get': 'Du mottar før betalingsgebyr',
  'create_group.rate_limit': 'Du har opprettet flere rom på kort tid. Prøv igjen senere.',
  'create_group.category.load_error': 'Kunne ikke hente retninger. Prøv å laste siden på nytt.',
  'groups.subscribe.total': 'Totalt',
  'groups.subscribe.local_estimate': 'Ca. {amount} i lokal valuta.',
  'groups.subscribe.cancel.cta': 'Avslutt deltakelse',
  'groups.subscribe.cancel.success': 'Du er ikke lenger med i rommet.',
  'groups.subscribe.vipps_info': 'Du bekrefter betalingen trygt i Vipps.',
  'groups.subscribe.vipps_currency_note': 'Betaling via Vipps belastes i NOK.',
  'groups.subscribe.vipps_unavailable_currency':
    'Vipps er ikke tilgjengelig for denne valutaen. Velg kort.',
  'messenger_v2.brand.title': 'End of Time',
  'messenger_v2.brand.beta': 'Beta',
  'messenger_v2.brand.tagline': 'Et sted for sannhet. Alltid.',
  'messenger_v2.conversation.title': 'Samtaler',
  'messenger_v2.encryption.title': 'Ende-til-ende-kryptert',
  'messenger_v2.encryption.copy': 'Ordene dine forblir mellom dere.',
  'messenger_v2.encryption.learn_more': 'Les mer',
  'messenger_v2.presence.active_now': 'Aktiv nå',
  'messenger_v2.composer.truth_placeholder': 'Hva er sant akkurat nå?',
  'messenger_v2.message.reaction_failed': 'Kunne ikke oppdatere reaksjonen.',
  'messenger_v2.message.actions': 'Meldingshandlinger',
  'messenger_v2.message.react_with': 'Reager med {emoji}',
  'messenger_v2.message.reaction_count': '{emoji}, {count} reaksjoner',
  'messenger_v2.message.commands': 'Meldingskommandoer',
  'messenger_v2.message.reactions': 'Reaksjoner',
  'messenger_v2.message.reaction_all': 'Alle',
  'messenger_v2.message.reaction_details': 'Reaksjonsdetaljer',
  'messenger_v2.message.reaction_filters': 'Reaksjonsfiltre',
  'messenger_v2.message.reaction_people_unavailable':
    'Reaksjonsdetaljer er ikke tilgjengelige for denne meldingen.',
  'messenger_v2.message.click_to_remove': 'Klikk for å fjerne',
  'messenger_v2.message.history_loading': 'Laster inn tidligere meldinger.',
  'messenger_v2.attachment.select': 'Velg {name}',
  'messenger_v2.search.placeholder': 'Søk eller start en samtale',
  'messenger_v2.search.groups_placeholder': 'Søk i grupper',
  'messenger_v2.tabs.aria': 'Meldingsseksjoner',
  'messenger_v2.tabs.direct': 'Meldinger',
  'messenger_v2.tabs.groups': 'Grupper',
  'messenger_v2.groups.add_action': 'Legg til',
  'messenger_v2.groups.add_members': 'Legg til medlemmer',
  'messenger_v2.groups.add_members_short': 'Legg til',
  'messenger_v2.groups.add_members_title': 'Legg til medlemmer',
  'messenger_v2.groups.add_description': 'Legg til gruppebeskrivelse',
  'messenger_v2.groups.contacts_loading': 'Kontakter lastes inn.',
  'messenger_v2.groups.create': 'Opprett gruppe',
  'messenger_v2.groups.create_action': 'Opprett',
  'messenger_v2.groups.create_category_required': 'Gruppekategori er ikke tilgjengelig ennå.',
  'messenger_v2.groups.create_name_required': 'Gruppenavn er påkrevd.',
  'messenger_v2.groups.create_new_group': 'Opprett ny gruppe',
  'messenger_v2.groups.create_success': 'Gruppe opprettet.',
  'messenger_v2.groups.create_title': 'Opprett gruppe',
  'messenger_v2.groups.description_label': 'Beskrivelse',
  'messenger_v2.groups.description_placeholder': 'Valgfritt',
  'messenger_v2.groups.details_updated': 'Gruppeinformasjon oppdatert.',
  'messenger_v2.groups.edit_description': 'Rediger gruppebeskrivelse',
  'messenger_v2.groups.edit_group_picture': 'Rediger gruppebilde',
  'messenger_v2.groups.edit_name': 'Rediger gruppenavn',
  'messenger_v2.groups.empty': 'Ingen grupper samsvarte med søket ditt.',
  'messenger_v2.groups.error': 'Grupper kunne ikke lastes inn.',
  'messenger_v2.groups.fallback': 'Gruppe',
  'messenger_v2.groups.choose_photo': 'Velg bilde',
  'messenger_v2.groups.delete_photo': 'Slett bilde',
  'messenger_v2.groups.deleting_photo': 'Sletter bilde...',
  'messenger_v2.groups.uploading_photo': 'Laster opp...',
  'messenger_v2.groups.avatar_crop_failed': 'Bildet kunne ikke beskjæres.',
  'messenger_v2.groups.avatar_read_failed': 'Bildet kunne ikke åpnes.',
  'messenger_v2.groups.avatar_owner_only': 'Bare gruppeoppretteren kan oppdatere gruppebildet.',
  'messenger_v2.groups.avatar_updated': 'Gruppebildet er oppdatert.',
  'messenger_v2.groups.avatar_update_failed': 'Gruppebildet kunne ikke oppdateres.',
  'messenger_v2.groups.avatar_deleted': 'Gruppebildet er slettet.',
  'messenger_v2.groups.avatar_delete_failed': 'Gruppebildet kunne ikke slettes.',
  'messenger_v2.groups.loading': 'Grupper lastes inn.',
  'messenger_v2.groups.members_added': 'Medlemmer lagt til.',
  'messenger_v2.groups.members_count': '{count} medlemmer',
  'messenger_v2.groups.update_failed': 'Gruppeinformasjonen kunne ikke oppdateres.',
  'messenger_v2.groups.members_label': 'Medlemmer',
  'messenger_v2.groups.leave_group': 'Forlat',
  'messenger_v2.groups.exit_group': 'Forlat gruppe',
  'messenger_v2.groups.exit_group_title': 'Forlat gruppe: "{name}"?',
  'messenger_v2.groups.exit_group_notice':
    'Bare administratorer får beskjed når du forlater en gruppe.',
  'messenger_v2.groups.exit_and_delete_for_me': 'Forlat og slett for meg',
  'messenger_v2.groups.delete_group': 'Slett gruppe',
  'messenger_v2.groups.deleting_group': 'Sletter gruppe...',
  'messenger_v2.groups.delete_group_title': 'Slett gruppe "{name}"?',
  'messenger_v2.groups.delete_group_warning_body':
    'Denne gruppen fjernes fra chatlisten din, og den lokale historikken tømmes.',
  'messenger_v2.groups.group_deleted': 'Gruppen ble slettet fra chatlisten din.',
  'messenger_v2.groups.delete_group_failed': 'Gruppen kunne ikke slettes.',
  'messenger_v2.groups.exiting_group': 'Forlater gruppe...',
  'messenger_v2.groups.left_group': 'Du forlot gruppen.',
  'messenger_v2.groups.left_group_notice':
    'Du forlot denne gruppen. Du kan se tidligere meldinger, men du kan ikke sende nye meldinger.',
  'messenger_v2.groups.member_removed': '{name} ble fjernet fra gruppen.',
  'messenger_v2.groups.member_remove_failed': 'Medlemmet kunne ikke fjernes.',
  'messenger_v2.groups.remove_member': 'Fjern',
  'messenger_v2.groups.removed_notice':
    '{actor} fjernet deg fra denne gruppen. Du kan se tidligere meldinger, men du kan ikke sende nye meldinger.',
  'messenger_v2.groups.access_removed_notice':
    'Du er ikke lenger medlem av denne gruppen. Du kan se tidligere meldinger, men du kan ikke sende nye meldinger.',
  'messenger_v2.groups.removing_member': 'Fjerner...',
  'messenger_v2.groups.name_label': 'Navn',
  'messenger_v2.groups.name_placeholder': 'Familieoppdateringer',
  'messenger_v2.groups.no_contacts': 'Ingen kontakter tilgjengelig.',
  'messenger_v2.groups.no_contacts_to_add': 'Ingen kontakter tilgjengelig å legge til.',
  'messenger_v2.groups.no_messages': 'Ingen meldinger ennå',
  'messenger_v2.groups.save_failed': 'Gruppen kunne ikke lagres.',
  'messenger_v2.groups.saving': 'Lagrer...',
  'messenger_v2.groups.select_member_required': 'Velg minst ett medlem.',
  'messenger_v2.groups.selected_count': '{count} valgt',
  'messenger_v2.groups.selected_fraction': '{selected}/{total}',
  'messenger_v2.groups.search_name_or_number': 'Søk etter navn eller nummer',
  'messenger_v2.groups.members_can_add': 'Alle medlemmer kan legge til andre i denne gruppen.',
  'messenger_v2.groups.edit_group_permissions': 'Rediger gruppetillatelser.',
  'messenger_v2.groups.group_permissions': 'Gruppetillatelser',
  'messenger_v2.groups.invite_via_link': 'Inviter via lenke',
  'messenger_v2.groups.invite_via_link_qr': 'Inviter via lenke eller QR-kode',
  'messenger_v2.groups.frequently_contacted': 'Ofte kontaktet',
  'messenger_v2.groups.scroll_more_contacts': 'Rull for å laste flere',
  'messenger_v2.groups.remove_selected_member': 'Fjern {name}',
  'messenger_v2.groups.group_link': 'Gruppelenke',
  'messenger_v2.groups.group_chat_invite': 'Gruppechatinvitasjon',
  'messenger_v2.groups.open_invite_link': 'Åpne denne lenken for å bli med i {name}.',
  'messenger_v2.groups.join_group': 'Bli med i gruppe',
  'messenger_v2.groups.invite_link_checking': 'Kontrollerer lenken...',
  'messenger_v2.groups.invite_link_expired': 'Lenken er utløpt',
  'messenger_v2.groups.invite_link_unavailable': 'Gruppen er utilgjengelig',
  'messenger_v2.groups.invite_link_full': 'Gruppen er full',
  'messenger_v2.groups.invite_link_status_expired': 'Denne invitasjonslenken er utløpt.',
  'messenger_v2.groups.invite_link_status_unavailable':
    'Denne gruppeinvitasjonen er ikke lenger tilgjengelig.',
  'messenger_v2.groups.invite_link_status_full': 'Denne gruppen er full.',
  'messenger_v2.groups.view_group': 'Vis gruppe',
  'messenger_v2.groups.invite_link_loading': 'Laster lenke...',
  'messenger_v2.groups.invite_link_copied': 'Invitasjonslenke kopiert.',
  'messenger_v2.groups.invite_link_copy_failed': 'Kunne ikke kopiere invitasjonslenken.',
  'messenger_v2.groups.invite_link_failed': 'Kunne ikke laste invitasjonslenken.',
  'messenger_v2.groups.invite_share_text': 'Bli med i {name}',
  'messenger_v2.groups.invite_share_text_with_link': 'Bli med i {name}: {url}',
  'messenger_v2.groups.share_via_chat': 'Del via chat',
  'messenger_v2.groups.send_to': 'Send til',
  'messenger_v2.groups.send_action': 'Send',
  'messenger_v2.groups.select_chat_recipients': 'Velg chatter',
  'messenger_v2.groups.invite_link_sent': 'Invitasjonslenke sendt.',
  'messenger_v2.groups.invite_link_send_failed': 'Kunne ikke sende invitasjonslenken.',
  'messenger_v2.groups.share_link': 'Del lenke',
  'messenger_v2.groups.share_link_short': 'Del',
  'messenger_v2.groups.copy_link': 'Kopier lenke',
  'messenger_v2.groups.qr_code': 'QR-kode',
  'messenger_v2.groups.manage_permissions': 'Administrer tillatelser',
  'messenger_v2.groups.invite_approval_not_required':
    'Administratorgodkjenning er ikke nødvendig for å bli med. Medlemmer har tilgang til denne lenken her.',
  'messenger_v2.groups.permissions_members_can': 'Medlemmer kan',
  'messenger_v2.groups.permission_edit_settings': 'Redigere gruppeinnstillinger',
  'messenger_v2.groups.permission_edit_settings_desc':
    'Dette inkluderer gruppenavn, ikon, beskrivelse og avansert chat-personvern.',
  'messenger_v2.groups.permission_send_messages': 'Sende nye meldinger',
  'messenger_v2.groups.permission_add_members': 'Legge til andre medlemmer',
  'messenger_v2.groups.permission_send_history': 'Sende meldingshistorikk',
  'messenger_v2.groups.permission_send_history_desc':
    'La medlemmer sende tidligere meldinger til nye medlemmer.',
  'messenger_v2.groups.permission_invite_link': 'Invitere via lenke',
  'messenger_v2.groups.permissions_turning_off_hint':
    'Når disse innstillingene slås av, kan bare gruppeadministratorer utføre handlingen.',
  'messenger_v2.groups.permissions_admins_can': 'Administratorer kan',
  'messenger_v2.groups.permission_approve_new_members': 'Godkjenne nye medlemmer',
  'messenger_v2.groups.permission_approve_new_members_desc':
    'Når dette er slått på, må administratorer godkjenne alle som vil bli med i gruppen.',
  'messenger_v2.groups.group_admins': 'Gruppeadministratorer',
  'messenger_v2.groups.edit_admins': 'Rediger administratorer',
  'messenger_v2.groups.admin': 'Admin',
  'messenger_v2.groups.available_member': 'Tilgjengelig medlem',
  'messenger_v2.groups.make_group_admin': 'Gjør til gruppeadministrator',
  'messenger_v2.groups.dismiss_as_admin': 'Fjern som administrator',
  'messenger_v2.groups.remove_from_group': 'Fjern fra gruppe',
  'messenger_v2.groups.no_members_to_manage': 'Ingen medlemmer å administrere.',
  'messenger_v2.groups.admins_updated': 'Gruppeadministratorer oppdatert.',
  'messenger_v2.groups.admin_update_failed': 'Administratorrollen kunne ikke oppdateres.',
  'messenger_v2.groups.member_made_admin': '{name} er nå gruppeadministrator.',
  'messenger_v2.groups.member_dismissed_admin': '{name} er ikke lenger gruppeadministrator.',
  'messenger_v2.groups.permissions_updated': 'Gruppetillatelser oppdatert.',
  'messenger_v2.groups.permissions_update_failed': 'Gruppetillatelsene kunne ikke oppdateres.',
  'messenger_v2.groups.no_longer_member_status': 'Ikke lenger medlem',
  'messenger_v2.info.member_options': 'Medlemsvalg',
  'messenger_v2.common.search': 'Søk',
  'messenger_v2.conversation.group_fallback': 'Gruppesamtale',
  'messenger_v2.conversation.direct_fallback': 'Direktesamtale',
  'messenger_v2.conversation.new_message': 'Ny melding',
  'messenger_v2.conversation.no_content': 'Ingen innhold',
  'messenger_v2.conversation.connection': 'Tilkobling',
  'messenger_v2.conversation.connections': 'Tilkoblinger',
  'messenger_v2.conversation.open': 'Åpne',
  'messenger_v2.conversation.open_failed': 'Samtalen kunne ikke åpnes.',
  'messenger_v2.conversation.opening': 'Åpner...',
  'messenger_v2.conversation.contacts_loading': 'Kontakter lastes inn.',
  'messenger_v2.conversation.no_contacts_matched': 'Ingen kontakter samsvarte med søket ditt.',
  'messenger_v2.conversation.bootstrap_loading': 'Messenger starter.',
  'messenger_v2.conversation.none_yet': 'Ingen samtaler ennå. Start en fra kontaktlisten.',
  'messenger_v2.conversation.select_title': 'Velg en samtale',
  'messenger_v2.conversation.select_copy':
    'Åpne en tråd fra venstre side, eller start en ny samtale med plussknappen.',
  'messenger_v2.conversation.show_contacts': 'Vis kontakter',
  'messenger_v2.conversation.show_conversations': 'Vis samtaler',
  'messenger_v2.presence.offline': 'Frakoblet',
  'messenger_v2.presence.online': 'På nett',
  'messenger_v2.presence.ready': 'Klar',
  'messenger_v2.presence.not_ready_yet': 'Ikke klar ennå',
  'messenger_v2.presence.group_online': '{onlineCount} av {totalCount} er på nett',
  'messenger_v2.presence.last_seen_today_at': 'Sist sett i dag kl. {time}',
  'messenger_v2.presence.last_seen_yesterday_at': 'Sist sett i går kl. {time}',
  'messenger_v2.presence.last_seen_date_at': 'Sist sett {date} kl. {time}',
  'messenger_v2.timeline.today': 'I dag',
  'messenger_v2.timeline.yesterday': 'I går',
  'messenger_v2.message.edited': 'Redigert',
  'messenger_v2.message.edited_time': 'Redigert {time}',
  'messenger_v2.message.read_more': 'Les mer',
  'messenger_v2.message.show_less': 'Vis mindre',
  'messenger_v2.message.upload_failed': 'Opplasting mislyktes',
  'messenger_v2.message.preparing_upload': 'Forbereder…',
  'messenger_v2.message.upload_progress': 'Laster opp {progress} %',
  'messenger_v2.message.upload_paused_progress': 'Opplasting satt på pause ved {progress} %',
  'messenger_v2.message.retry_upload': 'Prøv opplasting på nytt',
  'messenger_v2.message.retry_send': 'Prøv å sende meldingen på nytt',
  'messenger_v2.message.retry_reaction': 'Prøv å sende reaksjonen på nytt',
  'messenger_v2.message.retry_failed': 'Meldingen kunne ikke sendes. Prøv igjen.',
  'messenger_v2.message.reaction_retry_failed': 'Reaksjonen kunne ikke sendes. Prøv igjen.',
  'messenger_v2.message.pause_upload': 'Sett opplastingen på pause',
  'messenger_v2.message.pause': 'Pause',
  'messenger_v2.message.resume_upload': 'Fortsett opplastingen',
  'messenger_v2.message.resume': 'Fortsett',
  'messenger_v2.attachment.upload_paused': 'Opplasting satt på pause: {name}',
  'messenger_v2.message.failed': 'Mislyktes',
  'messenger_v2.message.read': 'Lest',
  'messenger_v2.message.delivered': 'Levert',
  'messenger_v2.message.sent': 'Sendt',
  'messenger_v2.message.delete': 'Slett melding',
  'messenger_v2.message.delete_title': 'Slette melding?',
  'messenger_v2.message.delete_from': 'Slette melding fra {name}?',
  'messenger_v2.message.delete_everyone': 'Slett for alle',
  'messenger_v2.message.delete_me': 'Slett for meg',
  'messenger_v2.message.copy': 'Kopier melding',
  'messenger_v2.attachment.copy': 'Kopier vedlegg',
  'messenger_v2.clipboard.copied': 'Kopiert',
  'messenger_v2.clipboard.retry': 'Prøv igjen',
  'messenger_v2.message.edit': 'Rediger melding',
  'messenger_v2.message.clear_selection': 'Fjern markering',
  'messenger_v2.message.open_menu': 'Åpne meldingsmeny',
  'messenger_v2.message.scroll_latest': 'Rull til nyeste melding',
  'messenger_v2.message.thread_loading': 'Trådhistorikk lastes inn.',
  'messenger_v2.conversation.unavailable_title': 'Samtalen er utilgjengelig',
  'messenger_v2.conversation.unavailable_copy': 'Du har ikke lenger tilgang til denne samtalen.',
  'messenger_v2.message.thread_empty': 'Ingen meldinger er lastet inn i denne tråden ennå.',
  'messenger_v2.message.thread': 'Samtaletråd',
  'messenger_v2.message.timeline': 'Meldinger i samtalen',
  'messenger_v2.message.encrypted_pending': 'Kryptert MLS-melding venter på at runtime er klar.',
  'messenger_v2.message.edit_resolve_error':
    'Kunne ikke finne meldingen som redigeres. Åpne redigeringsmodus på nytt og prøv igjen.',
  'messenger_v2.message.reply': 'Svar',
  'messenger_v2.message.forward': 'Videresend',
  'messenger_v2.message.forwarded': 'Videresendt',
  'messenger_v2.forward.title': 'Videresend til',
  'messenger_v2.forward.preview_label': 'Videresender',
  'messenger_v2.forward.message_preview': 'Melding',
  'messenger_v2.forward.search': 'Søk i samtaler og kontakter',
  'messenger_v2.forward.add_message': 'Legg til en melding',
  'messenger_v2.forward.add_message_placeholder': 'Legg til en melding...',
  'messenger_v2.forward.selected': 'Valgt',
  'messenger_v2.forward.not_selected': 'Ikke valgt',
  'messenger_v2.forward.loading': 'Laster samtaler og kontakter...',
  'messenger_v2.forward.chats': 'Samtaler',
  'messenger_v2.forward.connections': 'Kontakter',
  'messenger_v2.forward.no_targets': 'Ingen samtaler eller kontakter funnet.',
  'messenger_v2.forward.loading_message': 'Laster melding...',
  'messenger_v2.forward.message_unavailable': 'Denne meldingen er ikke tilgjengelig.',
  'messenger_v2.forward.send_failed': 'Meldingen kunne ikke videresendes.',
  'messenger_v2.forward.unavailable': 'Denne meldingen kan ikke videresendes ennå.',
  'messenger_v2.forward.sending_progress': 'Sender {completed} av {total}',
  'messenger_v2.forward.failed_count': '{count} mislyktes',
  'messenger_v2.forward.selected_count': '{count} valgt',
  'messenger_v2.forward.retry_failed': 'Prøv mislykkede på nytt',
  'messenger_v2.forward.sent_count': 'Videresendt til {count} samtaler.',
  'messenger_v2.message.react': 'Reager',
  'messenger_v2.message.cancel_reply': 'Avbryt svar',
  'messenger_v2.message.open_replied_message': 'Åpne besvart melding',
  'messenger_v2.reply.photo': 'Bilde',
  'messenger_v2.reply.photos_count': '{count} bilder',
  'messenger_v2.reply.video': 'Video',
  'messenger_v2.reply.videos_count': '{count} videoer',
  'messenger_v2.reply.audio': 'Lyd',
  'messenger_v2.reply.media_count': '{count} medier',
  'messenger_v2.reply.pages_count': '{count} sider',
  'messenger_v2.common.cancel': 'Avbryt',
  'messenger_v2.common.back': 'Tilbake',
  'messenger_v2.common.close': 'Lukk',
  'messenger_v2.common.done': 'Ferdig',
  'messenger_v2.common.save': 'Lagre',
  'messenger_v2.common.someone': 'Noen',
  'messenger_v2.common.you': 'Du',
  'messenger_v2.common.messenger': 'Messenger',
  'messenger_v2.chat.back': 'Tilbake til samtaler',
  'messenger_v2.chat.more': 'Mer',
  'messenger_v2.chat.more_actions': 'Flere handlinger',
  'messenger_v2.notifications.enabled': 'Skrivebordsvarsler aktivert',
  'messenger_v2.notifications.enabled_message': 'Skrivebordsvarsler er aktivert.',
  'messenger_v2.notifications.reaction_body': 'Reagerte med {emoji} på meldingen din.',
  'messenger_v2.conversation.reaction_preview': 'Reagerte {emoji} på «{message}»',
  'messenger_v2.conversation.reaction_preview_unknown': 'Reagerte {emoji} på en melding',
  'messenger_v2.notifications.reaction_body_with_preview':
    'Reagerte med {emoji} på meldingen din: “{message}”',
  'messenger_v2.notifications.blocked': 'Skrivebordsvarsler blokkert',
  'messenger_v2.notifications.blocked_message':
    'Skrivebordsvarsler er blokkert i nettleserinnstillingene.',
  'messenger_v2.notifications.unsupported': 'Skrivebordsvarsler støttes ikke i denne nettleseren.',
  'messenger_v2.notifications.enable': 'Aktiver skrivebordsvarsler',
  'messenger_v2.typing.preview': 'Skriver...',
  'messenger_v2.typing.preview_named': '{name} skriver...',
  'messenger_v2.typing.aria': '{name} skriver',
  'messenger_v2.info.open': 'Åpne samtaleinfo',
  'messenger_v2.info.title': 'Samtaleinfo',
  'messenger_v2.info.close': 'Lukk samtaleinfo',
  'messenger_v2.info.contact': 'Kontakt',
  'messenger_v2.info.creator': 'Oppretter',
  'messenger_v2.info.direct_chat': 'Direktechat',
  'messenger_v2.info.message_action': 'Melding',
  'messenger_v2.info.block': 'Blokker',
  'messenger_v2.info.block_failed': 'Brukeren kunne ikke blokkeres.',
  'messenger_v2.info.block_user': 'Blokker {name}',
  'messenger_v2.info.block_user_confirm':
    'Denne brukeren vil ikke se avataren eller statusen din, og nye meldinger eller anrop fra dem når ikke frem til deg.',
  'messenger_v2.info.block_user_title': 'Blokkere "{name}"?',
  'messenger_v2.info.blocking_user': 'Blokkerer...',
  'messenger_v2.info.chat_cleared': 'Chatten er tømt.',
  'messenger_v2.info.clear_all_messages': 'Tøm alle meldinger',
  'messenger_v2.info.clear_chat': 'Tøm chat',
  'messenger_v2.info.clear_chat_confirm': 'Gamle meldinger fjernes bare for deg.',
  'messenger_v2.info.clear_chat_failed': 'Chatten kunne ikke tømmes.',
  'messenger_v2.info.clear_chat_title': 'Tømme chat?',
  'messenger_v2.info.clear_chat_warning_body':
    'Denne chatten blir tom, men blir værende i chatlisten din.',
  'messenger_v2.info.clear_chat_warning_title': 'Tøm alle meldinger fra "{name}"?',
  'messenger_v2.info.chat_deleted': 'Chatten er slettet.',
  'messenger_v2.info.delete_chat': 'Slett chat',
  'messenger_v2.info.delete_chat_failed': 'Chatten kunne ikke slettes.',
  'messenger_v2.info.delete_chat_warning_body':
    'Denne chatten fjernes fra chatlisten din. Hvis du starter chatten igjen, vises ikke gamle meldinger.',
  'messenger_v2.info.delete_chat_warning_title': 'Slett chat med "{name}"?',
  'messenger_v2.info.clearing_chat': 'Tømmer chat...',
  'messenger_v2.info.info': 'Info',
  'messenger_v2.info.media': 'Media',
  'messenger_v2.info.links': 'Lenker',
  'messenger_v2.info.docs': 'Dokumenter',
  'messenger_v2.info.media_links_docs': 'Media, lenker og dokumenter',
  'messenger_v2.info.starred': 'Stjernemerket',
  'messenger_v2.info.encryption': 'Kryptering',
  'messenger_v2.info.members': 'Medlemmer',
  'messenger_v2.info.groups_in_common': 'Felles grupper',
  'messenger_v2.info.no_media': 'Ingen medier er delt i denne samtalen ennå.',
  'messenger_v2.info.no_links': 'Ingen lenker er delt i denne samtalen ennå.',
  'messenger_v2.info.no_docs': 'Ingen dokumenter er delt i denne samtalen ennå.',
  'messenger_v2.info.no_common_groups': 'Ingen felles grupper ennå.',
  'messenger_v2.info.unblock': 'Opphev blokkering',
  'messenger_v2.info.unblock_failed': 'Blokkeringen kunne ikke oppheves.',
  'messenger_v2.info.unblock_user': 'Opphev blokkering av {name}',
  'messenger_v2.info.unblock_user_confirm': 'Denne brukeren kan kontakte deg igjen.',
  'messenger_v2.info.unblock_user_title': 'Oppheve blokkering av "{name}"?',
  'messenger_v2.info.unblocking_user': 'Opphever blokkering...',
  'messenger_v2.info.user_blocked': '{name} er blokkert.',
  'messenger_v2.info.user_unblocked': '{name} er ikke lenger blokkert.',
  'messenger_v2.info.no_members': 'Ingen medlemmer å vise ennå.',
  'messenger_v2.info.pending_invitations': 'Invitert - venter på svar',
  'messenger_v2.info.invitation_pending': 'Invitasjonen venter på svar',
  'messenger_v2.info.document_fallback': 'Dokument',
  'messenger_v2.info.encryption_detail': 'Meldinger er beskyttet i denne samtalen.',
  'messenger_v2.info.starred_empty': 'Ingen stjernemerkede meldinger ennå.',
  'messenger_v2.info.member': 'Medlem',
  'messenger_v2.info.you_label': '{name} (Du)',
  'messenger_v2.info.last_week': 'Forrige uke',
  'messenger_v2.info.this_month': 'Denne måneden',
  'messenger_v2.info.date_unknown': 'Tidligere',
  'messenger_v2.composer.add_note': 'Legg til et notat',
  'messenger_v2.composer.add_more_attachments': 'Legg til flere vedlegg',
  'messenger_v2.composer.open_attachments': 'Åpne vedlegg',
  'messenger_v2.composer.send': 'Send',
  'messenger_v2.composer.sending': 'Sender',
  'messenger_v2.composer.draft': 'Utkast',
  'messenger_v2.voice.record': 'Ta opp talemelding',
  'messenger_v2.voice.recording': 'Tar opp talemelding',
  'messenger_v2.voice.recording_preview': 'Tar opp talemelding...',
  'messenger_v2.voice.paused': 'Taleopptaket er satt på pause',
  'messenger_v2.voice.ready': 'Talemeldingen er klar',
  'messenger_v2.voice.sending': 'Sender talemelding',
  'messenger_v2.voice.pause': 'Sett opptaket på pause',
  'messenger_v2.voice.pause_short': 'Pause',
  'messenger_v2.voice.resume': 'Fortsett opptaket',
  'messenger_v2.voice.resume_short': 'Fortsett',
  'messenger_v2.voice.cancel': 'Slett taleopptaket',
  'messenger_v2.voice.send': 'Send talemelding',
  'messenger_v2.voice.unsupported': 'Nettleseren støtter ikke taleopptak.',
  'messenger_v2.voice.permission_denied':
    'Mikrofontilgang ble avvist. Tillat mikrofonen og prøv igjen.',
  'messenger_v2.voice.microphone_unavailable': 'Ingen tilgjengelig mikrofon ble funnet.',
  'messenger_v2.voice.too_short': 'Talemeldingen er for kort. Ta opp på nytt.',
  'messenger_v2.voice.send_failed':
    'Talemeldingen kunne ikke legges i kø. Trykk på send for å prøve igjen.',
  'messenger_v2.voice.recording_failed': 'Talemeldingen kunne ikke tas opp.',
  'messenger_v2.voice.retry_playback': 'Prøv talemeldingen igjen',
  'messenger_v2.voice.pause_playback': 'Sett talemeldingen på pause',
  'messenger_v2.voice.play': 'Spill av talemelding',
  'messenger_v2.voice.seek': 'Spol i talemeldingen',
  'messenger_v2.voice.uploading': 'Laster opp {progress} %',
  'messenger_v2.voice.speed': 'Avspillingshastighet {rate}x',
  'messenger_v2.composer.send_attachments': 'Send vedlegg',
  'messenger_v2.composer.sending_attachments': 'Sender vedlegg',
  'messenger_v2.composer.file': 'Fil',
  'messenger_v2.composer.image_or_video': 'Bilde eller video',
  'messenger_v2.composer.document': 'Dokument',
  'messenger_v2.composer.preview_unavailable':
    'Forhåndsvisning er ikke tilgjengelig. Du kan fortsatt sende den rene lenken.',
  'messenger_v2.link_preview.error': 'Lenkeforhåndsvisning er ikke tilgjengelig.',
  'messenger_v2.link_preview.remove': 'Fjern lenkeforhåndsvisning',
  'messenger_v2.attachment.image': 'Bilde',
  'messenger_v2.attachment.video': 'Video',
  'messenger_v2.attachment.audio': 'Lyd',
  'messenger_v2.attachment.document': 'Dokument',
  'messenger_v2.attachment.file': 'Fil',
  'messenger_v2.attachment.file_upper': 'FIL',
  'messenger_v2.attachment.attachment': 'Vedlegg',
  'messenger_v2.attachment.fallback_name': 'Vedlegg {index}',
  'messenger_v2.attachment.attachments_selected': '{count} vedlegg valgt',
  'messenger_v2.attachment.add_attachments': 'Legg til vedlegg',
  'messenger_v2.attachment.edit_image': 'Rediger bilde',
  'messenger_v2.attachment.prepare_failed':
    'Det redigerte vedlegget kunne ikke klargjøres. Endringene dine er fortsatt her – prøv igjen.',
  'messenger_v2.attachment.edit_render_failed':
    'Det redigerte bildet kunne ikke gjengis. Endringene dine er fortsatt her – prøv igjen.',
  'messenger_v2.attachment.encryption_failed':
    'Vedlegget kunne ikke krypteres på denne enheten. Prøv igjen.',
  'messenger_v2.attachment.storage_warning':
    'Enhetslagringen er full. Hold appen åpen mens vedleggene lastes opp.',
  'messenger_v2.attachment.upload_failed':
    'Den sikre opplastingen ble avbrutt. Kontroller tilkoblingen og prøv igjen.',
  'messenger_v2.attachment.send_failed':
    'Vedleggene kunne ikke legges i kø. Endringene dine er fortsatt her – prøv igjen.',
  'messenger_v2.attachment.preparing_progress': 'Forbereder vedlegg ({completed}/{total})',
  'messenger_v2.image_editor.close': 'Tilbake',
  'messenger_v2.image_editor.crop': 'Beskjær',
  'messenger_v2.image_editor.done': 'Ferdig',
  'messenger_v2.image_editor.draw': 'Tegn',
  'messenger_v2.image_editor.emoji': 'Emoji',
  'messenger_v2.image_editor.redo': 'Gjør om',
  'messenger_v2.image_editor.text': 'Tekst',
  'messenger_v2.image_editor.title': 'Rediger bilde',
  'messenger_v2.image_editor.undo': 'Angre',
  'messenger_v2.attachment.drop_files_here': 'Slipp filene her',
  'messenger_v2.attachment.drop_files_hint': 'De legges til i vedleggsutkastet ditt.',
  'messenger_v2.attachment.no_attachments_selected_title': 'Ingen vedlegg valgt ennå',
  'messenger_v2.attachment.no_attachments_selected_text':
    'Velg filer fra vedleggsmenyen for å starte utkastet.',
  'messenger_v2.attachment.no_files_selected_title': 'Ingen filer valgt ennå',
  'messenger_v2.attachment.no_files_selected_text':
    'Velg bilder, videoer, dokumenter eller en fil for å bygge meldingsutkastet.',
  'messenger_v2.attachment.preview_unavailable': 'Forhåndsvisning er ikke tilgjengelig',
  'messenger_v2.attachment.unable_open': 'Kunne ikke åpne dette vedlegget. Prøv igjen.',
  'messenger_v2.attachment.unable_download': 'Kunne ikke laste ned dette vedlegget. Prøv igjen.',
  'messenger_v2.attachment.no_selected': 'Ingen vedlegg valgt',
  'messenger_v2.attachment.play_video_preview': 'Spill av videoforhåndsvisning',
  'messenger_v2.attachment.close_composer': 'Lukk vedleggskomponist',
  'messenger_v2.attachment.close_preview': 'Lukk forhåndsvisning av vedlegg',
  'messenger_v2.attachment.previous': 'Forrige vedlegg',
  'messenger_v2.attachment.next': 'Neste vedlegg',
  'messenger_v2.attachment.previous_selected': 'Vis forrige valgte vedlegg',
  'messenger_v2.attachment.next_selected': 'Vis neste valgte vedlegg',
  'messenger_v2.attachment.scroll_left': 'Rull vedlegg til venstre',
  'messenger_v2.attachment.scroll_right': 'Rull vedlegg til høyre',
  'messenger_v2.attachment.scroll_selected_left': 'Rull valgte vedlegg til venstre',
  'messenger_v2.attachment.scroll_selected_right': 'Rull valgte vedlegg til høyre',
  'messenger_v2.attachment.remove': 'Fjern {name}',
  'messenger_v2.attachment.open': 'Åpne {name}',
  'messenger_v2.attachment.view': 'Vis {name}',
  'messenger_v2.attachment.download': 'Last ned {name}',
  'messenger_v2.attachment.download_action': 'Last ned',
  'messenger_v2.attachment.zoom_in': 'Zoom inn på bildet',
  'messenger_v2.attachment.reset_zoom': 'Tilbakestill bildezoom',
  'messenger_v2.attachment.uploading': 'Laster opp {name}',
  'messenger_v2.call.audio': 'Lyd',
  'messenger_v2.call.remote_audio': 'Lyd fra samtalen',
  'messenger_v2.call.video': 'Video',
  'messenger_v2.call.start_voice': 'Start taleanrop',
  'messenger_v2.call.start_video': 'Start videoanrop',
  'messenger_v2.call.direct_only': 'Anrop er tilgjengelige i direkte krypterte chatter.',
  'messenger_v2.call.group_needs_members':
    'Legg til et annet medlem for å starte en gruppesamtale.',
  'messenger_v2.call.unavailable': 'Anrop er ikke tilgjengelige for denne chatten.',
  'messenger_v2.call.blocked_unavailable': 'Anrop er ikke tilgjengelige for denne chatten.',
  'messenger_v2.call.start_failed': 'Kunne ikke starte taleanrop.',
  'messenger_v2.call.start_video_failed': 'Kunne ikke starte videoanrop.',
  'messenger_v2.call.recipient_device_unavailable':
    'Mottakeren må åpne Nettgrav Chat på enheten sin før du kan ringe kryptert.',
  'messenger_v2.call.accept_failed': 'Kunne ikke svare på taleanrop.',
  'messenger_v2.call.incoming': 'Innkommende taleanrop',
  'messenger_v2.call.incoming_video': 'Innkommende videoanrop',
  'messenger_v2.call.calling': 'Ringer...',
  'messenger_v2.call.ringing': 'Ringer...',
  'messenger_v2.call.connecting': 'Kobler til...',
  'messenger_v2.call.reconnecting': 'Kobler til på nytt...',
  'messenger_v2.call.active': 'Taleanrop',
  'messenger_v2.call.active_video': 'Videoanrop',
  'messenger_v2.call.accept': 'Svar på anrop',
  'messenger_v2.call.decline': 'Avvis anrop',
  'messenger_v2.call.open': 'Åpne',
  'messenger_v2.call.join': 'Bli med',
  'messenger_v2.call.ignore': 'Ignorer',
  'messenger_v2.call.minimize': 'Minimer anrop',
  'messenger_v2.call.encrypted': 'Ende-til-ende-kryptert',
  'messenger_v2.call.open_chat': 'Åpne chat',
  'messenger_v2.call.change_audio_output': 'Bytt lydutgang',
  'messenger_v2.call.mute': 'Demp',
  'messenger_v2.call.unmute': 'Slå på lyd',
  'messenger_v2.call.camera_on': 'Slå kamera på',
  'messenger_v2.call.camera_off': 'Slå kamera av',
  'messenger_v2.call.background_blur_on': 'Gjør bakgrunnen uskarp',
  'messenger_v2.call.background_blur_off': 'Slå av uskarp bakgrunn',
  'messenger_v2.call.background_blur_failed': 'Kunne ikke endre bakgrunnsuskarphet.',
  'messenger_v2.call.enter_fullscreen': 'Vis fullskjerm',
  'messenger_v2.call.exit_fullscreen': 'Avslutt fullskjerm',
  'messenger_v2.call.end': 'Avslutt anrop',
  'messenger_v2.call.participant': 'Deltaker',
  'messenger_v2.call.you_label': '{name} (du)',
  'messenger_v2.call.pin_participant': 'Fest {name}',
  'messenger_v2.call.unpin_participant': 'Løsne {name}',
  'messenger_v2.call.screen_sharing': 'Skjermdeling',
  'messenger_v2.call.peer_muted': '{name} dempet dette anropet',
  'messenger_v2.call.you_muted': 'Du dempet dette anropet',
  'messenger_v2.call.history_call': 'Taleanrop',
  'messenger_v2.call.history_video_call': 'Videoanrop',
  'messenger_v2.call.history_group_call': 'Gruppesamtale',
  'messenger_v2.call.history_group_video_call': 'Gruppevideoanrop',
  'messenger_v2.call.history_participants': '{count} medlemmer',
  'messenger_v2.call.members_title': 'Samtalemedlemmer',
  'messenger_v2.call.history_missed': 'Tapt taleanrop',
  'messenger_v2.call.history_video_missed': 'Tapt videoanrop',
  'messenger_v2.call.history_declined': 'Taleanrop avvist',
  'messenger_v2.call.history_video_declined': 'Videoanrop avvist',
  'messenger_v2.call.history_cancelled': 'Taleanrop kansellert',
  'messenger_v2.call.history_video_cancelled': 'Videoanrop kansellert',
  'messenger_v2.call.history_failed': 'Taleanrop mislyktes',
  'messenger_v2.call.history_video_failed': 'Videoanrop mislyktes',
  'messenger_v2.call.duration_seconds': '{seconds} sek',
  'messenger_v2.call.duration_minutes': '{minutes} min',
  'messenger_v2.call.duration_minutes_seconds': '{minutes} min {seconds} sek',
  'messenger_v2.call.duration_hours': '{hours} t',
  'messenger_v2.call.duration_hours_minutes': '{hours} t {minutes} min',
  'messenger_v2.discard.title': 'Forkast endringer?',
  'messenger_v2.discard.content': 'Er du sikker på at du vil forkaste endringene dine?',
  'messenger_v2.discard.confirm': 'Forkast',
  'messenger_v2.discard.cancel': 'Fortsett å redigere',
  'emojiPicker.emojiPicker': 'Emoji-velger',
  'emojiPicker.reactionPicker': 'Reaksjonsvelger',
  'emojiPicker.searchEmoji': 'Søk etter emoji',
  'emojiPicker.searchReactions': 'Søk etter reaksjoner',
  'emojiPicker.findEmoji': 'Finn den perfekte emojien',
  'emojiPicker.findReaction': 'Finn den perfekte reaksjonen',
  'emojiPicker.categories': 'Emoji-kategorier',
  'emojiPicker.category.frequent': 'Ofte brukt',
  'emojiPicker.category.smileys': 'Smilefjes og følelser',
  'emojiPicker.category.people': 'Mennesker og kropp',
  'emojiPicker.category.animals': 'Dyr og natur',
  'emojiPicker.category.food': 'Mat og drikke',
  'emojiPicker.category.travel': 'Reiser og steder',
  'emojiPicker.category.activities': 'Aktiviteter',
  'emojiPicker.category.objects': 'Gjenstander',
  'emojiPicker.category.symbols': 'Symboler',
  'emojiPicker.category.flags': 'Flagg',
  'emojiPicker.searchResults': 'Søkeresultater',
  'emojiPicker.noResults': 'Ingen emojier samsvarer med søket ditt.',
  'emojiPicker.noFrequentlyUsed': 'Emojiene du bruker ofte, vises her.',
  'emojiPicker.skinTone': 'Hudtone',
  'emojiPicker.skinTone.default': 'Standard hudtone',
  'emojiPicker.skinTone.light': 'Lys hudtone',
  'emojiPicker.skinTone.mediumLight': 'Middels lys hudtone',
  'emojiPicker.skinTone.medium': 'Middels hudtone',
  'emojiPicker.skinTone.mediumDark': 'Middels mørk hudtone',
  'emojiPicker.skinTone.dark': 'Mørk hudtone',
  'messenger_v2.composer.choose_emoji': 'Velg emoji',
  'messenger_v2.message.add_reaction': 'Legg til reaksjon',
  'pwa.onboarding.install_title': 'Installer Nettgrav',
  'pwa.onboarding.install_body':
    'Ha Nettgrav bare ett trykk unna og få en mer pålitelig appopplevelse på denne enheten.',
  'pwa.onboarding.install_action': 'Installer Nettgrav',
  'pwa.onboarding.install_manual_action': 'Jeg forstår',
  'pwa.onboarding.not_now': 'Ikke nå',
  'pwa.onboarding.benefit_messages': 'Meldingsvarsler i bakgrunnen',
  'pwa.onboarding.benefit_calls': 'Varsler om innkommende anrop',
  'pwa.onboarding.benefit_badge': 'Antall uleste på appikonet',
  'pwa.onboarding.ios_steps':
    'Trykk på Del i nettleseren, velg Legg til på Hjem-skjermen, og åpne deretter Nettgrav fra det nye ikonet.',
  'pwa.onboarding.mac_steps':
    'I Safari velger du Arkiv → Legg til i Dock, og åpner deretter Nettgrav fra Dock eller Programmer.',
  'pwa.onboarding.notifications_title': 'Gå aldri glipp av en melding eller samtale',
  'pwa.onboarding.notifications_body':
    'Tillat at Nettgrav varsler deg om nye krypterte meldinger og innkommende anrop, selv når appen er lukket.',
  'pwa.onboarding.notifications_action': 'Tillat varsler',
  'pwa.onboarding.notifications_denied':
    'Varsler er blokkert. Aktiver dem for Nettgrav i nettleserens eller enhetens varselinnstillinger, og prøv igjen.',
  'rooms.invite.auth_required': 'Logg inn eller opprett en konto for å se rominvitasjonen.',
  'rooms.invite.back': 'Tilbake til rom',
  'rooms.invite.fail': 'Invitasjonen er ugyldig eller utløpt.',
  'rooms.invite.join': 'Bli med i rommet',
  'rooms.invite.label': 'Rominvitasjon',
  'rooms.invite.loading': 'Laster invitasjon...',
  'rooms.invite.member_count': '{count, plural, one {# medlem} other {# medlemmer}}',
  'rooms.invite.title': 'Rominvitasjon',
  'rooms.invite.view': 'Vis rom',
  'rooms.navigation.label': 'Romseksjoner',
  'rooms.state.archived': 'Dette rommet er arkivert.',
  'rooms.state.error': 'Rommet kunne ikke lastes.',
  'rooms.state.loading': 'Laster rommet…',
  'rooms.state.removed': 'Dette rommet er fjernet.',
  'rooms.state.retry': 'Prøv igjen',
  'rooms.tabs.members_chat': 'Medlemschat',
  'rooms.members_chat.title': 'Kryptert medlemschat',
  'rooms.members_chat.description':
    'En privat, ende-til-ende-kryptert samtale for aktive rommedlemmer.',
  'rooms.members_chat.loading': 'Klargjør romchatten…',
  'rooms.members_chat.locked_title': 'Samtale kun for medlemmer',
  'rooms.members_chat.locked':
    'Bli med i rommet for å åpne den krypterte medlemschatten. Meldinger og forhåndsvisninger er skjult til medlemskapet ditt er aktivt.',
  'rooms.members_chat.error': 'Medlemschatten kunne ikke lastes.',
  'rooms.state.unavailable': 'Rommet finnes ikke, eller du har ikke tilgang.',
  'rooms.provisioning.action_required': 'Romchatten trenger oppfølging før den kan brukes.',
  'rooms.provisioning.pending': 'Romchatten klargjøres.',
  'groups.reactions.error': 'Kunne ikke oppdatere reaksjonen din.',
  'groups.media.uploading': 'Laster opp medier…',
  'groups.post.published': 'Publisert.',
  retry: 'Prøv igjen',
};

export default NOR;
